import React, { useState, useEffect, useRef, useId, useMemo } from "react";
import { useLocation, Link, useNavigate, useSearchParams } from "react-router-dom";
import VerifySuccess from "../../../Assets/img/Email-Verified.png";
// import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactPlayer from "react-player";
import axios from "axios";
import { MuiTelInput } from "mui-tel-input";
import CryptoJS from "crypto-js";
import { v4 as uuidv4 } from "uuid";
import { matchIsValidTel } from "mui-tel-input";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import { ReactComponent as StudentIcon } from '../../../Assets/img/icons/Student.svg';
import { ReactComponent as StudentIcon } from '../../../Assets/img/icons/Student.svg';
import { ReactComponent as ProfessionalIcon } from '../../../Assets/img/icons/Professional-icon.svg';
import {
  Autocomplete,
  Avatar,
  Badge,
  Box,
  Button,
  Chip,
  Grid,
  TextField,
  MenuItem,
  Menu,
  Modal,
  Checkbox,
  Collapse,
  List,
  ListItemButton,
  ListItemText,
  FormControl,
  IconButton,
  Divider,
  Tab,
  Tabs,
  Typography,
  Select,
  InputLabel,
  InputAdornment,
  FormGroup,
  FormControlLabel,
  Switch,
  FormHelperText,
  useMediaQuery,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  CircularProgress,
  ListItem,
  Paper,
} from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { motion } from "framer-motion";
import ClearIcon from "@mui/icons-material/Clear";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import CancelIcon from "@mui/icons-material/Cancel";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
// import EditRoundedIcon from '@mui/icons-material/EditRounded';
// import MoreHoriz from "@material-ui/icons/MoreHoriz";
// import PlaylistAdd from "@material-ui/icons/PlaylistAdd";
// import School from "@material-ui/icons/School";
import GroupsIcon from "@mui/icons-material/Groups";
import InfoIcon from "@mui/icons-material/Info";
// import ContactMailIcon from '@mui/icons-material/ContactMail';
// import FileOpen from '@mui/icons-material/FileOpen';
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PublicIcon from "@mui/icons-material/Public";
import DeleteIcon from "@mui/icons-material/Delete";

import { FaFileImage, FaFileAlt, FaPlay } from "react-icons/fa";
// import { FaFilePdf, FaFileWord } from 'react-icons/fa';
import { IoLinkSharp } from "react-icons/io5";
// import { IoMdShare } from "react-icons/io";

import bg_image from "../../../Assets/img/Personal_bg_image.png";
// import defaultprofile from '../../../Assets/img/Default-Profile.jpg';
import NotAvailable from "../../../Assets/img/img not available.png";
import DefaultUniversity from "../../../Assets/img/default-university-logo.jpg";
// import Aigenerate from "../../../Assets/img/icons/Ai Generate-icon.svg";
import { ReactComponent as ShareIcon } from "../../../Assets/img/icons/share-icon-figma.svg";
import { ReactComponent as InviteIcon } from "../../../Assets/img/icons/invite-figma.svg";
import { ReactComponent as EditIcon } from "../../../Assets/img/icons/edit-icon-figma.svg";
import { ReactComponent as VerifyIcon } from "../../../Assets/img/Profile/Verified-Icon.svg";
import { ReactComponent as OpenToIcon } from "../../../Assets/img/icons/open-to-figma.svg";
import { ReactComponent as AddSectionIcon } from "../../../Assets/img/icons/add-section-figma.svg";
import { ReactComponent as OverFlowMenu } from "../../../Assets/img/icons/circle-overflow-figma.svg";
import { ReactComponent as VerifiedTick } from "../../../Assets/img/icons/verified-tick.svg";
import { ReactComponent as ViewOptionsIcon } from "../../../Assets/img/icons/view-options-figma.svg";
// import { ReactComponent as PDFicon } from "../../../Assets/img/icons/PDF.svg";
// import { ReactComponent as TickIcon } from "../../../Assets/img/icons/tick-shape.svg";
import { ReactComponent as PdfThumb } from "../../../Assets/img/icons/pdf-thumbnail.svg";
import { ReactComponent as DocxThumb } from "../../../Assets/img/icons/docx-thumbnail.svg";
import { ReactComponent as PptxThumb } from "../../../Assets/img/icons/pptx-thumbnail.svg";
import { ReactComponent as ExcelThumb } from "../../../Assets/img/icons/excel-thumbnail.svg";
// import { ReactComponent as VideoThumb } from '../../../Assets/img/icons/video-thumbnail.svg'
// import { ReactComponent as TxtThumb } from '../../../Assets/img/icons/txt-thumbnail.svg'
import { ReactComponent as AiLogo } from "../../../Assets/img/icons/ai-rewrite-logo.svg";
import ft_job from "../../../Assets/img/Profile/ft_job.svg";
import pt_job from "../../../Assets/img/Profile/pt_job.svg";
import intern from "../../../Assets/img/Profile/intern.svg";
import freelance from "../../../Assets/img/Profile/Freelance.svg";
import hiring from "../../../Assets/img/Profile/hiring.svg";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import AiGenerate from "../../../Assets/img/Profile/AiGenerate.svg";

import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";

import { useUserDetailContext } from "../../UserDetailContext";
import { useProfileContext } from "../../ProfileDetailContext";
import { useQuantityContext } from "../../QuantityContext";
import FileDragUploadWithContext from "../../Utilities/FileDragUploadWithContext";
// import FileDragUpload from '../../Utilities/FileUploadAttachDocs';
// import UploadedFile from './uploadFile';
import useApi from "../../Utilities/useAPI";
import QrCodeProfile from "./QrCodeProfile";
import PreviewFileItem from "../../Utilities/PreviewFileItem";
import {
  profSoftSkills,
  professionSkills,
  professionalTools,
} from "../../Utilities/HobbiesContext";
import {
  sortListByDate,
  validateDateRange,
  formatDate,
} from "../../Utilities/ValidationFunctions";
import { PhoneInputMenuProps } from "../../Onboarding/ActiveStep4";

import AddSection from "./ProfessionalProfileComponents/AddSection";
import AddProject from "./ProfessionalProfileComponents/AddProject";
import AddAwards from "./ProfessionalProfileComponents/AddAwards";
import {
  AWARDS_HONOUS,
  CERTIFICATE,
  degreeOptionsByEduLevel,
  EDUCATION,
  ERRORS,
  EXPERIENCE,
  fieldOfStudyOptions,
  MAX_DESC_LENGTH,
  PROFESSIONAL_SKILLS,
  PROJECTS,
  SERVICES,
  SOFT_SKILLS,
  TOOLS,
} from "../../../config/constant";
import ResumeGenerate from "./ProfessionalProfileComponents/ResumeGenerate";
import {
  ViewConnections,
  ShareProfile,
  InviteProfile,
} from "./ProfileConnectionComponents";
import { CircleCropper, RectangleCropper } from "../../Utilities/Croppers";
import { CustomChip, customHealthPaper } from "./PersonalProfile";
import FileDragUpload from "../../Utilities/FileUploadAttachDocs";
import { ContactlessOutlined } from "@material-ui/icons";
import {
  postCertificateBlobReducer,
  postEducationBlobReducer,
  postExperienceBlobReducer,
  postProfessionalCoverImageReducer,
  getProfessionalInfoReducer,
  postProfessionalProfileImageReducer,
  getVideoResumeReducer,
  setIsResumeChange,
  postProfessionalProfileReducer,
  postPersonalProfileUpdateVisibilityReducer,
  postPersonalProfileGenerateAboutMeReducer,
  postProfessionalProfileGenerateAboutMeReducer,
  postProfessionalSkillsResucer,
  getEducationReducer,
  deleteEducationReducer,
  getProfileCompletionReducer,
  deleteExperienceReducer,
  deleteCertificateReducer,
  getCertificateReducer,
  getExperienceReducer,
  getProfessionalSkillsReducer,
  getServiceReducer,
  getAwardsReducer,
  getProjecteReducer,
  postGenerateDescriptionReducer,
  deleteResumeReducer,
  getResumeReducer,
  postVerifyByAdminReducer,
  UniversityReducer,
  getRecommendationReducer,
  deleteRecommendationReducer,
  patchRecommendationReducer,
  getLogoReducer,
  deleteProfessionalExperienceReducer,
  deleteProfessionalEducationReducer,
  patchProfessionalEducationReducer,
  patchProfessionalExperienceReducer,
  getEducationLogoReducer,
  getExperienceLogoReducer,
} from "../../../Redux/Reducers/ProfileReducer";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import {
  createJob,
  generateAISkills,
  generateJobDescription,
  getAppliedJobs,
  getJobAnalytics,
  getOpenJobs,
  postJobPreferences,
} from "../../../Redux/Reducers/JobReducer";
import {
  transformCertificateData,
  transformEducationData,
  transformExperienceData,
} from "./ParentProfile";

import { LightTooltip } from "./SideFeedComponents/LightTooltip";
import PostingJobModal from "./SideFeedComponents/PostingJobModal";
import CompanySelectionModal from "./CompanySelectionModal";
import { getUserIdDetails } from "../../../Redux/Reducers/OnboardingReducer";
import {
  getCompanyIdFromUserType,
  getEnterpriseEntityIdFromUserType,
} from "../../../utils/userTypeUtils";
import { filterCompaniesFromUserType } from "../../../utils/filterUtil";
import { syncEnterpriseJobAPI } from "../../../enterpriseApi";

import { Recommend } from "@mui/icons-material";
import { patchProfessionalExperience } from "../../../Redux/helpers/ProfileHelperApis";
import { useCardDetailContext } from "../../CardDetailContext";
import { useCreateCardDetailContext } from "../../CreatecardDetailContext";
import Secure from '../../../Assets/Secure.svg';

import DefaultLogo from '../../../Assets/img/logo-placeholder.jpg';
import RobustLogo from "./RobustLogo";
import { getAllCardDetailsReducer } from "../../../Redux/Reducers/CardReducer";
import AddRecommendation from "./ProfessionalProfileComponents/AddRecommendation";
import VisibilityIcon from "@mui/icons-material/Visibility";
// import PreviewModal from "../../../Components/Custom/PreviewModal";

// import EditIcon from '@mui/icons-material/Edit';

const ProfessionalProfile = ({ getAPIs, settriggeredApi, videoUrlArray }) => {
  const {
    updateResume,
    ProfessionalDetails,
    setProfessionalDetails,
    visibilityStates,
    handleVisibilitySwitch,

    professionalProfileCompletion,
    getCompletionStatus,
    PersonalDetails,
    setPersonalDetails,

    openDocumentViewer,
    connectionList,
    setConnectionList,
  } = useProfileContext();

  // const { skills, softSkills, profSkills, profTools, isSectionPublic } =
  //   ProfessionalDetails;

  const { personalLanguages: profLanguages, connectionCount } = PersonalDetails;

  const { callApiFunction, loading, error } = useApi();
  const [Loading, setLoading] = useState(false);
  const submitLockRef = useRef("");
  const [submittingSection, setSubmittingSection] = useState("");

  const startSectionSubmit = (section) => {
    if (submitLockRef.current) return false;
    submitLockRef.current = section;
    setSubmittingSection(section);
    return true;
  };

  const endSectionSubmit = () => {
    submitLockRef.current = "";
    setSubmittingSection("");
  };

  const Recommendation = useSelector(
    (state) => state?.ProfileArray?.Recommendation?.data
  );

  const visible = Recommendation?.visileRecommendations || [];
  const hidden = Recommendation?.hiddenRecommendations || [];

  const { addSection } = useProfileContext();
  const dispatch = useDispatch();
  const { userDetails } = useUserDetailContext();
  const { openSnackbar } = useQuantityContext();
  const location = useLocation();
  // ✅ useSearchParams is reactive — triggers re-render on every URL change
  // ❌ Previously: new URLSearchParams(location.search) — stale snapshot, caused wrong tab rendering
  const [searchParams] = useSearchParams();

  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem("objectId");
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
  };

  const { cards } = useCardDetailContext();

  const { setCardDetails, setCardStyles, setCardQrStyles, setContactStyles, setSocialLinks, setAttachDocs,
    setIsPersonalDetailsSaved, updateCardDetails, updateSocialLinks2, updateCardStyles, updateCardQrStyles, updateContactStyles, updateAttachDocsVal } = useCreateCardDetailContext();

  const ProfessionalData = useSelector(
    (state) => state?.ProfileArray?.professionaProfile
  );

  // console.log("ProfessionalDataNNN", ProfessionalData)


  const Personaldata = useSelector(
    (state) => state?.ProfileArray?.personalProfile?.data
  );


  const handleCardTypeClick = (category) => {
    // console.log("Category :", category);
    setNewCardType(category);
    updateCardDetails({ "CardType": category });
    updateCardStyles({ "CardType": category });
    if (category === "Customize_Personal") {
      updateCardStyles({ "layoutStyle": '2' }); //For Personal Card - Default Layout is 2
    }
    updateCardQrStyles({ "CardType": category });
    updateSocialLinks2({ "card_type": category });
    updateContactStyles({ "card_type": category, mobile_number: userDetails.phone, email: userDetails.email });
    updateAttachDocsVal({ fieldName: "card_name", value: category }); // It is Needed If CardType is GenZ itself
    setchooseCategory(false);
    // setChooseCustomizeCategory(false);
    // setIsPersonalDetailsSaved(false);
    navigate('/create-card', { state: { category: category } });
  };

  const AllCards = useSelector((state) => state?.CardArray?.AllCardDetailsInfo);

  const ProfessonalSoftSkills =
    useSelector(
      (state) => state?.ProfileArray?.professionalSkills?.data?.soft_skills) || [];

  const ProfessonalToolsSkills =
    useSelector(
      (state) =>
        state?.ProfileArray?.professionalSkills?.data?.professional_tools
    ) || [];
  const ProfessonalSkills =
    useSelector(
      (state) =>
        state?.ProfileArray?.professionalSkills?.data?.professional_skills
    ) || [];


  const ProfessionalEducation =
    useSelector((state) => state?.ProfileArray?.educationData?.data) || [];

  const ProfessionalCertificate =
    useSelector((state) => state?.ProfileArray?.certificateData?.data) || [];


  const ProfessionalExperience =
    useSelector((state) => state?.ProfileArray?.experienceData?.data) || [];


  const ProfessionalProject =
    useSelector((state) => state?.ProfileArray?.projectData?.data) || [];


  const ProfessionalAwards =
    useSelector((state) => state?.ProfileArray?.awardsData?.data) || [];


  const ProfessionalServices =
    useSelector((state) => state?.ProfileArray?.serviceData?.data) || [];

  const Resumedata =
    useSelector((state) => state?.ProfileArray?.ResumeData?.data) || [];


  const profileCompletionPercentage =
    useSelector(
      (state) =>
        state?.ProfileArray?.profileCompletion?.data
          ?.professional_profile_completion
    ) || 0;

  const rawUserTypeDetails = useSelector((state) => state?.onboarding?.userTypeDetails);
  const userTypeDetails =
    (rawUserTypeDetails?.data && Array.isArray(rawUserTypeDetails.data))
      ? rawUserTypeDetails.data
      : (Array.isArray(rawUserTypeDetails) ? rawUserTypeDetails : []);

  useEffect(() => {
    if (!userTypeDetails || userTypeDetails.length === 0) {
      dispatch(getUserIdDetails(userDetails?.reference_id));
    }
  }, [userDetails?.reference_id, dispatch, userTypeDetails]);

  const enterpriseCompanies = filterCompaniesFromUserType(
    rawUserTypeDetails || userTypeDetails,
    ProfessionalExperience
  );



  const [showActiveModal, setShowActiveModal] = useState(false);
  const [NewCardType, setNewCardType] = useState('');
  const [chooseCategory, setchooseCategory] = useState(false);
  const [activeMenu, setActiveMenu] = useState("my_profile");
  const [modalChecked, setModalChecked] = useState(false);
  // New state for file preview modal
  const [previewFile, setPreviewFile] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  // console.log("ProfessionalExperience=NN", ProfessionalExperience)
  // useEffect(() => {
  //   const allowedCards = ['Professional', 'Student', 'Customize_Student', 'Customize_Professional'];
  //   const hasValidCard = AllCards.some(card => allowedCards.includes(card?.card_type)); // Check `card_type`, not the whole object


  //   setShowActiveModal(!hasValidCard); // Show modal if NO valid card exists
  // }, [AllCards]);

  const hasValidCard = useMemo(() => {
    const allowed = [
      'Professional',
      'Student',
      'Customize_Student',
      'Customize_Professional',
    ];
    return AllCards.some(c => allowed.includes(c?.card_type));
  }, [AllCards]);

  useEffect(() => {
    if (!modalChecked) {
      setShowActiveModal(!hasValidCard);
      setModalChecked(true);          // don’t reopen on subsequent renders
    }
  }, [hasValidCard, modalChecked]);

  useEffect(() => {
    if (ProfessionalData) {
      setProfessionalEdited({
        Designation: ProfessionalData?.designation || "",
        Department: ProfessionalData?.department || "",
        CompanyName: ProfessionalData?.company_name || "",
        CompanyWeb: ProfessionalData?.website || "",
        CompanyEmail: ProfessionalData?.professional_email || "",
        CompanyAddress: ProfessionalData?.address || "",
        CompanyPhone: ProfessionalData?.phone_no ? ProfessionalData.phone_no.replace(/\s+/g, '') : "",
        StartDate: ProfessionalData?.start_year || "",
        EndDate: ProfessionalData?.end_year || "",
        profilePic: ProfessionalData?.user_profile_url || "",
        coverPic: ProfessionalData?.user_cover_url || "",
        aboutme: ProfessionalData?.about_me || "",
        isCurrentlyWorking: ProfessionalData?.is_currently_working || false,
        isFieldVisible: {
          Designation: Boolean(ProfessionalData?.is_designation_visible),
          Department: Boolean(ProfessionalData?.is_dept_visible),
          CompanyName: Boolean(ProfessionalData?.is_company_visible),
          CompanyAddress: Boolean(ProfessionalData?.is_address_public),
          CompanyWeb: Boolean(ProfessionalData?.is_website_visible),
          CompanyEmail: Boolean(ProfessionalData?.is_professional_email_visible),
          CompanyPhone: Boolean(ProfessionalData?.is_phone_visible),
        },
        isVerified: {
          CompanyEmail: ProfessionalData?.is_verified || false,
          CompanyPhone: ProfessionalData?.is_verified || false,
        },
      });
    }
  }, [ProfessionalData]);



  const handleOpenActivebutton = () => {
    setchooseCategory(true);
    setShowActiveModal(false);
  };

  // Handlers for preview modal
  const handleOpenPreview = (file) => {
    const previewFile = {
      ...file,
      // If the file has data but no url, handle blob URLs
      document_url: file.data || file.document_url,
      document_name: file.name || file.document_name || 'Document',
      document_type: file.type || file.document_type
    };
    setPreviewFile(previewFile);
    setIsPreviewOpen(true);
  };

  const handleClosePreview = () => {
    setIsPreviewOpen(false);
    setPreviewFile(null);
  };
  // const { handleInfo } = useQuantityContext();
  const isSmallLaptop = useMediaQuery("(max-width:1200px)");

  const today = new Date().toISOString().split("T")[0];
  // Create a shallow copy
  const [certificateList, setcertificateList] = useState(
    ProfessionalCertificate && [...ProfessionalCertificate]
  );
  const [educationList, setEducationList] = useState(
    ProfessionalEducation && [...ProfessionalEducation]
  );
  const [ExperienceList, setExperienceList] = useState(
    ProfessionalExperience && [...ProfessionalExperience]
  );
  const [searchQuery, setSearchQuery] = useState("");
  const [openSearchBar, setOpenSearchBar] = useState(false);
  const [menuItem, setMenuItem] = useState();

  const [projectList, setprojectList] = useState(
    ProfessionalProject && [...ProfessionalProject]
  );

  const [awardsList, setAwardsList] = useState(
    ProfessionalAwards && [...ProfessionalAwards]
  );
  // const [services, setServicess] = useState(ProfessionalServices && [...ProfessionalServices]);
  const [parsedServices, setParsedServices] = useState([]);
  const userFirstName = userDetails?.firstName;
  const userLastName = userDetails?.lastName;

  // const location = useLocation();
  // console.log("certificateListMMMMM", certificateList)
  //  Varify modal
  const [openFamilyVerify, setOpenFamilyVerify] = useState(false);
  const [professionalEmailOtp, setProfessionalEmailOtp] = useState("");
  const [phoneOtp, setPhoneOtp] = useState();
  const [isProfessionalEmailVerified, setIsProfessioanlEmailVerified] =
    useState(false);
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [ProfessionalEmailError, setProfessionalEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [currentMember, setCurrentMember] = useState(null);
  const [phoneOtpSeconds, setPhoneOtpSeconds] = useState(60);
  const [isPhoneTimerActive, setIsPhoneTimerActive] = useState(false);
  const [currentMemberType, setCurrentMemberType] = useState(null);
  const [isFamilyEdit, setisFamilyEdit] = useState(false);
  const [searchItems, setSearchItems] = useState([]);
  // const [searchItemsDomain, setSearchItemsDomain] = useState([null]);
  const [selectedLogo, setSelectedLogo] = useState(null);
  const [familyEditState, setFamilyEditState] = useState({
    // fatherDet: personalFamilyDetails?.fatherDet,
    // motherDet: personalFamilyDetails?.motherDet,
    // spouseDet: personalFamilyDetails?.spouseDet,
    // kids: personalFamilyDetails?.kids.map(kid => ({ ...kid })) // Use a map to ensure a shallow copy if needed
  });

  // console.log("RESPONSEEEEEE", searchItems)


  const handleCloseVerifiedDialog = () => {
    // setIsVerifiedDialogOpen(false);
    // setOpenLightBoxForCategory(false);
    setchooseCategory(false);
    // setChooseCustomizeCategory(false);
  };
  const [dateError, setDateError] = useState("");
  const [isPhoneNumberVerified, setIsPhoneNumberVerified] = useState(false);
  const [isEmailVerifiedProfessional, setIsEmailVerifiedProfessional] =
    useState(false);
  const [selectedExperience, setSelectedExperience] = useState(null);
  const [selectedProfessionalCompany, setSelectedProfessionalCompany] = useState(null);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [selectedExperienceDomain, setSelectedExperienceDomain] =
    useState(null);

  const [selectedProfessionalDomain, setSelectedProfessioanlDomain] = useState(null);
  const [selectedCertificateDomain, setSelectedCertificateDomain] =
    useState(null);
  const [activeSection, setActiveSection] = useState("");
  const [activeSubTab, setActiveSubTab] = useState("");
  const mainTab = searchParams.get("mainTab") || searchParams.get("MainTab") || "professional_profile";
  const subTab = searchParams.get("subTab");
  const resumeSectionRef = useRef(null); // new ref for direct mapping if you add id to your resume wrapper
  const [blinkResume, setBlinkResume] = useState(false); // new state to trigger blink
  const [addRecommendation, setaddRecommendation] = useState(false);
  const [errors, setErrors] = useState({
    email: false,
    phoneNo: false,
  });
  let isMemberVerified = ProfessionalData?.isVerified;

  const handleOpenFamilyVerify = () => {
    setisFamilyEdit(false);
    setOpenFamilyVerify(true);
    setEmailOtp("");
    setPhoneOtp();
    setEmailOtpSeconds(60);
    setPhoneOtpSeconds(0);
    setIsProfessioanlEmailVerified(false);
    setIsPhoneVerified(false);
  };

  //    useEffect(() => {
  //   if (!document.getElementById("profile-blink-styles")) {
  //     const style = document.createElement("style");
  //     style.id = "profile-blink-styles";
  //     style.innerHTML = `
  //       @keyframes profileBlink {
  //         0% { opacity: 1; }
  //         50% { opacity: 0; }
  //         100% { opacity: 1; }
  //       }
  //       .blink-heading {
  //         animation: profileBlink 0.8s step-end infinite;
  //       }
  //     `;
  //     document.head.appendChild(style);
  //   }
  // }, []);

  useEffect(() => {
    if (mainTab === "professional_profile" && subTab) {
      // set the active tab to the subTab value when navigating in from other pages
      // common subTab values we expect: 'resume', 'video_resume', 'education' etc.
      setActiveMenu(subTab);
    }
  }, [mainTab, subTab]);

  useEffect(() => {
    if (activeMenu !== "resume") return;

    // wait a short time to ensure the DOM is rendered for the resume section
    const timer = setTimeout(() => {
      // Prefer the explicit resumeSectionRef if you assign it to the resume wrapper.
      let targetEl = resumeSectionRef.current || document.getElementById("resume-section");

      // If the element is not found by id, try to find a heading with text "Resume"
      if (!targetEl) {
        // search for headings used across the page with the class used in this component
        const h2s = document.querySelectorAll("h2.headingforContent");
        for (const h of h2s) {
          if ((h.textContent || "").trim().toLowerCase().includes("resume")) {
            targetEl = h;
            break;
          }
        }
      }

      // scroll the element into view
      if (targetEl) {
        // If we found a heading itself, we will scroll to the top of container that contains content
        targetEl.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });

        // Add blink class (heading)
        // If we targeted the wrapper, try to find the heading inside the wrapper
        let heading = targetEl;
        if (heading && !heading.matches("h1,h2,h3,h4,h5,h6")) {
          const innerHeading = heading.querySelector("h2.headingforContent, h3.headingforContent, .headingforContent");
          if (innerHeading) heading = innerHeading;
        }

        // if (heading) {
        //   heading.classList.add("blink-heading");
        //   setBlinkResume(true);
        //   const blinkTimeout = setTimeout(() => {
        //     heading.classList.remove("blink-heading");
        //     setBlinkResume(false);
        //   }, 5000); // 5 seconds

        //   // clear blink timeout in cleanup
        //   return () => clearTimeout(blinkTimeout);
        // }
      }
    }, 120);

    // cleanup timer when effect reruns or component unmounts
    return () => clearTimeout(timer);
  }, [activeMenu, subTab, resumeSectionRef.current]);

  const handleVerifyMember = async (member) => {

    // setCurrentMemberType(memberType?.toLowerCase());
    // setCurrentMember(member);

    // let updatedMember = member;
    // if (!member.CompanyEmail) {
    //   updatedMember = { ...member, email: userDetails.email };
    //   setCurrentMember(updatedMember);
    // } else {
    //   setCurrentMember(member);
    // }

    try {
      await sendEmailOtp(member?.CompanyEmail);
    } catch (error) {
      console.log("Cannot Start Verification:", error);
    }
  };
  const getValue = (field) => {
    // return member?.[field];
  };
  // const verifyMemberFunction = () => {
  //   let isEmailValid = true;
  //   let isPhoneValid = true;

  //   // Email validation (if provided)
  //   if (getValue("email")) {
  //     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  //     isEmailValid = emailRegex.test(getValue("email").trim());

  //     if (!isEmailValid) {
  //       setErrors((prevState) => ({
  //         ...prevState,
  //         email: true, // Show email error if invalid
  //       }));
  //     }
  //   } else {
  //     isEmailValid = true; // Email can be empty
  //   }

  //   // Phone number validation (mandatory)
  //   if (getValue("phoneNo")) {
  //     isPhoneValid = matchIsValidTel(getValue("phoneNo"));
  //     if (!isPhoneValid) {
  //       setErrors((prevState) => ({
  //         ...prevState,
  //         phoneNo: true, // Show phone error if invalid
  //       }));
  //     }
  //   } else {
  //     setErrors((prevState) => ({
  //       ...prevState,
  //       phoneNo: true, // Show phone error if invalid
  //     }));
  //   }

  //   // If both are valid, proceed with verification
  //   if (isPhoneValid && (isEmailValid || !getValue("email"))) {
  //     // onVerify(memberType, member);
  //   }
  // };



  // const sendEmailOtp = async (email) => {

  //   setLoading(true);
  //   try {
  //     openSnackbar("Sending OTP. Please wait.", "info");
  //     if (email) {
  //       const response = await axios.post(
  //         "onboard/twofactor-second-otp",
  //         { email: email },
  //         { headers: headers }
  //       );
  //       if (response?.status === 200) {

  //         handleOpenFamilyVerify();
  //         setEmailError("");
  //         setEmailOtp("");
  //         setEmailOtpSeconds(60);
  //         setIsEmailTimerActive(true);
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Failed to send OTP to email", error, "headers", headers);
  //     openSnackbar("Could not send OTP. Try again later.", "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const sendEmailOtp = async (email) => {
    setLoading(true);
    try {
      openSnackbar("Sending OTP. Please wait.", "info");
      if (email) {
        const response = await axios.post(
          "onboard/twofactor-second-otp",
          { email: email },
          { headers: headers }
        );
        if (response?.status === 200) {
          handleOpenFamilyVerify();
          setEmailError("");
          setProfessionalEmailOtp("");
          setEmailOtpSeconds(60);
          setIsEmailTimerActive(true);
          setIsProfessioanlEmailVerified(false); // Reset verification state
        }
      }
    } catch (error) {
      console.error("Failed to send OTP to email", error, "headers", headers);
      openSnackbar("Could not send OTP. Try again later.", "error");
    } finally {
      setLoading(false);
    }
  };

  const sendPhoneOtp = async (phoneNo) => {
    // setLoading(true);

    try {
      const response = await axios.post(
        "/mail/Contact-send-mob-otp",
        { mobileNumber: phoneNo },
        { headers: headers }
      );
      if (response.status === 200) {
        console.log("OTP sent successfully to phone");

        setIsPhoneTimerActive(true);
        setPhoneOtpSeconds(60);
        setPhoneError("");
        setPhoneOtp();
      }
    } catch (error) {
      console.error("Failed to send OTP to phone", error);
    } finally {
      setLoading(false);
    }
  };

  // const verifyPhoneOtp = async (phoneNo) => {
  //   if (phoneOtpSeconds <= 0) {
  //     setPhoneError("Current OTP time has expired. Click on Resend.");
  //     return;
  //   }
  //   try {
  //     const response = await axios.post(
  //       "/mail/verify-mobile-otp",
  //       { mobileNumber: phoneNo, otp: Number(phoneOtp) },
  //       { headers: headers }
  //     );
  //     if (response.status === 200) {
  //       setIsPhoneVerified(true);
  //       setPhoneError("");
  //       setPhoneOtpSeconds(0);
  //       setIsPhoneTimerActive(false);
  //       const updateResponse = await axios.post(
  //         "/api/v1/userprofile/verify/by-otp",
  //         {
  //           entityId: ProfessionalData?.user_ref_id,
  //           section: "professional_profile",
  //         },
  //         { headers: headers }
  //       );
  //       // Handle success logic here
  //       console.log("Phone OTP verified!");
  //       setIsPhoneVerified(true);
  //       setOpenFamilyVerify(false);
  //       setIsPhoneNumberVerified(true);
  //       // Update the verification status in the state
  //       setFamilyEditState((prevDetails) => {
  //         return {
  //           ...prevDetails,
  //           [`${currentMemberType}Det`]: {
  //             ...prevDetails[`${currentMemberType}Det`],
  //             isVerified: true, // Set isVerified to true
  //           },
  //         };
  //       });
  //     }
  //   } catch (error) {
  //     setPhoneError("Invalid Phone OTP. Try Again.");
  //     console.log("Failed to verify Phone OTP", error);
  //     if (error?.response?.status === 400) {
  //       handleFailure("Please enter valid OTP.")
  //     }
  //   }
  // };

  const [recommendations, setRecommendations] = useState([]);

  const [isRecommendationEdit, setIsRecommendationEdit] = useState({
    recommendations: false,
  });
  const [isSectionPublicrec, setIsSectionPublic] = useState({
    recommendations: true,
  });
  const navigate = useNavigate();

  const companyLogo = ProfessionalExperience[0]?.company_logo || "";


  const [openRecommendation, setOpenRecommendation] = useState(false);
  const [recommendationId, setRecommendationId] = useState(null);
  const handleRemoveRecommendation = (id) => {

    setOpenRecommendation(true);
    setRecommendationId(id);
  };
  const handleDeleteRecommendation = async () => {
    // const recommendationid = recommendationId?.toString();
    try {
      const response = await dispatch(
        deleteRecommendationReducer(recommendationId)
      );


      if (response?.payload?.status === "SUCCESS") {
        await dispatch(getRecommendationReducer());
        setOpenRecommendation(false);
        setRecommendationId(null);
      }
    } catch (error) {
      console.log("API ERROR", error);
    }
  };

  const [isEmailValid, setIsEmailValid] = useState(false);

  const handleSelected = (event, value) => {

    setSearchItems([]);

    if (menuItem === "Education") {
      if (!value) {
        setSelectedInstitute(null);
        updateCurrentEducation({
          institute: "",
          instlogo: { name: "logo", type: "image/png", data: "" },
          instituteDomain: "",
        });
      } else {
        setSelectedInstitute(value);
        updateCurrentEducation({
          institute: value?.legal_name || "",
          instituteDomain: value?.website || "",
          instlogo: {
            name: "logo",
            type: "image/png",
            data: value?.logo || "",
          },
        });

        console.log("Selected Education Logo:", {
          logoData: value?.logo,
          institute: value?.legal_name,
          fullLogoObject: value
        });
      }
    }

    if (menuItem === "Experience") {
      if (!value) {
        setSelectedExperience(null);
        // updateCurrentEducation({ institute: "", instlogo: { name: "logo", type: "image/png", data: "" }, instituteDomain: "" });
        setCurrentExperience({
          ...currentExperience,
          companyName: "",
          companyDomain: "",
          companylogo: { name: "logo", type: "image/png", data: "" },
        });
      } else {
        setSelectedExperience(value);

        setCurrentExperience({
          ...currentExperience,
          companyName: value?.legal_name,
          companyDomain: value?.website || "",
          companylogo: {
            name: "logo",
            type: "image/png",
            data: value?.logo || "",
          },
        });
      }
    }

    if (menuItem === "Certificate") {
      if (!value) {
        setSelectedCertificate(null);
        setcurrentCertificate({
          ...currentCertificate,
          certificateLogo: { name: "logo", type: "image/png", data: "" },
          organName: "",
          organDomain: "",
        });
      } else {
        setSelectedCertificate(value);

        setcurrentCertificate({
          ...currentCertificate,
          certificateLogo: {
            name: "logo",
            type: "image/png",
            data: value?.logo,
          },
          organName: value?.legal_name,
          organDomain: value?.website || "",
        });
      }
    }


    if (menuItem === "CompanyName") {
      if (!value) {
        setSelectedProfessionalCompany(null);
        setProfessionalEdited({
          ...ProfessionalEdited,
          // ...currentCertificate,
          // certificateLogo: { name: "logo", type: "image/png", data: "" },
          // organName: "",
          // organDomain: "",
          CompanyName: "",
          CompanyWeb: ""
        });
      } else {
        // setSelectedCertificate(value);
        setSelectedProfessionalCompany(value);
        setProfessionalEdited({

          ...ProfessionalEdited,
          CompanyName: value?.legal_name,
          CompanyWeb: value?.website || ""
        });
      }
    }

  };

  const handleSearchLogo = (event, value) => {


    if (menuItem === "Education") {
      // When typing, only update the institute name, reset logo/domain
      setSelectedInstitute(null); // deselect any previously selected item

      setCurrentEducation((prev) => ({
        ...prev,
        institute: value || "",
        // instlogo: { name: "logo", type: "image/png", data: "" },
        // instituteDomain: ""
      }));
      // console.log("Searching for logo with value:", value);
    }

    if (menuItem === "Experience") {
      setSelectedExperience(null);

      setCurrentExperience((prev) => ({
        ...prev,
        companyName: value || "",
        // DON’T reset companyDomain here
        // companylogo: { name: "logo", type: "image/png", data: "" },
      }));
    }

    if (menuItem === "Certificate") {
      setSelectedCertificate(null);
      setcurrentCertificate((prev) => ({
        ...prev,
        // certificateLogo: { name: "logo", type: "image/png", data: "" },
        organName: value,
        // organDomain: "",
      }));
    }

    if (menuItem === "CompanyName") {
      // setSelectedCertificate(null);
      setSelectedProfessionalCompany(null);
      setProfessionalEdited((prev) => ({
        ...prev,
        // certificateLogo: { name: "logo", type: "image/png", data: "" },
        CompanyName: value,
        // organDomain: "",
      }));
    }
  };

  const handleSelectedDomain = (event, value) => {

    setSearchItems(null);

    if (menuItem === "Education") {
      if (!value) {
        setSelectedInstituteDomain(null);
        updateCurrentEducation({
          institute: "",
          instlogo: { name: "logo", type: "image/png", data: "" },
          instituteDomain: "",
        });
      } else {
        setSelectedInstituteDomain(value);
        updateCurrentEducation({
          institute: value?.legal_name || "",
          instituteDomain: value?.website || "",
          instlogo: {
            name: "logo",
            type: "image/png",
            data: value?.logo || "",
          },
        });
      }
    }

    if (menuItem === "Experience") {
      if (!value) {
        setSelectedExperienceDomain(null);
        // updateCurrentEducation({ institute: "", instlogo: { name: "logo", type: "image/png", data: "" }, instituteDomain: "" });
        setCurrentExperience({
          ...currentExperience,
          companyName: "",
          companyDomain: "",
          companylogo: { name: "logo", type: "image/png", data: "" },
        });
      } else {
        setSelectedExperienceDomain(value);

        setCurrentExperience({
          ...currentExperience,
          companyName: value?.legal_name,
          companyDomain: value?.website || "",
          companylogo: {
            name: "logo",
            type: "image/png",
            data: value?.logo || "",
          },
        });
      }
    }

    if (menuItem === "Certificate") {
      if (!value) {
        setSelectedCertificateDomain(null);
        setcurrentCertificate({
          ...currentCertificate,
          certificateLogo: { name: "logo", type: "image/png", data: "" },
          organName: "",
          organDomain: "",
        });
      } else {
        setSelectedCertificateDomain(value);

        setcurrentCertificate({
          ...currentCertificate,
          certificateLogo: {
            name: "logo",
            type: "image/png",
            data: value?.logo,
          },
          organName: value?.legal_name,
          organDomain: value?.website || "",
        });
      }
    }


    if (menuItem === "CompanyWebsite") {
      if (!value) {
        setSelectedProfessioanlDomain(null);
        setProfessionalEdited({
          ...ProfessionalEdited,
          CompanyWeb: "",
          CompanyName: ""
          // ...currentCertificate,
          // certificateLogo: { name: "logo", type: "image/png", data: "" },
          // organName: "",
          // organDomain: "",
        });
      } else {
        setSelectedProfessioanlDomain(value);

        setProfessionalEdited({
          // ...currentCertificate,
          ...ProfessionalEdited,
          CompanyWeb: value?.website || "",
          CompanyName: value?.legal_name,
          // certificateLogo: {
          //   name: "logo",
          //   type: "image/png",
          //   data: value?.logo,
          // },
          // organName: value?.legal_name,
          // organDomain: value?.website || "",
        });
      }
    }
  };

  const handleSearchDomain = (event, value) => {
    // console.log("Searching for domain:", value);
    if (menuItem === "Education") {
      // When typing, only update the institute name, reset logo/domain
      setSelectedInstituteDomain(null); // deselect any previously selected item

      setCurrentEducation((prev) => ({
        ...prev,
        // institute: "",
        // instlogo: { name: "logo", type: "image/png", data: "" },
        instituteDomain: value,
      }));
    }

    if (menuItem === "Experience") {
      setSelectedExperienceDomain(null);

      setCurrentExperience((prev) => ({
        ...prev,
        companyDomain: value,
        // DON’T reset companyName here
        // companylogo: { name: "logo", type: "image/png", data: "" },
      }));
    }

    if (menuItem === "Certificate") {
      setSelectedCertificateDomain(null);
      setcurrentCertificate((prev) => ({
        ...prev,
        // certificateLogo: { name: "logo", type: "image/png", data: "" },
        // organName: "",
        organDomain: value,
      }));
    }

    if (menuItem === "CompanyWebsite") {
      setSelectedProfessioanlDomain(null);
      setProfessionalEdited((prev) => ({
        ...prev,
        // certificateLogo: { name: "logo", type: "image/png", data: "" },
        // organName: "",
        CompanyWeb: value,
      }));
    }
  };

  const [currentEducation, setCurrentEducation] = useState({
    id: "",
    instlogo: { name: "", type: "", data: "" },
    certificatepic: { name: "", type: "", data: "" },
    eduLevel: "",
    instituteDomain: "",
    universityName: "",
    fieldofStudy: "",
    institute: "",
    degree: "",
    grade: "",
    startYear: "",
    endYear: "",
    isCurrentlyPursuing: false,
    description: "",
    isPublic: true,
    month: "",
    year: "",
    fullName: userDetails.name || "",
    studentId: "",
    verifyMethod: "",
    institute_email: "",
    adminEmailId: "",
    verifyDoc: { name: "", type: "", data: "" },
    isVerified: false,
    // studentEmailId,
  });

  // console.log("currentEducation-NNN", currentEducation);
  const degreeOptions =
    degreeOptionsByEduLevel[currentEducation.eduLevel] || [];
  const [inputDegree, setInputDegree] = useState(currentEducation.degree || "");
  const [inputFieldOfStudy, setInputFieldOfStudy] = useState(
    currentEducation.fieldofStudy || ""
  );
  // Experience states and functions
  const [LightBoxExperience, setLightBoxExperience] = useState(false);

  const [currentExperience, setCurrentExperience] = useState({
    id: "",
    companylogo: { name: "", type: "", data: "" },
    companyDomain: "",
    companyName: "",
    location: "",
    locationType: "",
    roleTitle: "",
    employmentType: "",
    details: "",
    startMonth: "",
    startYear: "",
    endMonth: "",
    endYear: "",
    responsibility: [],
    headline: "",
    isCurrentlyWorking: false,
    isPublic: true,
    isVerified: false,
    fullName: userDetails.name,
    employeeId: "",
    verifyMethod: "",
    hrName: "",
    hrEmail: "",
    workEmail: "",
    verifyDocs: [],
    contentMethod: "",
    verifyDocEml: { name: "", type: "", data: "" },
    verifyDocImgPdf: { name: "", type: "", data: "" },
    verifyDocAny: { name: "", type: "", data: "" },
    company_email: "",
    profile_headline: "",
  });

  const [LightBoxCertificate, setLightBoxCertificate] = useState(false);
  const [editCertificateIndex, setEditCertificateIndex] = useState(null);
  const [DeleteCertificate, setDeleteCertificate] = useState(false);
  const [currentCertificate, setcurrentCertificate] = useState({
    id: "",
    certificateLogo: { name: "", type: "", data: "" },
    certificatePDF: { name: "", type: "", data: "" },
    organName: "",
    organDomain: "",
    courseName: "",
    certificateLink: "",
    certifiDetails: "",
    certifiMonth: "",
    certifiYear: null,
    isPublic: true,
    isVerified: false,
    fullName: "",
    verifyMethod: "",
    orgEmailId: "",
    verifyDoc: { name: "", type: "", data: "" },
  });

  const [ProfessionalEdited, setProfessionalEdited] = useState({
    Designation: ProfessionalData?.designation || "",
    Department: ProfessionalData?.department || "",
    CompanyName: ProfessionalData?.company_name || "",
    CompanyWeb: ProfessionalData?.website || "",
    CompanyEmail: ProfessionalData?.professional_email || "",
    CompanyAddress: ProfessionalData?.address || "",
    CompanyPhone: ProfessionalData?.phone_no ? ProfessionalData.phone_no.replace(/\s+/g, '') : "",
    StartDate: ProfessionalData?.start_year || "",
    EndDate: ProfessionalData?.end_year || "",
    profilePic: ProfessionalData?.user_profile_url || "",
    coverPic: ProfessionalData?.user_cover_url || "",
    aboutme: ProfessionalData?.about_me || "",
    isCurrentlyWorking: ProfessionalData?.is_currently_working || false,
    isFieldVisible: {
      Designation: Boolean(ProfessionalData?.is_designation_visible),
      Department: Boolean(ProfessionalData?.is_dept_visible),
      CompanyName: Boolean(ProfessionalData?.is_company_visible),
      CompanyAddress: Boolean(ProfessionalData?.is_address_public),
      CompanyWeb: Boolean(ProfessionalData?.is_website_visible),
      CompanyPhone: Boolean(ProfessionalData?.is_phone_visible),
      CompanyEmail: Boolean(ProfessionalData?.is_professional_email_visible),
    },
    isVerified: {
      CompanyEmail: false,
      CompanyPhone: false,
    },
  });


  useEffect(() => {
    if (!currentEducation?.institute) {
      // Ensure API is called only when there's a search value

      setSearchItems([]);
      return;
    }
    const delayDebouncing = setTimeout(() => {
      getEducationLogo(currentEducation?.institute);
    }, 500);
    return () => clearTimeout(delayDebouncing);
  }, [currentEducation?.institute]);

  // useEffect(() => {
  //   if (!currentExperience?.companyName) {
  //     // Ensure API is called only when there's a search value

  //     setSearchItems([]);
  //     return;
  //   }
  //   const delayDebouncing = setTimeout(() => {
  //     getLogo(currentExperience?.companyName);
  //   }, 500);
  //   return () => clearTimeout(delayDebouncing);
  // }, [currentExperience?.companyName]);

  useEffect(() => {
    if (!currentExperience?.companyName) {
      setSearchItems([]);
      return;
    }
    const delayDebouncing = setTimeout(() => {
      getExperienceLogo(currentExperience?.companyName); // ✅ use new function
    }, 500);
    return () => clearTimeout(delayDebouncing);
  }, [currentExperience?.companyName]);


  useEffect(() => {
    if (!ProfessionalEdited?.CompanyName) {
      // Ensure API is called only when there's a search value

      setSearchItems([]);
      return;
    }
    const delayDebouncing = setTimeout(() => {
      getLogo(ProfessionalEdited?.CompanyName);
    }, 500);
    return () => clearTimeout(delayDebouncing);
  }, [ProfessionalEdited?.CompanyName]);

  useEffect(() => {
    if (!currentCertificate?.organName) {
      // Ensure API is called only when there's a search value
      setSearchItems([]);
      return;
    }
    const delayDebouncing = setTimeout(() => {
      getLogo(currentCertificate?.organName);
    }, 500);
    return () => clearTimeout(delayDebouncing);
  }, [currentCertificate?.organName]);

  // useEffect(() => {
  //   if (!currentExperience?.companyDomain) {
  //     return;
  //   }

  //   const delayDebouncing = setTimeout(() => {
  //     getLogo(currentExperience?.companyDomain); //  only pass domain
  //   }, 500);

  //   return () => clearTimeout(delayDebouncing);
  // }, [currentExperience?.companyDomain]);

  useEffect(() => {
    if (!currentExperience?.companyDomain) {
      return;
    }
    const delayDebouncing = setTimeout(() => {
      getExperienceLogo(currentExperience?.companyDomain); // ✅ use new function
    }, 500);
    return () => clearTimeout(delayDebouncing);
  }, [currentExperience?.companyDomain]);

  useEffect(() => {
    if (!ProfessionalEdited?.CompanyWeb) {
      return;
    }

    const delayDebouncing = setTimeout(() => {
      getLogo(ProfessionalEdited?.CompanyWeb); //  only pass domain
    }, 500);

    return () => clearTimeout(delayDebouncing);
  }, [ProfessionalEdited?.CompanyWeb]);

  useEffect(() => {
    if (!currentEducation?.instituteDomain) {
      return;
    }
    const delayDebouncing = setTimeout(() => {
      getEducationLogo(currentEducation?.instituteDomain); //  only pass domain
    }, 500);

    return () => clearTimeout(delayDebouncing);
  }, [currentEducation?.instituteDomain]);

  useEffect(() => {
    if (!currentCertificate?.organDomain) {
      return;
    }

    const delayDebouncing = setTimeout(() => {
      getLogo(currentCertificate?.organDomain); //  only pass domain
    }, 500);

    return () => clearTimeout(delayDebouncing);
  }, [currentCertificate?.organDomain]);

  const getLogo = async (searchValue) => {
    // console.log("IAMsearchValue", searchValue);
    try {

      const response = await dispatch(getLogoReducer(searchValue));
      // console.log("LOGOOO", response);
      if (response?.payload?.statusCode === 200) {
        setSearchItems(response?.payload?.data);
      }
    } catch (error) {
      console.log("API EROR", error);
    }
  };

  const getEducationLogo = async (searchValue) => {
    try {
      const response = await dispatch(getEducationLogoReducer(searchValue));

      if (response?.payload?.statusCode === 200) {
        setSearchItems(response?.payload?.data);
      }
    } catch (error) {
      console.log("API EROR", error);
    }
  };

  const getExperienceLogo = async (searchValue) => {

    try {
      const response = await dispatch(getExperienceLogoReducer(searchValue)); // pass extra params
      // console.log("LOGOOO", response);
      if (response?.payload?.statusCode === 200) {
        setSearchItems(response?.payload?.data);
      }
    } catch (error) {
      console.log("API ERROR", error);
    }
  };

  const handleRecommendationVisibility = (id) => async (event) => {
    const newVisibility = event.target.checked;

    try {
      const response = await dispatch(patchRecommendationReducer(id));

      if (response?.payload?.status === "SUCCESS") {
        await dispatch(getRecommendationReducer());
      }
    } catch (error) {
      console.log("API ERROR", error);
    }
  };

  const [projectDetails, setProjectDetails] = useState({
    id: "",
    projectName: "",
    projectDescription: "",
    startMonth: "",
    startYear: "",
    endMonth: "",
    endYear: "",
    currentlyWorking: false,
    attachments: [],
  });

  const [editProjectIndex, setEditProjectIndex] = useState(null);
  const updateProjectDetails = (updatedDetails) => {
    setProjectDetails((prevDetails) => ({
      ...prevDetails,
      ...updatedDetails,
    }));
  };

  const [openModal, setOpenModal] = useState(false);
  // const [selectedRecommendation, setSelectedRecommendation] = useState(null);
  const [selectedRecommendation, setSelectedRecommendation] = useState(null);

  // const [selectedRecommendation, setSelectedRecommendation] = useState(null);

  const handleProfileClick = (recommendation) => {
    setSelectedRecommendation(recommendation);
    setOpenModal(true);
  };

  // Close the modal
  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedRecommendation(null); // Reset the selected recommendation
  };

  const handleSuccess = (message = "", op = "Save") => {
    let successMessage;
    if (op === "Delete")
      successMessage =
        message && message !== "" ? message : "Deleted Successfully!";
    else if (op === "Save")
      successMessage =
        message && message !== "" ? message : "Saved Successfully!";
    openSnackbar(successMessage, "success", 3000);
  };

  const handleFailure = (message = "", op = "Save") => {
    let failureMessage;
    if (op === "Delete")
      failureMessage =
        message && message !== "" ? message : "Failed to Delete. Try Again.";
    else if (op === "Save")
      failureMessage =
        message && message !== "" ? message : "Failed to Save. Try Again.";
    openSnackbar(failureMessage, "error", 3000);
  };

  const handleInfo = (message = "", autoClose = 5000) => {
    let infoMessage;
    infoMessage = message;
    openSnackbar(infoMessage, "info", autoClose);
  };

  const handleKYCClick = () => {
    if (!ProfessionalDetails?.Aboutme) {
      setActiveMenu("my_profile");
      return;
    }

    // if (!sortedEducationList || sortedEducationList.length === 0) {
    //   setActiveMenu("education");
    //   return;
    // }

    if (!sortedEducationList || sortedEducationList?.length === 0) {
      setActiveMenu("education");
      return;
    }

    if (!sortedCertificateList || sortedCertificateList?.length === 0) {
      setActiveMenu("certificate");
      return;
    }

    if (!sortedExperienceList || sortedExperienceList?.length === 0) {
      setActiveMenu("experience");
      return;
    }
  };

  // Connection, Share, and Invite
  const [connectionViewModal, setConnectionViewModal] = useState(false);
  const [openShareProfile, setOpenShareProfile] = useState(false);
  const [shareProfileConfig, setShareProfileConfig] = useState({
    open: false,
    onClose: undefined,
    qrCodeUrl: "",
    qrCodeLogo: undefined,
    showQr: true,
    isDownload: false,
    profileType: "",
    handleSuccess: handleSuccess,
    handleFailure: handleFailure,
  });

  const updateShareProfileConfig = (newConfig) => {
    setShareProfileConfig((prevConfig) => ({
      ...prevConfig,
      ...newConfig,
    }));
  };

  const handleShareProfile = () => {
    // console.log(
    //   "encryptedUrlRef.currentencryptedUrlRef.current",
    //   encryptedUrlRef.current
    // );
    updateShareProfileConfig({
      open: true,
      onClose: () =>
        setShareProfileConfig((prev) => ({ ...prev, open: false })),
      qrCodeUrl: `${process.env.REACT_APP_CARD_URL}/profile?encryptedId=${encryptedUrlRef.current}`,
      qrCodeLogo: mostRecentExpLogo,
      showQr: true,
      profileType: "Professional Profile",
    });
  };

  const professionaProfile =
    useSelector((state) => state?.ProfileArray?.professionaProfile) || [];
  // const showBadge=professionaProfile?.show_badge || ""
  // const TagName=professionaProfile?.tag_name || ""

  // Extract the video URL (if data exists)
  // const videoUrl = videoResume?.[0]?.document_url;

  const handleSharePortfolio = () => {
    updateShareProfileConfig({
      open: true,
      onClose: () =>
        setShareProfileConfig((prev) => ({ ...prev, open: false })),
      qrCodeUrl: `${process.env.REACT_APP_CARD_URL}/portfolio?encryptedId=${encryptedUrlRef.current}&link=${objectId}`,
      showQr: false,
      profileType: "Portfolio",
    });
  };

  const encryptedUrlRef = useRef(""); // Using a ref to persist encryptedUrl across renders without causing re-renders
  const qrCodeSize = isSmallLaptop ? 80 : undefined;
  const [openInviteProfile, setOpenInviteProfile] = useState(false);

  useEffect(() => {
    if (Personaldata?.user_ref_id) {
      const encryptedId = CryptoJS.AES.encrypt(
        Personaldata?.user_ref_id?.toString(),
        "UserDetailsSecretKey"
      ).toString();
      encryptedUrlRef.current = encodeURIComponent(encryptedId);
      // console.log("encrypted id ", encryptedUrlRef.current);
    }
  }, [Personaldata]); // Only re-calculate when userRefId changes



  const [Skills, setSkills] = useState({
    skills: [],
    profLanguages: [],
    softSkills: ProfessonalSoftSkills?.skills || [],
    profSkills: ProfessonalSkills?.skills || [],
    profTools: ProfessonalToolsSkills?.skills || [],
  });
  const [text, setText] = useState(ProfessionalDetails.Aboutme);

  const [isSectionPublicInfo, setIsSectionPublicInfo] = useState({
    Aboutme: Boolean(ProfessionalData?.is_about_public),
    skills: true,
    profLanguages: true,
    services: Boolean(ProfessionalServices?.[0]?.is_public),
    softSkills: ProfessonalSoftSkills?.is_public === 1 ? true : false,
    profSkills: ProfessonalSkills?.is_public === 1 ? true : false,
    profTools: ProfessonalToolsSkills?.is_public === 1 ? true : false,
  });

  const sectionSetters = {
    projects: setprojectList,
    "honors-awards": setAwardsList,
    education: setEducationList,
    certificate: setcertificateList,
    experience: setExperienceList,
  };
  // const handleAboutMeSave = () => {
  //   updateProfessionalDetails({ "Aboutme": text });
  //   setAboutOpen(false);
  // }

  // const [services, setServices] = useState({
  //   id: '',
  //   yourservices: [],
  //   servicesDetails: '',
  //   workLocation: '',
  //   remote: '',
  //   dayStart: '',
  //   dayEnd: '',
  //   workStart: '',
  //   workEnd: '',
  //   currency: '',
  //   hourRate: '',
  //   serviceAttachments: [],
  //   removedAttachments: []
  // });

  // Runs whenever ProfessionalData updates

  const updateProfessionalDetails = (updatedDetails) => {
    setProfessionalEdited((prevDetails) => ({
      ...prevDetails,
      ...updatedDetails,
    }));
  };

  const updateProfessionalEdited = (updatedDetails) => {
    setProfessionalEdited((prevDetails) => ({
      ...prevDetails,
      ...updatedDetails,
    }));
  };

  const updatePersonalDetails = (updatedDetails) => {
    setPersonalDetails((prevDetails) => ({
      ...prevDetails,
      ...updatedDetails,
    }));
  };

  const handleMenuClick = (event, menu) => {
    setActiveMenu(menu);
  };

  const [bgImage, setBgImage] = useState(
    ProfessionalEdited?.coverPic || bg_image
  );
  const [selectedBgFile, setSelectedBgFile] = useState(null);
  const [selectedBgImage, setSelectedBgImage] = useState(null);
  const bgImageRef = useRef(null);
  const [openRectCropper, setOpenRectCropper] = useState(false);

  const handleRectCropperClose = () => {
    setOpenRectCropper(false);
    setSelectedBgFile(null);
    setSelectedBgImage(null);
  };

  const handleBgImageChange = async (event) => {
    const file = event.target.files[0];

    if (file) {
      const formData = new FormData();
      formData.append("cover_pic", file);
      formData.append("first_name", userDetails.firstName);
      formData.append("last_name", userDetails.lastName);

      const response = await dispatch(
        postProfessionalCoverImageReducer(formData)
      );
      if (response?.payload?.statusCode === 200) {
        // settriggeredApi((prevState) => ({
        //   ...prevState,
        //   professionalInfo: true
        // }));

        const updatedDetails = await dispatch(getProfessionalInfoReducer());

        if (updatedDetails?.payload?.statusCode === 200) {
          setBgImage(updatedDetails?.payload?.data?.user_cover_url);
          setProfessionalEdited((prevState) => ({
            ...prevState,
            coverPic: updatedDetails?.payload?.data?.user_cover_url,
          }));
        }
        return;
      }

      // await handleBlobUpload(file, setBgImage, (url) => updatePersonalDetails({ coverPic: url }), 'cover');
      // const imageUrl = URL.createObjectURL(file);
      // setSelectedBgImage(imageUrl);
      // setSelectedBgFile(file);
      // setOpenRectCropper(true);
      // bgImageRef.current.value = null; // Reset the file input value
    } else {
    }
  };

  const handleBlobUpload = async (file, stateUpdate, contextUpdate, type) => {
    if (!file) {
      console.error("No File to upload");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("profile_pic", file);
      formData.append("first_name", userDetails.firstName);
      formData.append("last_name", userDetails.lastName);
      const response = await dispatch(
        postProfessionalProfileImageReducer(formData)
      );
      if (response?.payload?.statusCode === 200) {
        // settriggeredApi((prevState) => ({
        //   ...prevState,
        //   professionalInfo: true
        // }));

        const response = await dispatch(getProfessionalInfoReducer());

        if (response?.payload?.statusCode === 200) {
          setprofilePicturePersonal(response?.payload?.data?.user_profile_url);
          setProfessionalEdited((prevState) => ({
            ...prevState,
            profilePic: response?.payload?.data?.user_profile_url,
          }));
        }
        setSelectedFile(null);
        setSelectedImage(null);
      }
    } catch (error) {
      console.error("Error uploading file:", error.message);
      alert("Error uploading file. Please check the console for details.");
    }
  };

  if (!objectId) {
    objectId = localStorage.getItem("objectId");
  } else {
    localStorage.setItem("objectId", objectId);
  }

  const [openCropper, setOpenCropper] = useState(false);
  const handleCropClose = () => {
    setOpenCropper(false);
    setSelectedFile(null);
    setSelectedImage(null);
  };
  const avatarStyles = {
    bgcolor: "#F4F7FE",
    width: isSmallLaptop ? "8rem" : "10rem", // Adjust size based on screen width
    height: isSmallLaptop ? "8rem" : "10rem",
  };
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const profilePicRef = useRef(null);
  const [profilePicturePersonal, setprofilePicturePersonal] = useState(
    ProfessionalEdited?.profilePic || userDetails?.proFile
  );

  useEffect(() => {
    if (professionaProfile) {
      setJobFormValues({
        tagName: professionaProfile?.tag_name || "",
        preferredRole: professionaProfile?.preferred_role || "",
        preferredLocation: professionaProfile?.preferred_location || "",
        preferredWorkMode: professionaProfile?.preferred_work_mode || "",
        showBadge: professionaProfile.show_badge || false,
        isVisibleRecruiter: Boolean(professionaProfile?.is_visible_recruiter), // Ensure boolean
      });
    }
  }, [professionaProfile]);

  const handleProfilePicChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      // const formData = new FormData();
      // formData.append("cover_pic", file);
      // formData.append("first_name", userDetails.firstName);
      // formData.append("last_name", userDetails.lastName);

      // dispatch(getProfessionalProfileImageReducer(formData));

      // return
      const imageUrl = URL.createObjectURL(file);
      setSelectedImage(imageUrl);
      setSelectedFile(file);
      setOpenCropper(true);
      profilePicRef.current.value = null; // Reset the file input value
    } else {
      // Handle the cancel action here if needed
    }
  };

  const handleSaveCroppedImage = (croppedFile) => {
    handleBlobUpload(
      croppedFile,
      setprofilePicturePersonal, // Update profile picture state
      (url) => setProfessionalDetails((prev) => ({ ...prev, profilePic: url })), // Update context
      "profile" // Specify type (could be 'cover' for cover pic)
    );
  };

  const handleSaveBgImage = async (croppedFile) => {
    await handleBlobUpload(
      croppedFile,
      setBgImage,
      (url) => updateProfessionalDetails({ coverPic: url }),
      "cover"
    );
  };

  const DefaultLanguages = [
    "Assamese",
    "Bengali",
    "English",
    "Gujarati",
    "Hindi",
    "Kannada",
    "Kashmiri",
    "Konkani",
    "Maithlli",
    "Malayalam",
    "Marathi",
    "Odia",
    "Punjabi",
    "Sanskrit",
    "Sindhi",
    "Tamil",
    "Telugu",
    "Urdu",
  ];
  const [anchorEl, setAnchorEl] = useState(null);
  const [subMenuOpen, setSubMenuOpen] = useState(false);
  const [opportunitiesMenuOpen, setOpportunitiesMenuOpen] = useState(false);
  const [hiringMenuOpen, setHiringMenuOpen] = useState(false);
  const [anchorElMore, setAnchorElMore] = useState(null);
  const [anchorElView, setAnchorElView] = useState(null);
  const [viewOptions, setViewOptions] = useState(
    ProfessionalEdited?.isFieldVisible
  );

  const [showViewOptions, setShowViewOptions] = useState(true);

  // const viewOptionsOrder = [
  //   "companyName",
  //   "companyWebsite",
  //   "designation",
  //   "department",
  //   "professionalEmail",
  //   "phoneNumber",C
  //   "companyAddress",
  // ];

  const viewOptionsOrder = [
    "CompanyName",
    "CompanyWeb", // Ensure key matches `viewOptions`
    "Designation",
    "Department",
    "CompanyEmail",
    "CompanyPhone",
    "CompanyAddress",
  ];

  const disabledFields = ["professionalEmail", "phoneNumber"];

  useEffect(() => {
    if (ProfessionalData) {
      const updatedFields = {
        Designation: Boolean(ProfessionalData?.is_designation_visible),
        Department: Boolean(ProfessionalData?.is_dept_visible),
        CompanyName: Boolean(ProfessionalData?.is_company_visible),
        CompanyAddress: Boolean(ProfessionalData?.is_address_public),
        CompanyWeb: Boolean(ProfessionalData?.is_website_visible),
        CompanyEmail: Boolean(ProfessionalData?.is_professional_email_visible),
        CompanyPhone: Boolean(ProfessionalData?.is_phone_visible),
      };

      setViewOptions((prev) => ({
        ...prev,
        ...updatedFields, // Update only when `ProfessionalEdited` changes
      }));
    }
  }, [ProfessionalData]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    dispatch(getJobAnalytics());
    dispatch(getAppliedJobs());
    dispatch(getOpenJobs());
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSubMenuOpen(false);
  };

  const handleSubMenuClick = () => {
    setSubMenuOpen(!subMenuOpen);
  };

  const handleOpportunitiesMenu = () => {
    setOpportunitiesMenuOpen(!opportunitiesMenuOpen);
  };

  const handleHiringClick = () => {
    // Filter currently working experiences
    const currentExperiences =
      ProfessionalExperience?.filter(
        (exp) => exp.is_currently_working === true && exp.is_verified
      ) || [];



    // Check if there are any current experiences
    if (currentExperiences?.length > 0) {
      setHiringMenuOpen(!hiringMenuOpen);
    } else {
      // setAlertOpen(true);
      openSnackbar(
        "You need to be verified and currently employed to post a job",
        "warning"
      );
      setActiveMenu("experience");
      handleClose(); // Close any open menus
    }
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleMoreClick = (event) => {
    setAnchorElMore(event.currentTarget);
  };

  const [initialTab, setInitialTab] = useState("Recommended");

  const handleAddSectionClick = (event) => {
    event.stopPropagation();
    setInitialTab("Recommended");
    setOpenAddMoreSection(true);
  };

  // const handleServiceAdd = (newService) => {
  //   setServices((prevState) => ({
  //     ...prevState,
  //     yourservices: [...prevState.yourservices, newService],
  //   }));
  // };

  // const updateServicesDetails = (updatedDetails) => {
  //   setServicess((prevDetails) => ({
  //     ...prevDetails,
  //     ...updatedDetails,
  //   }));
  // };
  const handleEditServicesClick = (event) => {
    event.stopPropagation();
    // updateServicesDetails(services);
    setInitialTab("Add Services");
    setOpenAddMoreSection(true);
  };

  const handleMoreClose = () => {
    setAnchorElMore(null);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editIndexEducation, setEditIndexEdu] = useState(null);
  const [DeleteEducation, setDeleteEducation] = useState(false);

  const [aboutOpen, setAboutOpen] = useState(false);
  const [professionOpen, setprofessionOpen] = useState(false);
  const [isSkillEdit, setisSkillEdit] = useState({
    softSkills: false,
    profSkills: false,
    profTools: false,
  }); // object state to track editing of the 3 different skill types
  const [isLanguageEdit, setisLanguageEdit] = useState(false);

  const [selectLanguage, setSelectLanguage] = useState(profLanguages || []);
  const [openModalSkills, setOpenModalSkills] = useState({
    softSkills: false,
    profSkills: false,
    profTools: false,
  });
  const [openModalLanguage, setOpenLanguage] = useState(false);

  const [verifyEduModal, setVerifyEduModal] = useState(false);
  const [verifyExpModal, setVerifyExpModal] = useState(false);
  const [verifyCertModal, setVerifyCertModal] = useState(false);

  const handleEditSkillChange = (skillsList) => {
    setisSkillEdit((prevState) => ({
      ...prevState,
      [skillsList]: !prevState[skillsList],
    }));
  };

  const handleAddSkill = (skill, skillsKey) => {
    if (skill.trim() === "") {
      return;
    }
    const skillsList = Skills[skillsKey];
    const isSkillSelected = skillsList?.includes(skill);

    let updatedSkills;
    if (isSkillSelected) {
      // Remove the skill if it is already selected
      updatedSkills = skillsList.filter(
        (selectedSkill) => selectedSkill !== skill
      );
      // openSnackbar("Skill already in the list!", "info");
      // return;
    } else {
      // Add the skill if it is not already selected
      updatedSkills = [...skillsList, skill];
    }

    // Correctly update the state with the dynamic key
    setSkills((prevDetails) => ({
      ...prevDetails,
      [skillsKey]: updatedSkills,
    }));

    if (!isSkillEdit[skillsKey]) {
      setisSkillEdit((prevEdit) => ({
        ...prevEdit,
        [skillsKey]: true,
      }));
    }
  };

  const handleManualAddSkill = (skill, skillsKey) => {
    if (skill.trim() === "") {
      return;
    }
    const skillsList = Skills[skillsKey];
    const isSkillSelected = skillsList?.includes(skill);

    let updatedSkills;
    if (!isSkillSelected) {
      updatedSkills = [...skillsList, skill];
      setSkills((prevDetails) => ({
        ...prevDetails,
        [skillsKey]: updatedSkills,
      }));

      if (!isSkillEdit[skillsKey]) {
        setisSkillEdit((prevEdit) => ({
          ...prevEdit,
          [skillsKey]: true,
        }));
      }
    } else {
      handleInfo("Skill is already in the list.");
    }
  };

  const handleOpenSkillsModal = (skillsList) => {
    setOpenModalSkills((prevState) => ({
      ...prevState,
      [skillsList]: true,
    }));
  };

  const handleCloseSkillsModal = (skillsList) => {
    setOpenModalSkills((prevState) => ({
      ...prevState,
      [skillsList]: false,
    }));
  };

  const handleAddLanguage = (Language) => {
    if (Language.trim() === "") {
      return;
    }
    const isLanguageSelected = profLanguages.includes(Language);

    let updatedLanguages;
    // If the Language is selected, remove it from the array
    if (isLanguageSelected) {
      updatedLanguages = profLanguages.filter(
        (selectedLanguage) => selectedLanguage !== Language
      );
    } else {
      // If the Language is not selected, add it to the array
      updatedLanguages = [...profLanguages, Language];
    }

    updatePersonalDetails({ personalLanguages: updatedLanguages });
    if (isLanguageEdit === false) {
      setisLanguageEdit(true);
    }
  };

  // OTP States and functions
  const [emailOtp, setEmailOtp] = useState("");
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [emailOtpSeconds, setEmailOtpSeconds] = useState(60); // Seconds for Email OTP Verification
  const [isEmailTimerActive, setIsEmailTimerActive] = useState(true);
  const [verifyOtpModal, setVerifyOtpModal] = useState(false);
  const [verifyOtpConfig, setVerifyOtpConfig] = useState({
    // Config state for OTP Verification to dynamically work for education, experience, etc.
    setVerifyModal: undefined, // function that controls open/close of the respective verify modal
    section: "", // string that represents which section item is being verified
    email: "", // email to which the OTP is sent
    entityId: "", // id of the item being verified
    sendOtpFunction: undefined, // function that triggers OTP to respective section,
    getEntityFunction: undefined, // function that calls the GET API of that entity (education, experience, etc.)
  });

  useEffect(() => {
    let interval;
    if (isEmailTimerActive && !isEmailVerified) {
      interval = setInterval(() => {
        setEmailOtpSeconds((prevSeconds) => {
          if (prevSeconds > 0) return prevSeconds - 1;
          setIsEmailTimerActive(false);
          clearInterval(interval);
          return 0;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isEmailTimerActive, isEmailVerified]);

  useEffect(() => {
    let interval;
    if (isPhoneTimerActive && !isEmailVerified) {
      interval = setInterval(() => {
        setPhoneOtpSeconds((prevSeconds) => {
          if (prevSeconds > 0) return prevSeconds - 1;
          setIsPhoneTimerActive(false);
          clearInterval(interval);
          return 0;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isPhoneTimerActive]);

  const handleOpenOtpModal = (setVerifyModalFunction) => {
    setEmailOtp("");
    setEmailOtpSeconds(60);
    setIsEmailVerified(false);
    setEmailError("");
    setIsEmailTimerActive(true);

    if (setVerifyModalFunction) {
      setVerifyModalFunction();
    }

    setVerifyOtpModal(true);
  };

  const verifyProfessionalEmailOtp = async () => {
    if (emailOtpSeconds <= 0) {
      setEmailError("Current OTP has expired. Click Resend.");
      return;
    }
    try {
      const response = await axios.post(
        "onboard/twofactor-verify-otp",
        { email: ProfessionalEdited?.CompanyEmail, otp: professionalEmailOtp },
        { headers: headers }
      );

      if (response?.status === 200) {
        handleSuccess("Email Verified through OTP!");
        setEmailError("");
        setEmailOtpSeconds(0);
        setIsEmailTimerActive(false);
        setProfessionalEmailOtp("");

        // Update the verification status for email
        setProfessionalEdited(prev => ({
          ...prev,
          isVerified: {
            ...prev.isVerified,
            CompanyEmail: true
          }
        }));

        setIsProfessioanlEmailVerified(true);

        // Start phone verification if phone number exists
        if (ProfessionalEdited?.CompanyPhone) {
          sendPhoneOtp(ProfessionalEdited?.CompanyPhone);
        }
      }
    } catch (error) {
      console.log("Failed to verify Email OTP", error);
      if (error?.response?.status === 404) {
        handleFailure("Please enter valid OTP");
      }
    }
  };

  const verifyPhoneOtp = async (phoneNo) => {
    if (phoneOtpSeconds <= 0) {
      setPhoneError("Current OTP time has expired. Click on Resend.");
      return;
    }
    try {
      const response = await axios.post(
        "/mail/verify-mobile-otp",
        { mobileNumber: phoneNo, otp: Number(phoneOtp) },
        { headers: headers }
      );

      if (response.status === 200) {
        console.log("Phone OTP verified!");

        // Update the verification status for phone
        setProfessionalEdited(prev => ({
          ...prev,
          isVerified: {
            ...prev.isVerified,
            CompanyPhone: true
          }
        }));

        setIsPhoneVerified(true);
        setPhoneError("");
        setPhoneOtpSeconds(0);
        setIsPhoneTimerActive(false);
        setOpenFamilyVerify(false);
        setIsPhoneNumberVerified(true);

        handleSuccess("Phone Number Verified!");
      }
    } catch (error) {
      setPhoneError("Invalid Phone OTP. Try Again.");
      // console.log("Failed to verify Phone OTP", error);
      if (error?.response?.status === 400) {
        handleFailure("Please enter valid OTP.");
      }
    }
  };

  const verifyEmailOtp = async () => {
    if (emailOtpSeconds <= 0) {
      setEmailError("Current OTP has expired. Click Resend.");
      return;
    }
    try {
      const response = await axios.post(
        "onboard/twofactor-verify-otp",
        { email: verifyOtpConfig?.email, otp: emailOtp },
        { headers: headers }
      );
      if (response?.status === 200) {
        const updateResponse = await axios.post(
          "userprofile/verify/by-otp",
          {
            entityId: verifyOtpConfig.entityId,
            section: verifyOtpConfig.section.toLowerCase(),
          },
          { headers: headers }
        );

        if (updateResponse?.data?.status === "SUCCESS") {
          if (verifyOtpConfig.section.toLowerCase() === "experience") {
            setCurrentExperience({
              ...currentExperience,
              isVerified: Boolean(true),
            });
            // await handleAddExperience();
            setIsEmailVerified(true);
            setLightBoxExperience(true);
            await dispatch(getExperienceReducer());
          } else if (verifyOtpConfig.section.toLowerCase() === "education") {
            setCurrentEducation({
              ...currentEducation,
              isVerified: Boolean(true),
            });
            setIsEmailVerified(true);
            setIsModalOpen(true);
            await dispatch(getEducationReducer());
          }

          handleSuccess(`${verifyOtpConfig.section} Verified through OTP!`);

          setEmailError("");
          setEmailOtpSeconds(0);
          setIsEmailTimerActive(false);
          setVerifyOtpModal(false);
          verifyOtpConfig.getEntityFunction();
        }
      }
    } catch (error) {
      // setEmailError("Invalid Email OTP. Try Again.");
      console.log("Failed to verify Email OTP", error);
    }
  };

  const [eduErrors, setEduErrors] = useState({
    eduLevel: false,
    universityName: false,
    institute: false,
    instituteDomain: false,
    startYear: false,
    fieldofStudy: false,
    degree: false,
    endYear: false,
    endYearInvalid: false,
    institute_email: false,
  });

  const requiredFieldsEdu = [
    "eduLevel",
    "universityName",
    "institute",
    "instituteDomain",
    "startYear",
    "endYear",
  ];

  const EDUCATION_CORE_FIELDS = [
    "eduLevel", "instituteDomain", "universityName", "fieldofStudy",
    "institute", "degree", "grade", "startYear", "endYear",
    "isCurrentlyPursuing", "description",
  ];

  // const updateCurrentEducation = (updatedField) => {
  //   setCurrentEducation((prevEducation) => {
  //     const isVerifiedShouldReset = Object.keys(updatedField).some((key) =>
  //       EDUCATION_CORE_FIELDS.includes(key)
  //     );
  //     return {
  //       ...prevEducation,
  //       ...updatedField,
  //       ...(isVerifiedShouldReset ? { isVerified: false } : {}),
  //     };
  //   });
  // }

  const updateCurrentEducation = (updatedField) => {
    setCurrentEducation((prevEducation) => {
      const isVerifiedShouldReset =
        prevEducation.isVerified && // only bother if currently verified
        Object.keys(updatedField).some((key) => {
          if (!EDUCATION_CORE_FIELDS.includes(key)) return false;
          // Only reset if the value actually changed
          return updatedField[key] !== prevEducation[key];
        });

      return {
        ...prevEducation,
        ...updatedField,
        ...(isVerifiedShouldReset ? { isVerified: false } : {}),
      };
    });
  };

  const isCollege =
    currentEducation?.eduLevel === "UG" ||
    currentEducation?.eduLevel === "PG" ||
    currentEducation?.eduLevel === "HigherEd";

  const handleChangeEducationItems = (fieldName) => (event) => {
    const newValue = event.target.value;
    const updatedField = { [fieldName]: newValue };
    const updatedEducation = { ...currentEducation, ...updatedField };

    // Always update the experience state with the new value first
    updateCurrentEducation(updatedField);
    setEduErrors({
      ...eduErrors,
      [fieldName]: false,
    });



    // Validate date range only if both startYear and endYear are provided
    const startYearProvided =
      updatedEducation.startYear && updatedEducation.startYear !== "";
    const endYearProvided =
      updatedEducation.endYear && updatedEducation.endYear !== "";

    let isValidDateRange = true;

    if (startYearProvided && endYearProvided) {
      isValidDateRange = validateDateRange(
        updatedEducation.startYear,
        undefined,
        updatedEducation.endYear
      );
    }

    // Set errors based on validation
    setEduErrors((prevErrors) => ({
      ...prevErrors,
      endYearInvalid: !isValidDateRange && endYearProvided,
    }));


    if (fieldName === 'institute_email') {
      setEduErrors((prevErrors) => ({
        ...prevErrors,
        institute_email: newValue && !emailRegex.test(newValue)
      }));
    }

  };

  const handleEduCheckbox = (event) => {
    const checked = event.target.checked;
    updateCurrentEducation({ isCurrentlyPursuing: checked });
    if (checked) {
      updateCurrentEducation({ endYear: "Present" });
      setEduErrors((prevState) => ({
        ...prevState,
        endYearInvalid: false,
      }));
    } else {
      updateCurrentEducation({ endYear: "" });
    }
  };

  const resetCurrentEducation = () => {
    setCurrentEducation({
      id: "",
      instlogo: { name: "", type: "", data: "" },
      certificatepic: { name: "", type: "", data: "" },
      eduLevel: "",
      universityName: "",
      fieldofStudy: "",
      institute: "",
      degree: "",
      grade: "",
      startYear: "",
      endYear: "",
      description: "",
      isPublic: true,
      fullName: userDetails.name || "",
      studentId: "",
      verifyMethod: "",
      studentEmailId: "",
      adminEmailId: "",
      verifyDoc: { name: "", type: "", data: "" },
      isVerified: false,
    });
    setEduErrors({
      eduLevel: false,
      universityName: false,
      institute: false,
      instituteDomain: false,
      fieldofStudy: false,
      degree: false,
      startYear: false,
      endYear: false,
      endYearInvalid: false,
    });
  };

  // Autocomplete Variables, States, and Functions
  const [selectedUniversity, setSelectedUniversity] = useState(null);
  const [selectedInstitute, setSelectedInstitute] = useState(null);
  const [selectedInstituteDomain, setSelectedInstituteDomain] = useState(null);
  const [filteredColleges, setFilteredColleges] = useState([]);
  const [filteredUniversities, setFilteredUniversities] = useState([]);
  const EducationBlob = useSelector(
    (state) => state?.ProfileArray?.educationBlob
  );
  const CertificateBlob = useSelector(
    (state) => state?.ProfileArray?.certificateBlob
  );
  const ExperienceBlob = useSelector(
    (state) => state?.ProfileArray?.experienceBlob
  );
  const [offset, setOffset] = useState({
    colleges: 0,
    universities: 0,
  });
  const [hasMoreItems, setHasMoreItems] = useState({
    colleges: true,
    universities: true,
  }); // To track if more results are available
  const limit = 20;

  const handleSelectedUniversity = (event, value) => {
    // Handle null values when the field is cleared
    if (!value) {
      setSelectedUniversity(null);
      updateCurrentEducation({ universityName: "" }); // Clear the board/university field in the backend
    } else {
      setSelectedUniversity(value);
      updateCurrentEducation({ universityName: value.name }); // Use the correct field
    }
  };

  const handleSelectedInstitute = (event, value) => {
    if (!value) {
      setSelectedInstitute(null);
      updateCurrentEducation({ institute: "" }); // Clear the board/university field in the backend
    } else {
      setSelectedInstitute(value);
      updateCurrentEducation({ institute: value.college_name });
    }

    if (value && value.university_name) {
      // console.log('Selected option:', value);
      updateCurrentEducation({ universityName: value.university_name });
      setSelectedUniversity({ name: value.university_name });
    } else {
      updateCurrentEducation({ universityName: "" });
      setSelectedUniversity(null);
    }
  };
  // const { handleInfo } = useQuantityContext();

  const handleSearchUniversity = (event, value) => {
    updateCurrentEducation({ universityName: value });
  };

  const handleSearchInstitute = (event, value) => {
    updateCurrentEducation({ institute: value });
  };

  const fetchCollegesList = async () => {
    try {
      const reqObject = {
        search: currentEducation.institute,
        limit: limit,
        offset: offset.colleges,
      };
      const response = await callApiFunction("getCollegesList", reqObject);

      if (response.status === "SUCCESS") {
        const allColleges = response.data.colleges;

        // If less than 20 colleges are fetched, no more data is available
        if (allColleges?.length < limit) {
          setHasMoreItems((prevState) => ({ ...prevState, colleges: false }));
        }

        setFilteredColleges((prevColleges) => [
          ...prevColleges,
          ...allColleges,
        ]);
      } else {
        console.error("Failed to fetch college data.");
      }
    } catch (err) {
      console.error("An error occurred while fetching college data.", err);
    }
  };

  const fetchUniversitiesList = async () => {
    try {
      // const response = await callApiFunction("getUniversitiesList", { limit: 3000, offset: 0 });
      const response = await dispatch(
        UniversityReducer({
          search: currentEducation?.universityName,
          limit: 3000,
          offset: 0,
        })
      );
      if (response?.payload?.status === "SUCCESS") {
        const allUniversities = response?.payload?.data?.universities;

        // If less than 20 colleges are fetched, no more data is available
        if (allUniversities?.length < limit) {
          setHasMoreItems((prevState) => ({
            ...prevState,
            universities: false,
          }));
        }

        setFilteredUniversities((prevUniversities) => [
          ...prevUniversities,
          ...allUniversities,
        ]);
      } else {
        console.error("Failed to fetch University data.");
      }
    } catch (err) {
      console.error("An error occurred while fetching university data.", err);
    }
  };

  // const fetchUniversitiesList = async () => {
  //   const localStorageKey = "universities_Listdata";

  //   try {
  //     // Check LocalStorage first
  //     // const storedData = localStorage.getItem(localStorageKey);
  //     // if (storedData) {
  //     //   setFilteredUniversities(JSON.parse(storedData));
  //     //   setHasMoreItems((prevState) => ({ ...prevState, universities: false }));
  //     //   return;
  //     // }

  //     // Fetch from API
  //     // const response = await callApiFunction("getUniversitiesList", { limit: 3000, offset: 0 });
  //     const response = await dispatch(UniversityReducer({ limit: 3000, offset: 0 }));
  //     // console.log("universities data", response);
  //     if (response?.payload?.status === "SUCCESS") {
  //       const newUniversities = response?.payload?.data?.universities;
  //       console.log("universities data", newUniversities);
  //       // Store in LocalStorage
  //       const storedData = localStorage.getItem(localStorageKey);
  //       const parsedData = storedData ? JSON.parse(storedData) : [];
  //       const updatedData = [...parsedData, ...newUniversities];
  //       // localStorage.setItem(localStorageKey, JSON.stringify(updatedData));

  //       // Update State
  //       setFilteredUniversities((prevUniversities) => [
  //         ...prevUniversities,
  //         ...newUniversities,
  //       ]);

  //       // Check if more data is available
  //       if (newUniversities.length < 3000) {
  //         setHasMoreItems((prevState) => ({
  //           ...prevState,
  //           universities: false,
  //         }));
  //       }
  //     } else {
  //       console.error("Failed to fetch University data.");
  //     }
  //   } catch (err) {
  //     console.error("An error occurred while fetching university data.", err);
  //   }
  // };

  useEffect(() => {
    if (offset?.universities > 0) {
      fetchUniversitiesList();
    }
  }, [offset.universities]);

  const loadMoreUniversities = () => {
    setOffset((prevOffset) => ({
      ...prevOffset,
      universities: prevOffset.universities + 3000,
    }));
  };

  // Scroll event handler to detect if the user has reached the bottom of the dropdown
  const handleDropdownScroll = (event, listName = "colleges") => {
    const bottom =
      event.target.scrollHeight - event.target.scrollTop ===
      event.target.clientHeight;

    if (bottom && hasMoreItems[listName]) {
      // Increment the offset for the correct list (colleges or universities)
      setOffset((prevOffset) => ({
        ...prevOffset,
        [listName]: prevOffset[listName] + limit, // Increment the correct offset key
      }));
    }
  };

  // useEffect(() => {
  //   if (offset.colleges === 0) return; // Don't fetch data initially unless there's a search
  //   fetchCollegesList();
  // }, [offset.colleges]); // Trigger fetch when colleges offset changes

  // useEffect(() => {
  //   const debounceSearch = setTimeout(() => {
  //     setFilteredColleges([]); // Clear previous results
  //     setOffset((prevOffset) => ({ ...prevOffset, colleges: 0 })); // Reset offset for new search
  //     setHasMoreItems((prevState) => ({ ...prevState, colleges: true })); // Reset hasMoreItems flag
  //     fetchCollegesList(); // Initial fetch for new search term
  //   }, 300);

  //   return () => clearTimeout(debounceSearch);
  // }, [currentEducation.institute]);

  // useEffect for when Universities search term changes
  useEffect(() => {
    const debounceSearch = setTimeout(() => {
      setFilteredUniversities([]); // Clear previous results
      setOffset((prevOffset) => ({ ...prevOffset, universities: 0 })); // Reset offset for new search
      setHasMoreItems((prevState) => ({ ...prevState, universities: true })); // Reset hasMoreItems flag
      fetchUniversitiesList();
    }, 300);

    return () => clearTimeout(debounceSearch);
  }, [currentEducation.universityName]);

  const areEduFieldsFilled = (stage) => {
    // Stage can be add (general details form) or verify (verification form)
    if (stage === "add") {
      let requiredFields = [...requiredFieldsEdu];

      // Add 'fieldofStudy' and 'institute' only if the education level is not 'SSLC'
      if (currentEducation.eduLevel !== "SSLC") {
        requiredFields = [...requiredFields, "fieldofStudy", "degree"];
      }

      return requiredFields.every((field) => currentEducation[field]);
    } else if (stage === "verify") {
      const requiredFields = ["studentId", "verifyMethod"];

      const isCommonFieldsFilled = requiredFields.every(
        (field) => currentEducation[field]
      );

      if (!isCommonFieldsFilled) return false;

      // Check fields based on the selected verifyMethod
      if (currentEducation.verifyMethod === "studentEmailId") {
        return currentEducation.studentEmailId !== "";
      } else if (currentEducation.verifyMethod === "adminEmailId") {
        return currentEducation.adminEmailId !== "";
      } else if (currentEducation.verifyMethod === "verifyDoc") {
        return (
          currentEducation?.verifyDoc && currentEducation.verifyDoc.data !== ""
        );
      }

      return false;
    }
  };

  const handleVerifyEdu = () => {
    setIsModalOpen(false);
    setVerifyEduModal(true);
  };

  const handleVerifyEduCancel = () => {
    setVerifyEduModal(false);
    setIsModalOpen(true);
  };

  const handleVerifyEduButton = () => {
    if (currentEducation?.verifyMethod === "studentEmailId") {
      verifyEduByOtp();
    } else if (currentEducation?.verifyMethod === "adminEmailId") {
      verifyEduByAdmin();
    }
  };

  const verifyEduByOtp = async () => {
    try {
      handleInfo("Sending OTP to your Institute E-mail...");
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-second-otp`,
        { email: currentEducation?.institute_email },
        // { email: currentEducation?.studentEmailId },
        { headers: headers }
      );

      if (response.status === 200) {
        handleSuccess("OTP sent to your Institute E-mail");
        setVerifyOtpConfig({
          email: currentEducation.institute_email,
          // email: currentEducation.studentEmailId,
          entityId: currentEducation.id,
          section: "Education",
          sendOtpFunction: () => verifyEduByOtp(),
          // getEntityFunction: () => getAPIs.getEducation()
        });
        handleOpenOtpModal(() => setVerifyEduModal(false));
        await dispatch(getEducationReducer());
      }
    } catch (error) {
      console.log("Failed to send OTP: ", error);
      handleFailure("Failed to send OTP. Try again later.");
    }
  };

  const verifyEduByAdmin = async () => {
    try {
      // const endpoint = "entityVerifyByAdmin";
      // const verifyEduAttachments =
      //   currentEducation?.verifyDoc?.map((attachment) => ({
      //     name: attachment?.name || "", // Provide default values if fields are missing
      //     type: attachment?.type || "",
      //     data: attachment?.data || "",
      //   })) || [];

      // Default to an empty array if verifyDocs is undefined
      // const payload = {
      //   entityId: currentEducation?.id,
      //   fullName: currentEducation?.fullName || userDetails?.name,
      //   // uniqueId: currentEducation?.studentId,
      //   adminEmail: currentEducation?.adminEmailId,
      //   attachments: verifyEduAttachments, // Array since backend expects an array only
      //   section: "education"
      // }

      // const formData = new FormData();

      // formData.append("entityId", payload.entityId);
      // formData.append("fullName", payload.fullName);
      // formData.append("uniqueId", payload.uniqueId);
      // formData.append("adminEmail", payload.adminEmail);
      // formData.append("section", payload.section);

      // // Handling `attachments` array properly
      // if (Array.isArray(payload.attachments)) {
      //   payload.attachments.forEach((file, index) => {
      //     formData.append(`attachments[${index}]`, {
      //       uri: file.uri,
      //       name: file.name || `attachment_${index}.jpg`,
      //       type: file.type || "image/jpeg",
      //     });
      //   });
      // }

      const formData = new FormData();
      formData.append("entityId", currentEducation?.id);
      formData.append(
        "fullName",
        currentEducation?.fullName || userDetails?.name
      );
      formData.append("uniqueId", currentEducation?.studentId);
      formData.append("adminEmail", currentEducation?.adminEmailId);
      formData.append("adminName", userDetails?.name);
      formData.append("section", "education");


      if (currentEducation?.verifyDoc) {
        setLoading(true);
        handleInfo("Please wait to complete the process.");

        try {
          let attachmentsArray = Array.isArray(currentEducation.verifyDoc)
            ? currentEducation.verifyDoc
            : [currentEducation.verifyDoc]; // Ensure it's an array

          for (let i = 0; i < attachmentsArray?.length; i++) {
            const fileData = attachmentsArray[i].data;
            const fileName =
              attachmentsArray[i].name || `attachment_${Date.now()}.pdf`;
            const fileType = attachmentsArray[i].type;

            if (fileData instanceof File || fileData instanceof Blob) {
              formData.append("attachments", fileData, fileName);
            } else if (
              typeof fileData === "string" &&
              fileData.startsWith("blob:")
            ) {
              // Convert Blob URL to a File object
              const response = await fetch(fileData);
              const blob = await response.blob();

              const file = new File([blob], fileName, { type: fileType });

              formData.append("attachments", blob, fileName);
            } else {
              console.warn("Skipping invalid attachment:", fileData);
            }
          }

        } catch (error) {
          console.error("Error processing attachments:", error);
        }

        setLoading(false);
      }

      const formDataObject = {};
      formData.forEach((value, key) => {
        formDataObject[key] = value;
      });

      handleInfo("Sending Mail to your Institute Admin...");
      // const response = await callApiFunction(endpoint, payload);
      const response = await dispatch(postVerifyByAdminReducer(formData));

      if (response?.payload?.statusCode === 200) {
        handleSuccess("Verification Mail sent to your Institute Admin");
        setVerifyEduModal(false);
        setIsModalOpen(true);
        updateCurrentEducation({
          isVerified: false,
          verifyMethod: "",
          fullName: userDetails?.name,
          studentId: "",
          verifyDoc: { name: "", type: "", data: "" },
        });
      }
    } catch (error) {
      console.log("Error sending verification mail:", error);
      handleFailure("Could not send the verification mail. Try again later.");
    }
  };

  // Certificate States and Functions

  const [certErrors, setCertErrors] = useState({
    organName: false,
    organDomain: false,
    courseName: false,
    certifiMonth: false,
    certifiYear: false,
    certificatePDF: false,
  });
  const CERTIFICATE_CORE_FIELDS = [
    "organName", "organDomain", "courseName", "certificateLink",
    "certifiDetails", "certifiMonth", "certifiYear",
  ];

  const updateCurrentCertificate = (updatedField) => {
    setcurrentCertificate((prevCertificate) => {
      const isVerifiedShouldReset = Object.keys(updatedField).some((key) =>
        CERTIFICATE_CORE_FIELDS.includes(key)
      );
      return {
        ...prevCertificate,
        ...updatedField,
        ...(isVerifiedShouldReset ? { isVerified: false } : {}),
      };
    });
  };

  const handleCertifiItems = (fieldName) => (event) => {
    const newValue = event.target.value;
    const updatedField = { [fieldName]: newValue };
    // Always update the certificate state with the new value first
    updateCurrentCertificate(updatedField);
    setCertErrors({
      ...certErrors,
      [fieldName]: false,
    });
  };

  const handleEditCertificate = (certificate, index) => {
    setSelectedCertificate(null); // reset autocomplete
    setSelectedCertificateDomain(null); // reset domain autocomplete
    setSearchItems([]); // prevent stale dropdown

    setcurrentCertificate({
      id: certificate?.id || "",
      certificateLogo: {
        name: certificate?.certificate_logo ? "Certificate Logo" : "",
        type: "image/png",
        data: certificate?.certificate_logo || "",
      },
      certificatePDF: {
        name: certificate?.certificate_doc ? "Certificate PDF" : "",
        // type: "image/png",
        type: getDocumentType(certificate?.certificate_doc),
        data: certificate?.certificate_doc || "",
      },
      organName: certificate?.organisation_name || "",
      organDomain: certificate?.organisation_domain || "",
      courseName: certificate?.course_name || "",
      certificateLink: certificate?.certificate_link || "",
      certifiDetails: certificate?.description || "",
      certifiMonth: certificate?.issue_date || "",
      certifiYear: certificate?.year || null,
      isPublic: certificate?.is_public || false,
      isVerified: certificate?.is_verified || false,
      fullName: certificate?.created_by || "",
      verifyMethod: "",
      orgEmailId: certificate?.organisation_domain || "",
      verifyDoc: { name: "", type: "", data: "" },
    });

    setEditCertificateIndex(index);
    // console.log("editCertificateIndex set to:", index)
    setLightBoxCertificate(true);
  };

  const handleVerifyCertificateModal = (certificate, index) => {
    setcurrentCertificate({
      id: certificate?.id || "",
      certificateLogo: {
        name: certificate?.certificate_logo ? "Certificate Logo" : "",
        type: "image/png",
        data: certificate?.certificate_logo || "",
      },
      certificatePDF: {
        name: certificate?.certificate_doc ? "Certificate PDF" : "",
        type: "image/png",
        data: certificate?.certificate_doc || "",
      },
      organName: certificate?.organisation_name || "",
      organDomain: certificate?.organisation_domain || "",
      courseName: certificate?.course_name || "",
      certificateLink: certificate?.certificate_link || "",
      certifiDetails: certificate?.description || "",
      certifiMonth: certificate?.issue_date || "",
      certifiYear: certificate?.year || null,
      isPublic: certificate?.is_public || false,
      isVerified: certificate?.is_verified || false,
      fullName: certificate?.created_by || "",
      verifyMethod: "",
      orgEmailId: certificate?.organisation_domain || "",
      verifyDoc: { name: "", type: "", data: "" },
    });
    setVerifyCertModal(true);
  };

  // console.log("currentCertificatecurrentCertificate", currentCertificate);

  const resetCurrentCertificate = () => {
    setcurrentCertificate({
      id: "",
      certificateLogo: { name: "", type: "", data: "" },
      certificatePDF: { name: "", type: "", data: "" },
      organName: "",
      organDomain: "",
      certificateLink: "",
      courseName: "",
      certifiDetails: "",
      certifiMonth: "",
      certifiYear: null,
      isPublic: true,
      isVerified: false,
      fullName: "",
      verifyMethod: "",
      orgEmailId: "",
      verifyDoc: { name: "", type: "", data: "" },
    });
    setCertErrors({
      organName: false,
      organDomain: false,
      courseName: false,
      certifiMonth: false,
      certifiYear: false,
    });
  };

  const requiredFieldsCert = [
    "organName",
    "organDomain",
    "certificatePDF",
    "courseName",
    "certifiMonth",
    "certifiYear",
  ];

  const areCertFieldsFilled = (stage) => {
    if (stage === "add") {
      const requiredFields = requiredFieldsCert;

      return requiredFields.every((field) => {
        if (field === "certificatePDF") {
          // Check if the certificatePDF object has data
          return (
            currentCertificate[field] &&
            currentCertificate[field].data &&
            currentCertificate[field].data !== ""
          );
        }
        return currentCertificate[field] && currentCertificate[field] !== "";
      });
    } else if (stage === "verify") {
      const commonFields = ["verifyMethod"];

      const isCommonFieldsFilled = commonFields.every(
        (field) => currentCertificate[field]
      );

      if (!isCommonFieldsFilled) return false;

      // Check fields based on the selected verifyMethod
      if (currentCertificate.verifyMethod === "orgEmailId") {
        return currentCertificate.orgEmailId !== "";
      } else if (currentCertificate.verifyMethod === "verifyDoc") {
        return (
          currentCertificate?.verifyDoc &&
          currentCertificate.verifyDoc.data !== ""
        );
      }

      return false;
    }
  };

  const handleVerifyCert = () => {
    setLightBoxCertificate(false);
    setVerifyCertModal(true);
  };

  const handleVerifyCertCancel = () => {
    setVerifyCertModal(false);
    setLightBoxCertificate(true);
  };

  const handleVerifyCertButton = () => {
    // setVerifyCertModal(false);
    // setLightBoxCertificate(true);
    // updateCurrentCertificate({
    //   isVerified: true,
    //   verifyMethod: "",
    //   fullName: "",
    // });

    if (currentCertificate?.verifyMethod === "orgEmailId") {
      // console.log("currentCertificatecurrentCertificate", currentCertificate);
      verifyCertByAdmin();
    }
  };

  const verifyCertByAdmin = async () => {
    try {
      const endpoint = "entityVerifyByAdmin";
      // const verifyCertAttachments =
      //   currentCertificate?.verifyDoc?.map((attachment) => ({
      //     name: attachment?.name || "", // Provide default values if fields are missing
      //     type: attachment?.type || "",
      //     data: attachment?.data || "",
      //   })) || []; // Default to an empty array if verifyDocs is undefined

      const verifyCertAttachments = currentCertificate?.verifyDoc
        ? [currentCertificate.verifyDoc]
        : [];

      // const payload = {
      //   entityId: currentCertificate?.id,
      //   fullName: currentCertificate?.fullName || userDetails?.name,
      //   uniqueId: currentCertificate?.certificateLink,
      //   adminEmail: currentCertificate?.orgEmailId,
      //   attachments: verifyCertAttachments, // Array since backend expects an array only
      //   section: "certificate",
      // };

      const formData = new FormData();

      formData.append("entityId", currentCertificate?.id);
      formData.append("fullName", currentCertificate?.fullName || userDetails?.name);
      formData.append("uniqueId", currentCertificate?.certificateLink);
      formData.append("adminEmail", currentCertificate?.orgEmailId);
      formData.append("section", "certificate");

      // ✅ Handle attachments properly

      for (let item of verifyCertAttachments) {
        if (item?.data?.startsWith("blob:")) {
          const blob = await fetch(item.data).then(res => res.blob());
          const file = new File([blob], item.name, { type: item.type });

          formData.append("attachments", blob);
        } else if (item instanceof File) {
          formData.append("attachments", item);
        }
      }
      handleInfo("Sending Mail to Organization Admin...");
      const response = await dispatch(postVerifyByAdminReducer(formData));

      if (response?.payload?.statusCode === 200) {
        handleSuccess("Verification Mail sent to Organization Admin");
        setVerifyCertModal(false);
        setLightBoxCertificate(true);
        updateCurrentCertificate({
          isVerified: false,
          verifyMethod: "",
          fullName: userDetails.name,
          verifyDoc: { name: "", type: "", data: "" },
        });
      }
    } catch (error) {
      console.log("Error sending verification mail:", error);
      handleFailure("Could not send the verification mail. Try again later.");
    }
  };

  const handleEditEducation = (education, index) => {
    // console.log("Education INformation", education);
    const mappedEducation = {
      id: education?.id || "",
      instlogo: { name: "", type: "", data: education?.logo_link || "" },
      certificatepic: {
        name: "",
        type: "",
        data: education?.certificate_link || "",
      },
      eduLevel: education?.educational_level || "",
      instituteDomain: education?.institute_domain || "",
      universityName: education?.board || "",
      fieldofStudy: education?.field_of_study || "",
      institute: education?.institute_name || "",
      degree: education?.degree || "",
      grade: education?.percentage || "",
      startYear: education?.start_year || "",
      endYear: education?.is_pursuing ? "Present" : education?.end_year || "",
      isCurrentlyPursuing: education?.is_pursuing || false,
      description: education?.desc || "",
      isPublic: education?.is_public || true,
      isVerified: education?.is_verified || false,
      verifyMethod: education?.verification_method || "",
      studentEmailId: education?.studentEmailId || "",
      adminEmailId: education?.adminEmailId || "",
      verifyDoc: { name: "", type: "", data: "" },
      fullName: userDetails?.name || "",
      studentId: education?.user_ref_id || "",
      institute_email: education?.institute_email || "",
    };

    setCurrentEducation(mappedEducation);
    setEditIndexEdu(index);
    setIsModalOpen(true);
  };

  const handleVerifyEducationModal = (education, index) => {
    const mappedEducation = {
      id: education?.id || "",
      instlogo: { name: "", type: "", data: education?.logo_link || "" },
      certificatepic: {
        name: "",
        type: "",
        data: education?.certificate_link || "",
      },
      eduLevel: education?.educational_level || "",
      instituteDomain: education?.institute_domain || "",
      universityName: education?.board || "",
      fieldofStudy: education?.field_of_study || "",
      institute: education?.institute_name || "",
      degree: education?.degree || "",
      grade: education?.percentage || "",
      startYear: education?.start_year || "",
      endYear: education?.end_year || "",
      isCurrentlyPursuing: education?.is_pursuing || false,
      description: education?.desc || "",
      isPublic: education?.is_public || true,
      isVerified: education?.is_verified || false,
      verifyMethod: education?.verification_method || "",
      studentEmailId: education?.studentEmailId || "",
      adminEmailId: education?.adminEmailId || "",
      verifyDoc: { name: "", type: "", data: "" },
      fullName: userDetails?.name || "",
      studentId: education?.user_ref_id || "",
      institute_email: education?.institute_email || "",
    };

    setCurrentEducation(mappedEducation);
    setVerifyEduModal(true);
  };

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  // const handleInputChange = (field) => (event) => {
  //   if (field === "CompanyPhone") {
  //     setProfessionalEdited({
  //       ...ProfessionalEdited,
  //       [field]: event,
  //     });
  //   } else {

  //     if (field === "CompanyEmail") {
  //       setEmailError(!emailRegex.test(value));
  //     }

  //     setProfessionalEdited({
  //       ...ProfessionalEdited,
  //       [field]: event.target.value,
  //     });
  //   }
  // };

  // const handleProfessionDetSave = () => {
  //   setProfessionalDetails({ ...ProfessionalEdited });
  //   setprofessionOpen(false);
  // };

  // const handleInputChange = (field) => (event) => {
  //   let value = field === "CompanyPhone" ? event : event.target.value;

  //   // For phone field, remove all spaces immediately
  //   if (field === "CompanyPhone") {
  //     // If event is a string (from MuiTelInput), clean it
  //     if (typeof event === 'string') {
  //       value = event.replace(/\s+/g, '');
  //     }
  //   }
  // // 
  //   if (field === "CompanyEmail") {
  //     setEmailError(!emailRegex.test(value));
  //   }

  //   setProfessionalEdited({
  //     ...ProfessionalEdited,
  //     [field]: value,
  //   });
  // };

  const handleInputChange = (field) => (event) => {
    let value = field === "CompanyPhone" ? event : event.target.value;

    // For phone field, remove all spaces immediately
    if (field === "CompanyPhone") {
      if (typeof event === 'string') {
        value = event.replace(/\s+/g, '');
      }
    }

    // Email validation
    if (field === "CompanyEmail") {
      setEmailError(!emailRegex.test(value));
    }

    // Reset verification status when email or phone is changed
    if (field === "CompanyEmail" || field === "CompanyPhone") {
      setProfessionalEdited(prev => {
        const updatedField = { [field]: value };

        // Reset the specific field's verification status
        const updatedIsVerified = {
          ...prev.isVerified,
          [field === "CompanyEmail" ? "CompanyEmail" : "CompanyPhone"]: false
        };

        // Also update the main isVerified flag if both are now false
        const bothUnverified = !updatedIsVerified.CompanyEmail && !updatedIsVerified.CompanyPhone;

        return {
          ...prev,
          ...updatedField,
          isVerified: updatedIsVerified
        };
      });

      // Also update the main ProfessionalData?.is_verified if needed
      // This will be handled when saving
    } else {
      setProfessionalEdited({
        ...ProfessionalEdited,
        [field]: value,
      });
    }
  };
  //   const handleInputChange = (field) => (event) => {
  //   const value = field === "CompanyPhone" ? event : event.target.value;

  //   if (field === "CompanyEmail") {
  //     setEmailError(!emailRegex.test(value));
  //   }

  //   if (field === "CompanyPhone") {
  //     // Extract digits only
  //     const digits = value.replace(/\D/g, '');

  //     // Expecting "+91" followed by exactly 10 digits => total 12 digits
  //     const isValid = digits.startsWith('91') && digits.length === 12;

  //     setPhoneError(!isValid);

  //     if (!isValid) {
  //       return; // Stop updating state if phone number is invalid
  //     }
  //   }

  //   setProfessionalEdited({
  //     ...ProfessionalEdited,
  //     [field]: value,
  //   });
  // };


  const handleEditClick = () => {
    const {
      Designation,
      Department,
      CompanyName,
      CompanyWeb,
      CompanyEmail,
      CompanyAddress,
      CompanyPhone,
      StartDate,
      EndDate,
      isCurrentlyWorking,
      isVerified,
      isFieldVisible, //  Keep isFieldVisible when updating state
    } = ProfessionalEdited;

    setProfessionalEdited({
      Designation,
      Department,
      CompanyName,
      CompanyWeb,
      CompanyEmail,
      CompanyAddress,
      CompanyPhone,
      StartDate,
      EndDate,
      isCurrentlyWorking,
      isVerified,
      isFieldVisible, //  Ensure visibility settings persist
    });

    setprofessionOpen(!professionOpen);
  };

  // const getProfFieldValue = (field) => professionOpen ? ProfessionalEdited[field] : ProfessionalEdited[field];

  const handleCheckboxMyProfile = (event) => {
    const checked = event.target.checked;
    updateProfessionalEdited({ isCurrentlyWorking: checked });
    if (checked) {
      updateProfessionalEdited({ EndDate: "" });
    }
  };

  const handleViewOptionsClick = (event) => {
    setAnchorElView(event.currentTarget);
  };

  const handleViewMenuClose = () => {
    setAnchorElView(null);
  };

  // const handleViewCheckboxChange = (event) => {
  //   setViewOptions({
  //     ...viewOptions,
  //     [event.target.name]: event.target.checked,
  //   });
  // };

  const handleViewCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setViewOptions((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 1970 + 1 },
    (_, index) => currentYear - index
  );

  // ----------------- State and Functions for Project ---------------------
  const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);
  const [isEditProject, setIsEditProject] = useState(false);

  const resetProjectDetails = () => {
    setProjectDetails({
      id: "",
      projectName: "",
      projectDescription: "",
      startMonth: "",
      startYear: "",
      endMonth: "",
      endYear: "",
      currentlyWorking: false,
      attachments: [],
    });
  };
  const handleProjectAddMore = () => {
    setEditProjectIndex(null);
    resetProjectDetails();
    setIsProjectModalOpen(true);
  };

  const handleEditProject = (index) => {
    setEditProjectIndex(index);
    updateProjectDetails(sortedProjectList[index]);
    setIsProjectModalOpen(true);


  };

  // ----------------- State and Functions for Awards -------------------------

  const [awardEditIndex, setAwardEditIndex] = useState(true);

  const [awardDetails, setAwardDetails] = useState({
    id: "",
    award_title: "",
    associated_with: "",
    issuer: "",
    issue_month: "",
    issue_year: "",
    description: "",
    attachments: [],
    isPublic: false,
  });

  const resetAwardsDetails = () => {
    setAwardDetails({
      id: "",
      award_title: "",
      associated_with: "",
      issuer: "",
      issue_month: "",
      issue_year: "",
      description: "",
      attachments: [],
      isPublic: false,
    });
  };
  // const updateAwardsAttachments = (newAttachment) => {
  //   setAwardDetails((prevState) => ({
  //     ...prevState,
  //     awardAttachments: [...prevState.awardAttachments, newAttachment],
  //   }));
  // };

  const updateAwardsDetails = (updatedDetails) => {
    setAwardDetails((prevState) => ({
      ...prevState,
      ...updatedDetails,
    }));
  };
  const [isAwardsModalOpen, setIsAwardsModalOpen] = useState(false);

  const handleAwardsAddMore = () => {
    setAwardEditIndex(null);
    resetAwardsDetails();
    setIsAwardsModalOpen(true);
  };

  // const handleEditAwards = (index) => {
  //   setAwardEditIndex(() => index);
  //   console.log("Awards index id", index);
  //   updateAwardsDetails(ProfessionalAwards[index]);
  //   setIsAwardsModalOpen(true);
  // };

  const handleEditAwards = (index) => {
    const selectedAward = sortedAwardsList[index]; // Using sorted list

    setAwardEditIndex(index);
    updateAwardsDetails(selectedAward);
    setIsAwardsModalOpen(true);
  };

  // console.log("currentExperience", currentExperience);
  const [expErrors, setExpErrors] = useState({
    companyName: false,
    companyDomain: false,
    location: false,
    locationType: false,
    roleTitle: false,
    employmentType: false,
    startMonth: false,
    startYear: false,
    endMonth: false,
    endYear: false,
    endMonthInvalid: false,
    endYearInvalid: false,
    companylogo: false,
  });

  const EXPERIENCE_CORE_FIELDS = [
    "companyName", "companyDomain", "roleTitle", "employmentType",
    "location", "locationType", "startMonth", "startYear",
    "endMonth", "endYear", "isCurrentlyWorking", "details", "responsibility",
  ];

  const updateCurrentExperience = (updatedField) => {
    setCurrentExperience((prevExperience) => {
      const isVerifiedShouldReset = Object.keys(updatedField).some((key) =>
        EXPERIENCE_CORE_FIELDS.includes(key)
      );

      return {
        ...prevExperience,
        ...updatedField,
        // Only set isVerified to false if a core data field was changed
        ...(isVerifiedShouldReset ? { isVerified: false } : {}),
      };
    });
  };

  const [responsibilityInput, setResponsibilityInput] = useState("");

  const handleAddChip = (event, input, field) => {
    const keyPressed = event.key;
    const inputValue = input.trim();

    // Only handle 'Enter' or ',' keys when there's input to add
    if ((keyPressed === "Enter" || keyPressed === ",") && inputValue) {
      event.preventDefault(); // Prevent default before updating state
      setCurrentExperience((prevState) => {
        const fieldValue = prevState[field];
        if (Array.isArray(fieldValue)) {
          return {
            ...prevState,
            [field]: [...fieldValue, inputValue],
          };
        } else {
          console.error(`${field} is not an array.`);
          return prevState;
        }
      });
      setResponsibilityInput("");
    }
  };

  const handleDeleteChip = (field, chipToDelete) => {
    setCurrentExperience((prevState) => ({
      ...prevState,
      [field]: prevState[field].filter((chip) => chip !== chipToDelete),
    }));
  };

  const kpiOptions = [
    "API Response Time",
    "Average Order Fulfillment Time",
    "Average Resolution Time",
    "A/B Test Results",
    "Annual Revenue Growth",
    "Audience Retention Rate",
    "Bounce Rate",
    "Brand Awareness Metrics",
    "Budget Variance",
    "Bug Fix Rate",
    "Candidate Satisfaction Score",
    "Click-Through Rate (CTR)",
    "Close Rate (Sales Conversion Rate)",
    "Code Quality",
    "Code Review Efficiency",
    "Code Velocity",
    "Conversion Rate from Content",
    "Conversion Rate from Design Changes",
    "Cost per Acquisition (CPA)",
    "Cost Reduction Ratio",
    "Customer Acquisition Cost (CAC)",
    "Customer Feedback Volume",
    "Customer Lifetime Value (CLV)",
    "Customer Retention Rate",
    "Customer Satisfaction Score (CSAT)",
    "Database Optimization",
    "Deliverable Timeliness",
    "Employee Satisfaction Rate",
    "Employee Turnover Rate",
    "Error Rate",
    "First Call Resolution Rate",
    "Feature Adoption Rate",
    "Financial Forecast Accuracy",
    "Gross Profit Margin",
    "Hiring Time (Time to Hire)",
    "Incident Response Time",
    "Inventory Turnover Ratio",
    "Lead Conversion Rate",
    "Leads Generated from Content",
    "Mean Time Between Failures (MTBF)",
    "Monthly Sales Quota Achievement",
    "Net Promoter Score (NPS)",
    "On-Time Delivery Rate",
    "Operating Cash Flow",
    "Page Load Speed",
    "Profitability Ratio",
    "Return on Assets (ROA)",
    "Return on Equity (ROE)",
    "Sales Revenue per Rep",
    "Server Uptime",
    "Sprint Completion Rate",
    "Time to Market",
    "Unit Test Coverage",
    "User Feedback Rating",
  ];

  const handleExperienceItems = (fieldName) => (event) => {
    const newValue = event.target.value;
    const updatedField = { [fieldName]: newValue };
    const updatedExperience = { ...currentExperience, ...updatedField };

    // Always update the experience state with the new value first
    updateCurrentExperience(updatedField);
    setExpErrors({
      ...expErrors,
      [fieldName]: false,
    });

    // Validate date range only if both startYear and endYear are provided
    const startYearProvided =
      updatedExperience.startYear && updatedExperience.startYear !== "";
    const endYearProvided =
      updatedExperience.endYear && updatedExperience.endYear !== "";
    const startMonthProvided =
      updatedExperience.startMonth && updatedExperience.startMonth !== "";
    const endMonthProvided =
      updatedExperience.endMonth && updatedExperience.endMonth !== "";

    let isValidDateRange = true;

    if (startYearProvided && endYearProvided) {
      isValidDateRange = validateDateRange(
        updatedExperience.startYear,
        updatedExperience.startMonth,
        updatedExperience.endYear,
        updatedExperience.endMonth
      );
    }

    // Set errors based on validation
    setExpErrors((prevErrors) => ({
      ...prevErrors,
      endMonthInvalid: !isValidDateRange && endMonthProvided,
      endYearInvalid: !isValidDateRange && endYearProvided,
    }));
  };

  const [editExperienceIndex, setEditExperienceIndex] = useState(null);
  const [deleteExperience, setdeleteExperience] = useState(false);

  const resetCurrentExperience = () => {
    setCurrentExperience({
      id: "",
      companylogo: { name: "", type: "", data: "" },
      companyName: "",
      companyDomain: "",
      location: "",
      locationType: "",
      roleTitle: "",
      employmentType: "",
      details: "",
      startMonth: "",
      startYear: "",
      endMonth: "",
      endYear: "",
      responsibility: [],
      headline: "",
      isCurrentlyWorking: false,
      isPublic: true,
      isVerified: false,
      fullName: userDetails.name,
      employeeId: "",
      verifyMethod: "",
      hrName: "",
      hrEmail: "",
      workEmail: "",
      verifyDocs: [],
      contentMethod: "",
      verifyDocEml: { name: "", type: "", data: "" },
      verifyDocImgPdf: { name: "", type: "", data: "" },
      verifyDocAny: { name: "", type: "", data: "" },
    });
    setExpErrors({
      companyName: false,
      companyDomain: false,
      location: false,
      locationType: false,
      roleTitle: false,
      employmentType: false,
      startMonth: false,
      startYear: false,
      endMonth: false,
      endYear: false,
      endMonthInvalid: false,
      endYearInvalid: false,
    });
  };

  const requiredFieldsExp = [
    "companyName",
    "companyDomain",
    "location",
    "roleTitle",
    "startMonth",
    "startYear",
    "endMonth",
    "endYear",
    "companylogo",
  ];

  const areExpFieldsFilled = (stage) => {
    if (stage === "add") {
      const requiredFields = requiredFieldsExp;

      return requiredFields.every((field) => {
        if (field === "companylogo") {
          // Check if logo data exists
          return currentExperience[field] &&
            currentExperience[field].data &&
            currentExperience[field].data !== "";
        }
        return currentExperience[field] && currentExperience[field] !== "";
      });
    } else if (stage === "verify") {
      const commonFields = ["employeeId", "verifyMethod"];

      const isCommonFieldsFilled = commonFields.every(
        (field) => currentExperience[field]
      );

      if (!isCommonFieldsFilled) return false;
      else {
        // Check fields based on the selected verifyMethod
        if (currentExperience.verifyMethod === "hrEmail")
          return currentExperience.hrEmail;
        else if (currentExperience.verifyMethod === "currentOtp") {
          return currentExperience.workEmail;
        } else if (currentExperience.verifyMethod === "verifyDoc") {
          return (
            currentExperience?.verifyDocAny &&
            currentExperience.verifyDocAny?.data !== ""
          );
        } else if (currentExperience.verifyMethod === "previousHr") {
          if (currentExperience.contentMethod === "pdfImage")
            return (
              currentExperience?.verifyDocImgPdf &&
              currentExperience.verifyDocImgPdf?.data !== ""
            );
          else if (currentExperience.contentMethod === "eml")
            return (
              currentExperience?.verifyDocEml &&
              currentExperience.verifyDocEml?.data !== ""
            );
        }
      }
    }
  };

  const handleCheckboxExperience = (event) => {
    const checked = event.target.checked;
    updateCurrentExperience({ isCurrentlyWorking: checked });
    if (checked) {
      updateCurrentExperience({ endMonth: "Present", endYear: "Present" });
      setExpErrors((prevState) => ({
        ...prevState,
        endMonthInvalid: false,
        endYearInvalid: false,
      }));
    } else {
      updateCurrentExperience({ endMonth: "", endYear: "" });
    }
  };

  const handleEditExperience = (experience, index) => {
    setCurrentExperience({
      id: experience?.id || "",
      companylogo: { name: "", type: "", data: experience?.company_logo || "" }, // Handle logo
      companyDomain: experience?.company_domain || "",
      companyName: experience?.company_name || "",
      company_email: experience?.company_email || "",
      location: experience?.location || "",
      locationType: experience?.location_type || "",
      roleTitle: experience?.role_title || "",
      employmentType: experience?.employee_type || "",
      details: experience?.details || "",
      startMonth: experience?.start_month || "",
      startYear: experience?.start_year || "",
      endMonth: experience?.is_currently_working
        ? "Present"
        : experience?.end_month || "",
      endYear: experience?.is_currently_working
        ? "Present"
        : experience?.end_year || "",
      responsibility: experience?.responsibility
        ? experience.responsibility?.split(", ").filter(Boolean) // Convert to an array
        : [],
      headline: experience?.profile_headline || "",
      isCurrentlyWorking: experience?.is_currently_working || false,
      isPublic: experience?.is_public || true,
      isVerified: experience?.is_verified || false,
      fullName: userDetails.name, // Keeping this same
      employeeId: experience?.employee_id || "",
      verifyMethod: "",
      hrName: "",
      hrEmail: "",
      workEmail: "",
      verifyDocs: [],
      contentMethod: "",
      verifyDocEml: { name: "", type: "", data: "" },
      verifyDocImgPdf: { name: "", type: "", data: "" },
      verifyDocAny: { name: "", type: "", data: "" },
      profile_headline: experience?.profile_headline,
    });

    setEditExperienceIndex(index);
    setLightBoxExperience(true);
  };

  const handleVerifyExperienceModal = (experience, index) => {
    setCurrentExperience({
      id: experience?.id || "",
      companylogo: { name: "", type: "", data: experience?.company_logo || "" }, // Handle logo
      companyDomain: experience?.company_domain || "",
      companyName: experience?.company_name || "",
      location: experience?.location || "",
      locationType: experience?.location_type || "",
      roleTitle: experience?.role_title || "",
      employmentType: experience?.employee_type || "",
      details: experience?.details || "",
      startMonth: experience?.start_month || "",
      startYear: experience?.start_year || "",
      endMonth: experience?.end_month || "",
      endYear: experience?.end_year || "",
      responsibility: experience?.responsibility
        ? experience.responsibility?.split(", ").filter(Boolean) // Convert to an array
        : [],
      headline: experience?.profile_headline || "",
      isCurrentlyWorking: experience?.is_currently_working || false,
      isPublic: experience?.is_public || true,
      isVerified: experience?.is_verified || false,
      fullName: userDetails.name, // Keeping this same
      employeeId: experience?.employee_id || "",
      verifyMethod: "",
      hrName: "",
      hrEmail: "",
      workEmail: "",
      verifyDocs: [],
      contentMethod: "",
      verifyDocEml: { name: "", type: "", data: "" },
      verifyDocImgPdf: { name: "", type: "", data: "" },
      verifyDocAny: { name: "", type: "", data: "" },
      company_email: experience?.company_email || "",
    });
    setVerifyExpModal(true);
  };

  const handleVerifyExp = () => {
    setLightBoxExperience(false);
    setVerifyExpModal(true);
  };

  const handleVerifyExpCancel = () => {
    setVerifyExpModal(false);
    setLightBoxExperience(true);
    setIsEmailValid(false);
  };

  const updateVerifyExpDocs = (newAttachment) => {
    const attachmentWithId = { ...newAttachment, id: uuidv4() };
    setCurrentExperience((prevState) => ({
      ...prevState,
      verifyDocs: [...(prevState.verifyDocs || []), attachmentWithId],
    }));
  };

  const removeVerifyExpDoc = (id) => {
    setCurrentExperience((prevState) => ({
      ...prevState,
      verifyDocs: prevState.verifyDocs.filter(
        (attachment) => attachment?.id !== id
      ),
    }));
  };

  const handleVerifyExpButton = () => {
    // setVerifyExpModal(false);
    // setLightBoxExperience(true);
    // updateCurrentExperience({
    //   isVerified: true,
    //   verifyMethod: "",
    //   fullName: "",
    //   employeeId: "",
    // });
    if (currentExperience.verifyMethod === "currentOtp") {
      verifyExpByOtp();
      setIsEmailValid(false);
    } else if (currentExperience.verifyMethod === "hrEmail") {
      verifyExpByHr();
      setIsEmailValid(false);
    }
  };

  const verifyExpByOtp = async () => {
    try {
      handleInfo("Sending OTP to your Work E-mail");
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-second-otp`,
        { email: currentExperience.company_email },
        // { email: currentExperience.workEmail },
        { headers: headers }
      );

      if (response.status === 200) {
        handleSuccess("OTP sent to your Work E-mail");
        setVerifyOtpConfig({
          email: currentExperience.company_email,
          // email: currentExperience.workEmail,
          entityId: currentExperience.id,
          section: "Experience",
          sendOtpFunction: () => verifyExpByOtp(),
          // getEntityFunction: () => getAPIs.getExperiences()
        });
        await dispatch(getExperienceReducer());
        handleOpenOtpModal(() => setVerifyExpModal(false));
      }
    } catch (error) {
      console.log("Failed to send OTP: ", error);
      handleFailure("Failed to send OTP. Try again later.");
    }
  };

  const verifyExpByHr = async () => {
    try {
      const endpoint = "entityVerifyByAdmin";
      // Map the verifyDocs array to ensure correct structure
      const verifyExpAttachments =
        currentExperience?.verifyDocs?.map((attachment) => ({
          name: attachment.name || "", // Provide default values if fields are missing
          type: attachment.type || "",
          data: attachment.data || "",
        })) || []; // Default to an empty array if verifyDocs is undefined
      // const payload = {
      //   entityId: currentExperience.id,
      //   fullName: currentExperience.fullName || userDetails.name,
      //   uniqueId: currentExperience.employeeId,
      //   adminEmail: currentExperience.hrEmail,
      //   adminName: currentExperience.hrName, // new name
      //   attachments: verifyExpAttachments, // already an array
      //   section: "experience", // section_slug from backend
      // };

      const formData = new FormData();

      formData.append("entityId", currentExperience.id);
      formData.append("fullName", currentExperience.fullName || userDetails.name);
      formData.append("uniqueId", currentExperience.employeeId);
      formData.append("adminEmail", currentExperience.hrEmail);
      formData.append("adminName", currentExperience.hrName);
      formData.append("section", "experience");

      for (let item of verifyExpAttachments) {
        if (item?.data?.startsWith("blob:")) {
          const blob = await fetch(item.data).then(res => res.blob());
          const file = new File([blob], item.name, { type: item.type });

          formData.append("attachments", blob);
        } else if (item instanceof File) {
          formData.append("attachments", item);
        }
      }
      handleInfo("Sending Mail to your Company HR...");
      const response = await dispatch(postVerifyByAdminReducer(formData));
      // console.log("RESPONSEEEERESPONSEEEE", response);
      if (response?.payload?.statusCode === 200) {
        handleSuccess("Verification Mail sent to your Company HR");
        setVerifyExpModal(false);
        setLightBoxExperience(true);
        updateCurrentExperience({
          isVerified: false,
          fullName: userDetails.name,
          employeeId: "",
          verifyMethod: "",
          hrName: "",
          hrEmail: "",
          workEmail: "",
          verifyDocs: [],
          contentMethod: "",
        });
      }
    } catch (error) {
      console.log("Error sending verification mail:", error);
      handleFailure("Could not send the verification mail. Try again later.");
    }
  };

  const getDocumentType = (url) => {
    if (!url) return '';

    // Strip query parameters
    const cleanUrl = url.split('?')[0];

    // Get extension
    const extension = cleanUrl.split('.').pop().toLowerCase();

    switch (extension) {
      case 'pdf':
        return 'application/pdf';
      case 'png':
        return 'image/png';
      case 'jpg':
      case 'jpeg':
        return 'image/jpeg';
      default:
        return '';
    }
  };

  useEffect(() => {
    if (currentExperience?.company_email) {
      validateEmail(
        currentExperience.company_email,
        currentExperience.companyDomain
      );
    } else {
      setIsEmailValid(false);
    }
  }, [currentExperience?.company_email, verifyExpModal]);

  useEffect(() => {
    if (currentEducation?.institute_email) {
      validateEmail(
        currentEducation?.institute_email,
        currentEducation.instituteDomain
      );
    } else {
      setIsEmailValid(false);
    }
  }, [currentEducation?.institute_email, verifyEduModal]);


  const validateEmail = (email, domainInput) => {
    const domainOnlyRegex = /^[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/;

    const extractDomain = (input) => {
      try {
        if (!/^https?:\/\//i.test(input)) {
          input = "http://" + input;
        }
        const parsedDomain = new URL(input).hostname;
        return parsedDomain
          .replace(/^www\./, "")
          .toLowerCase()
          .trim();
      } catch (err) {
        return null;
      }
    };

    if (!email) {
      setIsEmailValid(false);
      return false;
    }

    const emailCleaned = email.trim().toLowerCase();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(emailCleaned)) {
      setIsEmailValid(false);
      return false;
    }

    const emailDomain = emailCleaned.split("@")[1].trim().toLowerCase();
    const extractedDomain = extractDomain(domainInput);

    if (!extractedDomain || !domainOnlyRegex.test(extractedDomain)) {
      console.error("Invalid domain input:", domainInput);
      setIsEmailValid(false);
      return false;
    }



    const isValid = emailDomain === extractedDomain;

    setIsEmailValid(isValid);
    return isValid;
  };

  const renderVerifyExpFields = (method) => {
    if (method === "hrEmail") {
      return <></>;
    } else if (method === "previousHr") {
      return (
        <>
          <TextField
            name="contentMethod"
            label="Content Method"
            value={currentExperience.contentMethod}
            onChange={handleExperienceItems("contentMethod")}
            fullWidth
            select
            helperText="Choose the format that best suits the content you're providing for verification."
          >
            <MenuItem value="pdfImage">Email as PDF and Image Format</MenuItem>
            <MenuItem value="eml">Email as EML Format</MenuItem>
          </TextField>
          {currentExperience.contentMethod === "pdfImage" && (
            <FileDragUploadWithContext
              label="Upload Verification Document"
              maxSize={5}
              inputId="verifyExpDoc1"
              contextKey="verifyDocImgPdf"
              context={currentExperience}
              updateContext={updateCurrentExperience}
              accept={["image/jpeg", "image/png", "application/pdf"]}
            />
          )}
          {currentExperience.contentMethod === "eml" && (
            <FileDragUploadWithContext
              label="Upload Verification Document"
              maxSize={5}
              inputId="verifyExpDoc2"
              contextKey="verifyDocEml"
              context={currentExperience}
              updateContext={updateCurrentExperience}
              accept={["eml", "message/rfc822"]}
            />
          )}
        </>
      );
    } else if (method === "verifyDoc") {
      return (
        <FileDragUploadWithContext
          label="Upload Verification Document"
          maxSize={5}
          inputId="verifyExpDoc3"
          contextKey="verifyDocAny"
          context={currentExperience}
          updateContext={updateCurrentExperience}
          accept={["image/jpeg", "image/png", "application/pdf"]}
        />
      );
    }
  };

  /* All the Function Required for Resume and File Section */
  const [isModalResume, setisModalResume] = useState(false);
  const [selectedResume, setSelectedResume] = useState(null);
  const [deleteResume, setDeleteResume] = useState(false);
  const [selectedVideoResume, setSelectedVideoResume] = useState(null);
  const [deleteVideoResume, setDeleteVideoResume] = useState(false);
  const [resumeAlert, setResumeAlert] = useState(false);
  const [resumeAlertConfig, setResumeAlertConfig] = useState({
    title: "ALERT",
    message: "",
    cancelFn: undefined,
    continueFn: undefined,
    continueLabel: "Continue",
  });

  const openResumeAlert = (config) => {
    setResumeAlertConfig(config);
    setResumeAlert(true);
  };

  const closeAlertDialog = () => {
    setResumeAlert(false);
  };

  // const handleOpenResumeComponent = () => {
  //   setisModalResume(true);
  // };

  const handleOpenResumeComponent = () => {
    // Check professional skills
    const professionalSkills = ProfessonalSkills?.skills || [];
    // console.log("NNNNNNN", professionalSkills)
    if (professionalSkills?.length < 4) {
      openSnackbar(
        "Please add at least 4 Professional Skills before creating a resume",
        "warning"
      );
      return;
    }

    // Check if both email and phone exist in PersonalData
    const personalEmail = Personaldata?.personal_email;
    const phoneNumber = Personaldata?.phone_no;

    if (!personalEmail || !phoneNumber) {
      openSnackbar(
        "Please add both email and phone number in your Personal Profile before creating resume",
        "warning"
      );
      return;
    }

    // Check education using sortedEducationList
    if (!sortedEducationList || sortedEducationList?.length < 1) {
      openSnackbar(
        "Please add at least one education detail before creating resume",
        "warning"
      );
      return;
    }

    // If all validations pass, open resume modal
    setisModalResume(true);
  };

  const handleShareResume = (file) => {
    updateShareProfileConfig({
      open: true,
      onClose: () =>
        setShareProfileConfig((prev) => ({ ...prev, open: false })),
      qrCodeUrl: file,
      showQr: false,
      isDownload: true,
      profileType: "Resume",
    });
  };

  const handleResumeAlert = () => {
    setResumeAlert(true);
  };

  const getFileIcon = (filename) => {
    const extension = filename?.split(".").pop().toLowerCase();
    switch (extension) {
      case "pdf":
        return <PdfThumb />;
      case "doc":
      case "docx":
        return <DocxThumb />;
      case "ppt":
      case "pptx":
        return <PptxThumb />;
      case "xls":
      case "xlsx":
        return <ExcelThumb />;
      case "jpg":
      case "jpeg":
      case "png":
        return <FaFileImage style={{ color: "green", fontSize: "2em" }} />;
      default:
        return <FaFileAlt style={{ color: "gray", fontSize: "2em" }} />;
    }
  };

  const visibleFiles = (files) => files.filter((file) => file.visible); // Hide the attached files that are marked invisible
  const inputId = useId();
  const [OpenAddMoreSection, setOpenAddMoreSection] = useState(false);
  const [playing, setPlaying] = useState(false);

  // Functions for Dynamic Add Sections
  const [OtherNewSections, setOtherNewSections] = useState({
    projects: [],
    recommendations: [],
    honorsAndAwards: [],
    languages: [],
    skills: [],
    services: [],
  });

  const formatTime = (time) => {
    if (!time) return "";
    const [hour, minute] = time.split(":");
    const hourNum = parseInt(hour, 10);
    const ampm = hourNum >= 12 ? "PM" : "AM";
    const formattedHour = hourNum % 12 || 12;
    return `${formattedHour}:${minute} ${ampm}`;
  };

  const createObjectURL = (file) => {
    if (file.data.startsWith("http" || "https")) {
      // If the argument file is already a URL
      return file.data;
    }

    const base64ToBlob = (base64, mime) => {
      // If it is base64 encoded
      const byteCharacters = atob(base64);
      const byteNumbers = new Array(byteCharacters?.length);
      for (let i = 0; i < byteCharacters?.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      return new Blob([byteArray], { type: mime });
    };

    const blob = base64ToBlob(file.data, file.type);
    return URL.createObjectURL(blob);
  };

  // const { recentCompanyLogo, recentCompanyName } = getMostRecentExperience();
  // const recentComapanyLogoImg = `data:${recentCompanyLogo?.type};base64,${recentCompanyLogo?.data}`;
  // const { recentUniLogo, recentUniName } = getMostRecentEducation();
  // const recentUniLogoImg = `data:${recentUniLogo?.type};base64,${recentUniLogo?.data}`;

  // const [mostRecentEducation, setMostRecentEducation] = useState({
  //   instlogo: { name: "", type: "", data: ProfessionalEducation[0]?.logo_link || "" },
  //   institute: sortedEducationList[0]?.institute_name || "",
  // });
  // const [mostRecentExperience, setMostRecentExperience] = useState({
  //   companylogo: { name: "", type: "", data: sortedExperienceList[0]?."" },
  //   companyName: "",
  // });

  // const getMostRecentEducation = () => {
  //   if (sortedEducationList?.length === 0) return { instlogo: { name: '', type: '', data: '' }, institute: '' };
  //   const { logo_link, institute_name } = sortedEducationList[0];
  //   return { logo_link, institute_name };
  // };

  // const getMostRecentExperience = () => {
  //   if (ExperienceList.length === 0) return { companylogo: { name: '', type: '', data: '' }, companyName: '' };
  //   const { companylogo, companyName } = ExperienceList[0];
  //   return { companylogo, companyName };
  // };
  // useEffect(() => {
  //   setMostRecentEducation(getMostRecentEducation());
  //   setMostRecentExperience(getMostRecentExperience());
  // }, []); // Re-run this effect whenever the experience or education list changes



  const handleEduAddMore = () => {
    setEditIndexEdu(null);
    resetCurrentEducation();
    setIsModalOpen(true);
  };

  const handleCertAddMore = () => {
    setEditCertificateIndex(null);
    resetCurrentCertificate();
    setLightBoxCertificate(true);
  };

  const handleExpAddMore = () => {
    setEditExperienceIndex(null);
    resetCurrentExperience();
    setLightBoxExperience(true);
  };

  // Helper function to fetch logos from the domain through API
  const fetchLogoFromDomain = async (
    domainField,
    logoProperty,
    updateLogoFunction
  ) => {
    let blobResponse;
    const domain = domainField.includes("@")
      ? domainField.split("@")[1]
      : domainField;
    openSnackbar("Setting Logo...", "info", 20000);
    const logoFromDomain = await axios.get(
      `https://logoapi.onrender.com/logo`,
      {
        params: { domain },
      }
    );

    if (logoFromDomain.data) {
      const fetchedLogo = logoFromDomain.data.logo;
      if (fetchedLogo) {
        const payloadLogo = {
          logo: fetchedLogo, // Include the logo URL
        };

        blobResponse = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url-from-url`,
          payloadLogo,
          { headers: headers }
        );
      }
      const logoBlob = blobResponse?.data.url;
      updateLogoFunction({
        [logoProperty]: {
          name: domainField,
          type: "image/png",
          data: logoBlob,
        },
      });
      return blobResponse?.data.url;
    }
  };

  // API Calling functions
  const handleProfessionalInfoSave = async () => {
    setLoading(true);

    if (!validateDate()) {
      setLoading(false);
      return;
    }

    handleInfo("Please wait to Complete the Process.");
    try {
      const cleanPhoneNumber = ProfessionalEdited?.CompanyPhone?.replace(/\s+/g, '') || '';

      const updatedDetails = {
        first_name: userFirstName,
        last_name: userLastName,
        company_name: ProfessionalEdited?.CompanyName,
        website: ProfessionalEdited?.CompanyWeb,
        department: ProfessionalEdited?.Department,
        designation: ProfessionalEdited?.Designation,
        professional_email: ProfessionalEdited?.CompanyEmail,
        phone_no: cleanPhoneNumber,
        address: ProfessionalEdited?.CompanyAddress,
        start_year: ProfessionalEdited?.StartDate,
        end_year: ProfessionalEdited?.EndDate,
        is_currently_working: ProfessionalEdited?.isCurrentlyWorking,
        is_company_visible: viewOptions?.CompanyName,
        is_designation_visible: viewOptions?.Designation,
        is_dept_visible: viewOptions?.Department,
        is_address_public: viewOptions?.CompanyAddress,
        is_website_visible: viewOptions?.CompanyWeb,
        is_professional_email_visible: viewOptions?.CompanyEmail,
        is_phone_visible: viewOptions?.CompanyPhone,
        // Only set is_verified true if both email and phone are verified
        is_verified: ProfessionalEdited?.isVerified?.CompanyEmail &&
          ProfessionalEdited?.isVerified?.CompanyPhone
      };

      const response = await dispatch(
        postProfessionalProfileReducer(updatedDetails)
      );

      if (response?.payload?.statusCode === 200) {
        const updatedData = await dispatch(getProfessionalInfoReducer());

        if (updatedData?.payload?.statusCode === 200) {
          setProfessionalEdited((prevState) => ({
            ...prevState,
            isFieldVisible: {
              ...prevState.isFieldVisible,
              Designation: Boolean(updatedData?.payload?.data?.is_designation_visible),
              Department: Boolean(updatedData?.payload?.data?.is_dept_visible),
              CompanyName: Boolean(updatedData?.payload?.data?.is_company_visible),
              CompanyAddress: Boolean(updatedData?.payload?.data?.is_address_public),
              CompanyWeb: Boolean(updatedData?.payload?.data?.is_website_visible),
              CompanyEmail: Boolean(updatedData?.payload?.data?.is_professional_email_visible),
              CompanyPhone: Boolean(updatedData?.payload?.data?.is_phone_visible),
            },
            // Preserve verification status from local state
            isVerified: {
              CompanyEmail: ProfessionalEdited?.isVerified?.CompanyEmail || false,
              CompanyPhone: ProfessionalEdited?.isVerified?.CompanyPhone || false
            }
          }));

          setprofessionOpen(false);
          handleSuccess();
        }

        await dispatch(getProfileCompletionReducer());
      }
    } catch (error) {
      console.log("Error saving Professional Info", error);
      handleFailure();
    } finally {
      setLoading(false);
    }
  };
  const getProfFieldValue = (field) =>
    professionOpen ? ProfessionalEdited[field] : ProfessionalEdited[field];

  const validateDate = () => {
    const startDate = new Date(ProfessionalEdited?.StartDate);
    const endDate = new Date(ProfessionalEdited?.EndDate);
    // console.log("Show  date", startDate, endDate);

    // if (!startDate || isNaN(startDate) || !endDate || isNaN(endDate)) {
    //   setDateError("Please enter valid start and end dates.");
    //   return false;
    // }

    if (startDate > endDate) {
      setDateError("Start date cannot be after end date.");
      return false;
    }

    setDateError("");
    return true;
  };

  const handleAboutMeSave = async () => {
    try {
      console.log("AboutMe Save Clicked!");
      const aboutMeText = ProfessionalEdited?.aboutme?.trim();
      const updatedDetails = {
        first_name: userFirstName,
        last_name: userLastName,
        about_me: aboutMeText,
      };
      // await callApiFunction("professionalInfoUpdate", updatedDetails);
      const response = await dispatch(
        postProfessionalProfileReducer(updatedDetails)
      );
      if (response?.payload?.statusCode === 200) {
        await dispatch(getProfessionalInfoReducer()); // Dispatch to update state

        updateProfessionalDetails({ aboutme: aboutMeText });
        setAboutOpen(false);
        handleSuccess();

        // settriggeredApi((prevState) => ({
        //   ...prevState,
        //   professionalInfo: true
        // }));
      }
    } catch (error) {
      console.log("Error saving AboutMe - Professional Info");
      handleFailure();
    }
  };

  const handleAboutMeSwitch = async (event) => {
    const newVisibility = event.target.checked;
    try {
      console.log("AboutMe Switched!");
      const updatedDetails = {
        first_name: userFirstName,
        last_name: userLastName,
        is_about_public: newVisibility,
      };
      // const response = await callApiFunction(
      //   "professionalInfoUpdate",
      //   updatedDetails
      // );
      const response = await dispatch(
        postProfessionalProfileReducer(updatedDetails)
      );
      if (response?.payload?.statusCode === 200) {
        await dispatch(getProfessionalInfoReducer(updatedDetails)); // Dispatch to update state

        // setProfessionalEdited((prevDetails) => ({
        //   ...prevDetails,
        //   isSectionPublicInfo: {
        //     ...prevDetails.isSectionPublic,
        //     Aboutme: newVisibility,
        //   },
        // }));

        isSectionPublicInfo((prevState) => ({
          ...prevState,
          Aboutme: newVisibility,
        }));
      }
    } catch (error) {
      console.log("Error Switching AboutMe - Personal Info");
    }
  };

  const handleSectionSwitch = (keyword, stateProperty) => async (event) => {
    const newVisibility = event.target.checked;
    try {
      console.log(`${keyword} Switched!`);
      const updatedDetails = {
        is_public: newVisibility ? 1 : 0,
        keyword: keyword,
      };
      // const response = await callApiFunction(
      //   "updateVisibility",
      //   updatedDetails
      // );
      const response = await dispatch(
        postPersonalProfileUpdateVisibilityReducer(updatedDetails)
      );
      // console.log("responseresponse", response);
      if (response?.payload?.status === "SUCCESS") {
        if (
          stateProperty === "profSkills" ||
          stateProperty === "softSkills" ||
          stateProperty === "profTools"
        ) {
          await dispatch(getProfessionalSkillsReducer());
        } else if (stateProperty === "services") {
          await dispatch(getServiceReducer());
        }

        isSectionPublicInfo((prevState) => ({
          ...prevState,
          [stateProperty]: newVisibility,
        }));
      }
    } catch (error) {
      console.log(`Error Switching ${keyword}`, error);
    }
  };

  const handleItemSwitch = (section, itemId) => async (event) => {
    const newVisibility = event.target.checked;
    try {
      setLoading(true);

      const updatedDetails = {
        is_public: newVisibility ? 1 : 0,
        keyword: section,
        id: itemId,
      };

      // const response = await callApiFunction(
      //   "updateVisibility",
      //   updatedDetails
      // );
      const response = await dispatch(
        postPersonalProfileUpdateVisibilityReducer(updatedDetails)
      );

      if (response?.payload?.status === "SUCCESS") {
        if (section === PROJECTS) {
          await dispatch(getProjecteReducer());
        } else if (section === AWARDS_HONOUS) {
          await dispatch(getAwardsReducer());
        } else if (section === EDUCATION) {
          await dispatch(getEducationReducer());
        } else if (section === CERTIFICATE) {
          await dispatch(getCertificateReducer());
        } else if (section === EXPERIENCE) {
          await dispatch(getExperienceReducer());
        }
        // sectionSetters[section]((prevList) =>
        //   prevList.map((item) =>
        //     item.id === itemId ? { ...item, isPublic: newVisibility } : item
        //   )
        // );

        if (sectionSetters[section]) {
          sectionSetters[section]((prevList) =>
            prevList.map((item) =>
              item.id === itemId ? { ...item, isPublic: newVisibility } : item
            )
          );
        }
      }
    } catch (error) {
      console.log(
        `Error toggling visibility for ${section} item with ID ${itemId}`,
        error
      );
    } finally {
      setLoading(false);
    }
  };

  const handleSkillsSave = async (stateProperty, sectionKeyword) => {
    try {
      const updatedDetails = {
        data: Skills[stateProperty],
        is_public: isSectionPublicInfo[stateProperty],
        sectionKeyword: sectionKeyword,
      };
      // console.log("Save Clicked ===== updatedDetails:", updatedDetails);

      const response = await dispatch(
        postProfessionalSkillsResucer(updatedDetails)
      );
      // console.log("response response", response);
      if (response?.payload?.statusCode === 200) {
        await dispatch(getProfessionalSkillsReducer());
        setSkills((prevState) => ({
          ...prevState,
          [stateProperty]: updatedDetails.data,
        }));
        setisSkillEdit((prevState) => ({
          ...prevState,
          [stateProperty]: false,
        }));
        handleSuccess();
        // settriggeredApi((prevState) => ({
        //   ...prevState,
        //   professionalSkill: true
        // }));
      }
      // await callApiFunction("profSkillsUpdate", {
      //   ...updatedDetails,
      //   sectionKeyword: sectionKeyword,
      // });
    } catch (error) {
      console.log("Error saving Skills Info");
      handleFailure();
    }
  };

  const handleAddEducation = async (e) => {
    e.preventDefault();
    if (!startSectionSubmit("education")) return;
    setLoading(true);
    const newErrors = { ...eduErrors };

    let requiredFields = [...requiredFieldsEdu];
    if (!currentEducation?.eduLevel || currentEducation.eduLevel !== "SSLC") {
      requiredFields = [...requiredFields, "fieldofStudy", "degree"];
    }

    requiredFields.forEach((field) => {
      if (!currentEducation[field]) {
        newErrors[field] = true;
      } else {
        newErrors[field] = false;
      }
    });

    setEduErrors(newErrors);

    const hasErrors = Object.values(newErrors).some((error) => error);

    if (!hasErrors) {
      const endpoint = "educationCreateUpdate";
      const {
        id,
        instlogo,
        certificatepic,
        instituteDomain,
        eduLevel,
        universityName,
        fieldofStudy,
        institute,
        degree,
        grade,
        startYear,
        endYear,
        isCurrentlyPursuing,
        description,
        isPublic,
        isVerified,
        institute_email,
      } = currentEducation;

      const formData = new FormData();

      // Append each field to the FormData object
      if (id !== undefined && id !== null && id !== "") {
        formData.append("id", id);
      }

      if (institute_email !== undefined && institute_email !== null) {
        formData.append("institute_email", institute_email);
      }

      formData.append("institute_domain", instituteDomain);
      formData.append("educational_level", eduLevel);
      formData.append("board", universityName);
      formData.append("field_of_study", fieldofStudy);
      formData.append("institute_name", institute);
      formData.append("degree", degree);
      formData.append("percentage", grade);
      formData.append("start_year", startYear);
      formData.append(
        "end_year",
        endYear === "Present" ? new Date().getFullYear() : endYear
      );
      formData.append("is_pursuing", isCurrentlyPursuing || false);
      formData.append("desc", description);
      formData.append("is_public", Boolean(isPublic));
      formData.append("is_verified", Boolean(isVerified));


      // Handle file uploads correctly
      // if (instlogo?.data) {
      //   try {
      //     const response = await fetch(instlogo.data);
      //     const blob = await response.blob();
      //     const file = new File([blob], instlogo.name, { type: instlogo.type });

      //     formData.append("logo_file", file);

      //   } catch (error) {
      //     console.error("Error fetching file:", error);
      //   }
      // }

      if (instlogo?.data) {
        // const logoUrl = cardDetails?.logo?.data || cardDetails?.logo;

        if (instlogo?.data.startsWith("blob:")) {
          setLoading(true);
          handleInfo("Please wait to complete the process");

          try {
            const response = await fetch(instlogo?.data);
            const blob = await response.blob();
            // const file = new File([blob], cardDetails?.logo?.name, { type: cardDetails?.logo?.type });
            formData.append("logo_file", blob);
          } catch (error) {
            console.error("Error fetching File", error);
          }

          setLoading(false);
        } else {
          formData.append("logo_url", instlogo?.data);
        }
      }


      if (certificatepic?.data) {
        setLoading(true);
        handleInfo("Please wait to complete the process");
        try {
          const response = await fetch(certificatepic.data);
          const blob = await response.blob();
          const file = new File([blob], certificatepic.name, {
            type: certificatepic.type,
          });

          formData.append("certificate_file", blob);
        } catch (error) {
          console.error("Error fetching file:", error);
        }
        setLoading(false);
        // formData.append("certificate_link", certificatepic.data || "certificate.pdf");
      }

      try {
        // const response = await callApiFunction(endpoint, payload);

        if (editIndexEducation !== null) {
          const response = await dispatch(
            patchProfessionalEducationReducer({ id: id, data: formData })
          );



          if (response?.payload?.statusCode === 200) {
            const updatedata = await dispatch(getEducationReducer());
            // console.log("updatedataupdatedata", updatedata?.payload?.data);
            const newId = EducationBlob?.id;
            dispatch(setIsResumeChange(true));
            // setEducationList(updatedata?.payload?.data);

            if (editIndexEducation !== null) {
              const updatedEducationList = educationList?.map(
                (education, index) =>
                  index === editIndexEducation ? currentEducation : education
              );
              setEducationList(updatedEducationList);
              // const sortedEducationList = (() => {
              // if (ProfessionalEducation) {
              //   const transformedData = transformEducationData(ProfessionalEducation);
              //   return sortListByDate(transformedData, 'education');
              // } else if (updatedata?.payload?.statusCode === 200) {
              //   const newdata = updatedata?.payload?.data;
              //   const transformedData = transformEducationData(data);
              //   return sortListByDate(transformedData, 'education');
              // }
              // });
              setEditIndexEdu(null);
            } else {
              const newEducation = { ...currentEducation, id: newId };
              setEducationList((prevList) => [...prevList, newEducation]);
            }
            resetCurrentEducation();
            setIsModalOpen(false);
            handleSuccess();
            // getCompletionStatus();
            await dispatch(getProfileCompletionReducer());
            // settriggeredApi((prevState) => ({
            //   ...prevState,
            //   professionalProEducation: true
            // }));
          } else {
            console.log("Failed Response");
            handleFailure();
            // getCompletionStatus();
            await dispatch(getProfileCompletionReducer());
          }
        } else {
          const response = await dispatch(postEducationBlobReducer(formData));

          if (response?.payload?.statusCode === 200) {
            const updatedata = await dispatch(getEducationReducer());
            // console.log("updatedataupdatedata", updatedata?.payload?.data);
            const newId = EducationBlob?.id;
            dispatch(setIsResumeChange(true));
            dispatch(getAllCardDetailsReducer());
            setShowActiveModal(false);
            // setEducationList(updatedata?.payload?.data);

            if (editIndexEducation !== null) {
              const updatedEducationList = educationList.map(
                (education, index) =>
                  index === editIndexEducation ? currentEducation : education
              );
              setEducationList(updatedEducationList);
              // const sortedEducationList = (() => {
              // if (ProfessionalEducation) {
              //   const transformedData = transformEducationData(ProfessionalEducation);
              //   return sortListByDate(transformedData, 'education');
              // } else if (updatedata?.payload?.statusCode === 200) {
              //   const newdata = updatedata?.payload?.data;
              //   const transformedData = transformEducationData(data);
              //   return sortListByDate(transformedData, 'education');
              // }
              // });
              setEditIndexEdu(null);
            } else {
              const newEducation = { ...currentEducation, id: newId };
              setEducationList((prevList) => [...prevList, newEducation]);
            }
            resetCurrentEducation();
            setIsModalOpen(false);
            handleSuccess();
            // getCompletionStatus();
            await dispatch(getProfileCompletionReducer());
            // settriggeredApi((prevState) => ({
            //   ...prevState,
            //   professionalProEducation: true
            // }));
          } else {
            console.log("Failed Response");
            handleFailure();
            // getCompletionStatus();
            await dispatch(getProfileCompletionReducer());
          }
        }
      } catch (error) {
        console.log("Error Saving Education info", error);
        handleFailure();
      } finally {
        setLoading(false);
        endSectionSubmit();
        // await getAPIs.getEducation();
        // await getCompletionStatus();
      }
    }
  };

  const handleDeleteEducation = async () => {
    const endpoint = "educationDelete";
    const { id } = currentEducation;

    const params = { id };

    try {
      // const response = await callApiFunction(endpoint, params);
      const response = await dispatch(deleteProfessionalEducationReducer(id));

      if (response?.payload?.statusCode === 200) {
        await dispatch(getEducationReducer());
        if (editIndexEducation !== null) {
          const updatedEducationList = educationList.filter(
            (education, index) => index !== editIndexEducation
          );
          setEducationList(updatedEducationList);
          setEditIndexEdu(null);
          setDeleteEducation(false);
        }
        resetCurrentEducation();
        setIsModalOpen(false); //doubt only
        handleSuccess("", "Delete");
        // settriggeredApi((prevState) => ({
        //   ...prevState,
        //   professionalProEducation: true
        // }));
        if (educationList?.length == 0) {
          dispatch(getAllCardDetailsReducer())
        }
      } else {

        handleFailure("", "Delete");
      }
    } catch (error) {
      console.log("TRY for DELETE failed", error, params);
      handleFailure("", "Delete");
    } finally {
      // await getCompletionStatus();
      await dispatch(getProfileCompletionReducer());
    }
  };

  const handleAddCertificate = async (e) => {
    e.preventDefault();
    if (!startSectionSubmit("certificate")) return;
    setLoading(true);
    const newErrors = { ...certErrors };

    requiredFieldsCert.forEach((field) => {
      if (!currentCertificate[field]) {
        newErrors[field] = true;
      } else {
        newErrors[field] = false;
      }
    });

    setCertErrors(newErrors);
    const hasErrors = Object.values(newErrors).some((error) => error);

    if (hasErrors) return;

    const {
      id,
      certificateLogo,
      certificatePDF,
      organName,
      organDomain,
      courseName,
      certificateLink,
      certifiDetails,
      certifiMonth,
      certifiYear,
      isPublic,
    } = currentCertificate;

    const formData = new FormData();

    formData.append("id", id);
    formData.append("organisation_name", organName);
    formData.append("organisation_domain", organDomain);
    formData.append("course_name", courseName);
    formData.append("description", certifiDetails);
    formData.append("issue_date", certifiMonth);
    formData.append("year", certifiYear);
    formData.append("is_public", isPublic);
    formData.append("certificate_link", certificateLink);

    // Explicitly set is_verified to false when editing
    if (editCertificateIndex !== null) {
      formData.append("is_verified", false);
    }

    // Handling certificate logo file
    if (certificateLogo?.data) {
      try {
        const response = await fetch(certificateLogo?.data);
        const blob = await response.blob();
        const file = new File([blob], certificateLogo.name, {
          type: certificateLogo.type,
        });
        formData.append("logo_file", file);
      } catch (error) {
        console.error("Error fetched File", error);
      }
    }

    // Handling certificate PDF file
    if (certificatePDF?.data) {
      setLoading(true);
      handleInfo("Please wait to complete the process");
      try {
        const response = await fetch(certificatePDF?.data);
        const blob = await response.blob();
        const file = new File([blob], certificatePDF.name, {
          type: certificatePDF.type,
        });
        formData.append("certificate_file", file);
      } catch (error) {
        console.error("Error fetch message", error);
      }
      setLoading(false);
    }

    try {
      const response = await dispatch(postCertificateBlobReducer(formData));
      if (response?.payload?.statusCode === 200) {
        await dispatch(getCertificateReducer());
        const newId = CertificateBlob?.id;

        if (editCertificateIndex !== null) {
          const updatedCertificateList = certificateList?.map(
            (certificate, index) =>
              index === editCertificateIndex
                ? { ...currentCertificate, isVerified: false } // Ensure isVerified is false in local state
                : certificate
          );
          setcertificateList(updatedCertificateList);
          setEditCertificateIndex(null);
        } else {
          const newCertificate = { ...currentCertificate, id: newId, isVerified: false };
          setcertificateList((prevList) => [...prevList, newCertificate]);
        }
        resetCurrentCertificate();
        setLightBoxCertificate(false);
        handleSuccess();
      }
    } catch (error) {
      console.log("Error Saving Certificate info", error);
      handleFailure();
    } finally {
      setLoading(false);
      endSectionSubmit();
      await dispatch(getProfileCompletionReducer());
    }
  };

  const handleDeleteCertificate = async () => {
    const endpoint = "certificateDelete";
    const { id } = currentCertificate;
    const params = { id };
    try {
      // const response = await callApiFunction(endpoint, params);
      const response = await dispatch(deleteCertificateReducer(id));
      if (response?.payload?.statusCode === 200) {
        if (editCertificateIndex !== null) {
          const updatedCertificateList = certificateList.filter(
            (certificate, index) => index !== editCertificateIndex
          );
          setcertificateList(updatedCertificateList);
          setEditCertificateIndex(null);
          setDeleteCertificate(false);
        }
        resetCurrentCertificate();
        setLightBoxCertificate(false); //doubt only
        handleSuccess("", "Delete");
        await dispatch(getCertificateReducer());
        // settriggeredApi((prevState) => ({
        //   ...prevState,
        //   professionalProCertificate: true
        // }));
      } else {
        console.log("Could not DELETE Certificate", response);
        handleFailure("", "Delete");
      }
    } catch (error) {
      console.log("TRY for DELETE failed", error, params);
      handleFailure("", "Delete");
    } finally {
      // await getCompletionStatus();
      await dispatch(getProfileCompletionReducer());
    }
  };


  const handleAddExperience = async (e) => {
    e.preventDefault();
    if (!startSectionSubmit("experience")) return;
    setLoading(true);
    const newErrors = { ...expErrors };

    requiredFieldsExp.forEach((field) => {
      if (field === "companylogo") {
        // Special validation for logo
        if (!currentExperience[field] ||
          !currentExperience[field].data ||
          currentExperience[field].data === "") {
          newErrors[field] = true;
        } else {
          newErrors[field] = false;
        }
      } else {
        if (!currentExperience[field]) {
          newErrors[field] = true;
        } else {
          newErrors[field] = false;
        }
      }
    });

    setExpErrors(newErrors);

    const hasErrors = Object.values(newErrors).some((error) => error);

    if (!hasErrors) {
      // let logoBlob;

      // // Find the corresponding experience in the global state
      // const originalExperience = ExperienceList.find(
      //   (experience) => experience.id === currentExperience.id
      // );

      // // Only fetch logo if companyDomain has changed
      // const hasCompanyDomainChanged =
      //   !originalExperience || // If it's a new experience (not found in ExperienceList)
      //   originalExperience.companyDomain !== currentExperience.companyDomain;

      // // attempt to fetch logo from company domain if entered
      // if (hasCompanyDomainChanged && currentExperience.companyDomain) {
      //   logoBlob = await fetchLogoFromDomain(currentExperience.companyDomain, "companylogo", updateCurrentExperience);
      // }

      const endpoint = "experienceCreateUpdate";
      const {
        id,
        companylogo,
        companyName,
        companyDomain,
        location,
        locationType,
        roleTitle,
        employmentType,
        details,
        startMonth,
        startYear,
        endMonth,
        endYear,
        responsibility,
        headline,
        isCurrentlyWorking,
        isPublic,
        isVerified,
        company_email,
        profile_headline,
      } = currentExperience;

      // const payload = {
      //   id: id,
      //   company_logo: companylogo?.data,
      //   company_name: companyName,
      //   company_domain: companyDomain,
      //   location: location,
      //   location_type: locationType,
      //   role_title: roleTitle,
      //   employee_type: employmentType,
      //   details: details,
      //   start_month: startMonth,
      //   start_year: startYear,
      //   end_month: endMonth,
      //   end_year: endYear === "Present" ? new Date().getFullYear() : endYear,
      //   responsibility: responsibility.join(", "),
      //   profile_headline: headline,
      //   is_currently_working: isCurrentlyWorking,
      //   is_public: isPublic,
      // };

      const formData = new FormData();

      // Append non-file payload data
      formData.append("id", id);
      formData.append("company_name", companyName);
      formData.append("company_domain", companyDomain);
      formData.append("location", location);
      formData.append("location_type", locationType);
      formData.append("role_title", roleTitle);
      formData.append("employee_type", employmentType);
      formData.append("details", details);
      formData.append("start_month", startMonth);
      formData.append("start_year", startYear);
      formData.append("end_month", endMonth);
      formData.append(
        "end_year",
        endYear === "Present" ? new Date().getFullYear() : endYear
      );
      formData.append("responsibility", responsibility.join(", "));
      if (profile_headline !== undefined && profile_headline !== null) {
        formData.append("profile_headline", profile_headline);
      };

      formData.append("is_currently_working", isCurrentlyWorking);
      formData.append("is_public", Boolean(isPublic));
      formData.append("is_verified", Boolean(isVerified));
      if (company_email !== undefined && company_email !== null) {
        formData.append("company_email", company_email);
      }

      // Handle file upload for `certificateLogo`

      // if (companylogo?.data) {
      //   setLoading(true);
      //   handleInfo("Please wait to complete the process")
      //   try {
      //     const response = await fetch(companylogo?.data);
      //     const blob = await response.blob();
      //     const file = new File([blob], companylogo.name, { type: companylogo.type });
      //     formData.append("logo_file", blob, companylogo?.name);
      //   } catch (error) {
      //     console.error("Error fetching File", error);
      //   }
      //   setLoading(false);
      // }

      // if (companylogo?.data) {
      //   // const logoUrl = cardDetails?.logo?.data || cardDetails?.logo;
      //   console.log("companylogo?.datacompanylogo?.data", companylogo?.data);
      //   if (companylogo?.data.startsWith("blob:")) {
      //     console.log("Experienxe blob if")
      //     setLoading(true);
      //     handleInfo("Please wait to complete the process");

      //     try {
      //       const response = await fetch(companylogo?.data);
      //       const blob = await response.blob();
      //       // const file = new File([blob], cardDetails?.logo?.name, { type: cardDetails?.logo?.type });
      //       formData.append("logo_file", blob);
      //     } catch (error) {
      //       console.error("Error fetching File", error);
      //     }

      //     setLoading(false);
      //   } else {

      //     console.log("Experienxe blob else")
      //     formData.append("logo_url", companylogo?.data);
      //   }
      // }


      if (companylogo?.data) {
        // const logoUrl = cardDetails?.logo?.data || cardDetails?.logo;

        if (companylogo?.data.startsWith("blob:")) {
          setLoading(true);
          handleInfo("Please wait to complete the process");

          try {
            const response = await fetch(companylogo?.data);
            const blob = await response.blob();
            formData.append("logo_file", blob); // ✅ send File, not blob
          } catch (error) {
            console.error("Error fetching File", error);
          }

          setLoading(false);
        } else {
          formData.append("logo_url", companylogo?.data);
        }
      }

      try {
        // const response = await callApiFunction(endpoint, payload);

        if (editExperienceIndex !== null) {
          const response = await dispatch(
            patchProfessionalExperienceReducer({ id: id, data: formData })
          );
          if (response?.payload?.statusCode === 200) {
            await dispatch(getExperienceReducer());
            const newId = ExperienceBlob?.id;
            // if (response.status === "SUCCESS") {
            if (editExperienceIndex !== null) {
              const updatedExperienceList = ExperienceList.map(
                (experience, index) =>
                  index === editExperienceIndex ? currentExperience : experience
              );
              setExperienceList(updatedExperienceList);
              setEditExperienceIndex(null);
            } else {
              const newExperience = { ...currentExperience, id: newId };
              setExperienceList((prevList) => [...prevList, newExperience]);
            }
            // settriggeredApi((prevState) => ({
            //   ...prevState,
            //   professionalProExperience: true
            // }));
            resetCurrentExperience();
            setLightBoxExperience(false);
            // setVerifyExpModal(true);
            handleSuccess();
          }
        } else {
          const response = await dispatch(postExperienceBlobReducer(formData));
          if (response?.payload?.statusCode === 200) {
            await dispatch(getExperienceReducer());
            await dispatch(getAllCardDetailsReducer());
            setShowActiveModal(false);
            const newId = ExperienceBlob?.id;
            // if (response.status === "SUCCESS") {
            if (editExperienceIndex !== null) {
              const updatedExperienceList = ExperienceList.map(
                (experience, index) =>
                  index === editExperienceIndex ? currentExperience : experience
              );
              setExperienceList(updatedExperienceList);
              setEditExperienceIndex(null);
            } else {
              const newExperience = { ...currentExperience, id: newId };
              setExperienceList((prevList) => [...prevList, newExperience]);
            }
            // settriggeredApi((prevState) => ({
            //   ...prevState,
            //   professionalProExperience: true
            // }));
            resetCurrentExperience();
            setLightBoxExperience(false);
            handleSuccess();
          }
        }

        // } else {

        //   handleFailure();
        // }
      } catch (error) {
        console.log("Error Saving Experience Details: ", error);
        handleFailure();
      } finally {
        setLoading(false);
        endSectionSubmit();
        // await getAPIs.getExperiences();
        // await getCompletionStatus();
        await dispatch(getProfileCompletionReducer());
      }
    }
  };

  const handleDeleteExperience = async () => {
    const endpoint = "experienceDelete";
    const { id } = currentExperience;
    const params = { id };
    try {
      // const response = await callApiFunction(endpoint, params);
      // const response = await dispatch(deleteExperienceReducer(id));
      const response = await dispatch(deleteProfessionalExperienceReducer(id));
      if (response?.payload?.statusCode === 200) {
        if (editExperienceIndex !== null) {
          const updatedExperienceList = ExperienceList.filter(
            (experience, index) => index !== editExperienceIndex
          );
          setExperienceList(updatedExperienceList);
          setEditExperienceIndex(null);
          setdeleteExperience(false);
        }

        resetCurrentExperience();
        await dispatch(getExperienceReducer());
        // settriggeredApi((prevState) => ({
        //   ...prevState,
        //   professionalProExperience: true
        // }));
        setLightBoxExperience(false); //doubt only
        handleSuccess("", "Delete");

        if (ExperienceList?.length == 0) {
          dispatch(getAllCardDetailsReducer())
        }
      } else {
        // console.log("Could not DELETE Experience", response);
        handleFailure("", "Delete");
      }
    } catch (error) {
      console.log("TRY for DELETE failed", error, params);
      handleFailure("", "Delete");
    } finally {
      // await getCompletionStatus();
      await dispatch(getProfileCompletionReducer());
    }
  };

  const handleDeleteResume = async (fileId) => {
    const endpoint = "deleteResume";
    const id = fileId;
    const params = { id };

    try {
      // const response = await callApiFunction(endpoint, params);

      const response = await dispatch(deleteResumeReducer(id));

      if (response?.payload?.statusCode === 200) {
        // Update context to remove the file
        updateResume("files", { id }, "remove");
        setDeleteResume(false);
        handleSuccess("", "Delete");
        await dispatch(getResumeReducer());
      }
    } catch (error) {
      console.error("Error deleting Resume:", error, "params", params);
      handleFailure("", "Delete");
    }
  };

  const handleDeleteVideoResume = async (fileId) => {
    const endpoint = "deleteVideoResume";
    const id = fileId;
    const params = { id };

    try {
      // const response = await callApiFunction(endpoint, params);

      const response = await dispatch(deleteResumeReducer(id));

      if (response?.payload?.statusCode === 200) {
        // Update context to remove the file
        updateResume("files", { id }, "remove");
        setDeleteResume(false);
        handleSuccess("", "Delete");
        await dispatch(getResumeReducer());
      }
    } catch (error) {
      console.error("Error deleting Resume:", error, "params", params);
      handleFailure("", "Delete");
    }
  };

  const handleGenerateAboutMe = async () => {
    if (!ProfessionalEdited?.aboutme) {
      openSnackbar(
        "Empty data! Please enter some data for generating content!",
        "error",
        8000
      );
      return;
    }
    openSnackbar("Generating your content...", "info");
    const prompt = {
      aboutMe: ProfessionalEdited?.aboutme,
      education: sortedEducationList?.map((education) => ({
        level: education?.eduLevel,
        degree:
          education?.eduLevel === "SSLC"
            ? "10th / Senior Secondary"
            : education?.eduLevel === "HSC"
              ? "12th / Higher Secondary"
              : education.degree,
        field:
          education?.fieldofStudy === "SSLC"
            ? undefined
            : education?.fieldOfStudy,
        institution: education?.institute,
        university:
          education.eduLevel !== "SSLC" && education.eduLevel !== "HSC"
            ? education?.universityName
            : undefined,
        yearCompleted: education?.endYear,
        details: education?.description,
      })),
      experience: sortedExperienceList.map((experience) => ({
        company: experience?.companyName,
        location: experience?.location,
        role: experience?.roleTitle,
        startDate: experience?.startMonth + " " + experience?.startYear,
        endDate: experience?.endMonth + " " + experience?.endYear,
        details: experience?.details,
      })),
      skills: {
        softSkills: ProfessonalSoftSkills?.skills,
        professionalSkills: ProfessonalSkills?.skills,
        tools: ProfessonalToolsSkills?.skills,
      },
    };

    try {
      // const response = await callApiFunction("generateAboutMe", {
      //   prompt: prompt,
      // });
      const response = await dispatch(
        postProfessionalProfileGenerateAboutMeReducer({ prompt })
      );
      if (response?.payload?.statusCode === 200) {
        const generatedata = response?.payload?.data?.aboutMe;
        // setText(responseData.aboutMe);
        if (generatedata) {
          setProfessionalEdited((prevState) => ({
            ...prevState,
            aboutme: generatedata,
          }));
        }
        // const responseData = response.data;
        // setText(responseData.aboutMe);
      }
    } catch (error) {
      console.error("Failed to Rewrite content with AI", error);
      openSnackbar("Could Not Rewrite your content. Try Again Later.", "error");
    }
  };

  const handleGenerateDescription = async (
    data,
    sectionType,
    property,
    updateState
  ) => {
    try {
      handleInfo("Generating your content...");
      const prompt = data;
      // const response = await callApiFunction("generateDescription", { prompt: data });
      const response = await dispatch(
        postGenerateDescriptionReducer({
          prompt: prompt,
          sectionType: sectionType,
        })
      );

      if (response?.payload?.statusCode === 200) {


        // Update the specific property in the state
        updateState({
          [property]: response?.payload?.data?.description,
        });
        handleSuccess("Content successfully generated!");
      } else {
        console.error("Error generating description:", response.data.message);
      }
    } catch (error) {
      console.error("Error generating description:", error);
      handleFailure("Failed to generate. Please try later.");
    }
  };

  const sortedEducationList = sortListByDate(
    [...(ProfessionalEducation || [])],
    "education"
  );
  const sortedExperienceList = sortListByDate(
    [...(ProfessionalExperience || [])],
    "experience"
  );
  const sortedCertificateList = sortListByDate(
    [...(ProfessionalCertificate || [])],
    "certificates"
  );

  const sortedProjectList = sortListByDate(
    [...(ProfessionalProject || [])],
    "projects"
  );

  const sortedAwardsList = sortListByDate(
    [...(ProfessionalAwards || [])],
    "awards"
  );

  // console.log("sortedEducationListMMMM", sortedEducationList)
  const [jobsModalOpen, setJobsModalOpen] = useState(false);
  const [jobType, setJobType] = useState("");
  const [badgeChecked, setBadgeChecked] = useState(false);
  const [jobFormValues, setJobFormValues] = useState({
    tagName: professionaProfile?.tag_name || "",
    showBadge: professionaProfile?.show_badge || false,
    preferredRole: professionaProfile?.preferred_role || "",
    preferredWorkMode: professionaProfile?.preferred_work_mode || "",
    preferredLocation: professionaProfile?.preferred_location || "",
    isVisibleRecruiter: professionaProfile?.is_visible_recruiter || false,
  });

  const [mostRecentEducation, setMostRecentEducation] = useState({
    instlogo: {
      name: "",
      type: "",
      data:
        ProfessionalEducation && ProfessionalEducation?.length > 0
          ? ProfessionalEducation[0]?.logo_link
          : "",
    },
    institute:
      sortedEducationList && sortedEducationList?.length > 0
        ? sortedEducationList[0]?.institute_name
        : "",
  });
  const [mostRecentExperience, setMostRecentExperience] = useState({
    companylogo: {
      name: "",
      type: "",
      data:
        sortedExperienceList && sortedExperienceList?.length > 0
          ? sortedExperienceList[0]?.company_logo
          : "",
    },
    companyName:
      sortedExperienceList && sortedExperienceList?.length > 0
        ? sortedExperienceList[0]?.company_name
        : "",
  });

  const mostRecentEduLogo =
    mostRecentEducation?.instlogo?.data || DefaultLogo;
  const mostRecentExpLogo =
    mostRecentExperience?.companylogo?.data || DefaultLogo;

  const [isSaving, setIsSaving] = useState(false);
  const [hiringModalOpen, setHiringModalOpen] = useState(false);
  const [hiringType, setHiringType] = useState("");
  const [hiringChecked, setHiringChecked] = useState(false);
  const [currentStep, setCurrentStep] = useState(1); // Start with Step 1
  const [selectedChips, setSelectedChips] = useState([]);
  const [hiringInputValue, setHiringInputValue] = useState("");
  const [alertOpen, setAlertOpen] = useState(false);
  const [hiringData, setHiringData] = useState({
    role: "",
    company_name: "",
    company_url: "",
    dept_type: "",
    emp_type: "",
    edu_level: "",
    experience: "",
    salary: "",
    location: "",
    mode: "",
    skills: [],
    candidate_profile: " ",
    job_description_md: "",
    company_id: "",
    // job_summary: "",
    // qualifications: [],
    // responsibility: [],
    // about_company: "",
    // perks: [],
    // pre_requisites: [],
    no_of_rounds: 0,
    no_of_open_positions: 0,
  });
  const [formErrors, setFormErrors] = useState({
    tagName: false,
    preferredRole: false,
  });
  const [fieldJobErrors, setJobFieldErrors] = useState({});
  const [isLoadingSkills, setIsLoadingSkills] = useState(false);
  const [isLoadingDescription, setIsLoadingDescription] = useState(false);
  const [showCompanySelection, setShowCompanySelection] = useState(false);


  useEffect(() => {
    // ✅ Removed: navigate("/myprofile") — was firing on first render when ExperienceList
    // was empty (before Redux loaded data), wiping mainTab from URL and snapping back to personal_profile
    if (!ExperienceList || ExperienceList?.length === 0) {
      return; // Just return early — do NOT navigate away
    }

    // Find the current experience where isCurrentlyWorking is true
    const currentExperience = ExperienceList?.find(
      (exp) => exp.isCurrentlyWorking
    );

    if (currentExperience) {
      const companyId =
        currentExperience?.cid ||
        currentExperience?.uniqueId ||
        getCompanyIdFromUserType(userTypeDetails, currentExperience?.companyName);
      const enterpriseCompanyId =
        currentExperience?.id ||
        currentExperience?.entityId ||
        getEnterpriseEntityIdFromUserType(
          userTypeDetails,
          currentExperience?.companyName || companyId
        );
      setHiringData((prev) => ({
        ...prev,
        company_name: currentExperience?.companyName || "",
        company_url: currentExperience?.companyDomain || "",
        emp_type: currentExperience?.employmentType || "",
        mode: currentExperience?.locationType || "",
        company_location: currentExperience?.location || "",
        company_id: companyId || prev.company_id || "",
        enterprise_company_id: enterpriseCompanyId || prev.enterprise_company_id || undefined,
      }));
    } else {
      // navigate("/myprofile");
    }
  }, [ExperienceList, navigate, userTypeDetails]);

  useEffect(() => {
    // Handle sub tab selection
    if (mainTab === "professional_profile" && subTab) {
      switch (subTab) {
        case "resume":
          setActiveMenu("resume");
          break;
        case "video_resume":
          setActiveMenu("video_resume");
          break;
        default:
          setActiveMenu("my_profile");
          break;
      }
    }
  }, [mainTab, subTab]);



  // Open and close modal handlers
  const handleJobsModalOpen = (type) => {
    setJobType(type); // Set job type dynamically
    setJobsModalOpen(true);
    setSubMenuOpen(!subMenuOpen);
  };

  const handleHiringModalOpen = (type) => {
    setHiringType(type);
    setHiringModalOpen(true);
  };

  const handleHiringPopupClick = () => {
    // Filter currently working experiences
    const currentExperiences =
      ProfessionalExperience?.filter(
        (exp) => exp.is_currently_working === true && exp.is_verified
      ) || [];

    if (currentExperiences?.length === 0) {
      // No current employment
      openSnackbar(
        "You need to be verified and currently employed to post a job",
        "warning"
      );
      setActiveMenu("experience");
      handleClose();
    } else if (currentExperiences?.length === 1) {
      // Single current employment - directly open hiring modal with data
      const currentExp = currentExperiences[0];
      const companyId =
        currentExp.cid ||
        currentExp.uniqueId ||
        getCompanyIdFromUserType(userTypeDetails, currentExp.company_name);
      const enterpriseCompanyId =
        currentExp.id ||
        currentExp.entityId ||
        getEnterpriseEntityIdFromUserType(
          userTypeDetails,
          currentExp.company_name || companyId
        );
      setHiringData((prev) => ({
        ...prev,
        company_name: currentExp.company_name || "",
        company_url: currentExp.company_domain || "",
        emp_type: currentExp.employee_type || "",
        mode: currentExp.location_type || "",
        company_location: currentExp.location || "",
        company_logo: currentExp.company_logo || "",
        company_id: companyId || "",
        enterprise_company_id: enterpriseCompanyId || undefined,
      }));
      setHiringModalOpen(true);
    } else {
      // Multiple current employments - show selection modal
      setShowCompanySelection(true);
    }
  };

  const handleJobsModalClose = () => {
    // setTempJobFormValues({...jobFormValues});
    setJobFormValues({
      tagName: professionaProfile?.tag_name || "",
      showBadge: professionaProfile?.show_badge || false,
      preferredRole: professionaProfile?.preferred_role || "",
      preferredWorkMode: professionaProfile?.preferred_work_mode || "",
      preferredLocation: professionaProfile?.preferred_location || "",
      isVisibleRecruiter: professionaProfile?.isVisibleRecruiter || false,
    });
    setJobsModalOpen(false);
  };

  const handleHiringModalClose = () => setHiringModalOpen(false);

  // Add this improved handleHiringInputChange function
  const handleHiringInputChange = (e) => {
    const { name, value } = e.target;

    // Handle array fields that use newline separation
    const arrayFields = [
      "responsibility",
      "qualifications",
      "perks",
      "pre_requisites",
    ];

    if (arrayFields.includes(name)) {
      // Split by newlines and filter out empty lines
      const arrayValue = value
        .split("\n")
        .map((item) => item.trim())
        .filter((item) => item !== "");

      setHiringData((prev) => ({
        ...prev,
        [name]: arrayValue,
      }));
    } else {
      // Handle regular string fields
      setHiringData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleKeyDown = (e) => {
    console.log("Key Pressed:", e.key);
  };

  const handleJobInputChange = (e) => {
    const { name, type, checked, value } = e.target;

    if (name === "isVisibleRecruiter") {
      setJobFormValues((prevValues) => ({
        ...prevValues,
        [name]: checked, // Only update with true when checked
      }));
      return;
    }

    setJobFormValues((prevValues) => ({
      ...prevValues,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Handle save button

  // const handleSaveJobModal = () => {

  //   handleJobsModalClose();
  // };

  const menuOptions = {
    "Department Type": [
      "Human Resources (HR)",
      "Finance & Accounting",
      "Marketing",
      "Sales",
      "Customer Support",
      "Operations",
      "Legal & Compliance",
      "Administrative",
      "Information Technology (IT)",
      "Software Development",
      "Data & Analytics",
      "Product Management",
      "Medical & Clinical",
      "Pharmacy",
      "Research & Development (R&D)",
      "Production & Manufacturing",
      "Engineering",
      "Quality Assurance (QA)",
      "Academic Affairs",
      "Student Affairs",
      "Training & Development",
      "Public Relations (PR)",
      "Procurement & Purchasing",
      "Supply Chain & Logistics",
    ],
    "Employment Type": [
      "Full-time/ Permanent",
      "Part-time",
      "Freelance",
      "Internship",
      "Trainee",
    ],
    "Education Type": [
      "Undergraduate",
      "10th/SSLC/SCC",
      "12th/PUC/HSC",
      "Postgraduate",
      "Higher Education",
      "Any Graduate",
    ],
    "Experience Range": [
      "0-1 year",
      "1-2 years",
      "2-4 years",
      "4-6 years",
      "6-8 years",
      "8-10 years",
      "10-15 years",
      "15-20 years",
      "20+ years",
    ],
    "Salary Range": [
      "Less than 2,00,000",
      "2,00,000-5,00,000",
      "5,00,000-10,00,000",
      "10,00,000-15,00,000",
      "15,00,000-20,00,000",
      "20,00,000-30,00,000",
      "35,00,000-50,00,000",
      "50,00,000-1,00,00,000",
      "Above-1,00,00,000",
    ],
    "Work Location": ["Bangalore", "Hyderabad", "Chennai", "Delhi", "Kochi"],
    "Work Mode": ["On-site", "Hybrid", "Remote"],
  };


  const generatedJobDescriptions = useSelector(
    (state) => state.jobs.generatedJobDescriptions
  );
  const generatedSkills = useSelector((state) => state.jobs?.generatedSkills);
  const [localGeneratedSkills, setLocalGeneratedSkills] =
    useState(generatedSkills);

  useEffect(() => {
    // Merge generatedSkills and hiringData.skills, removing duplicates
    const mergedSkills = Array.from(
      new Set([...(generatedSkills || []), ...(hiringData.skills || [])])
    );
    setLocalGeneratedSkills(mergedSkills);
  }, [generatedSkills, hiringData.skills]);

  // Get the latest generated job description
  // const latestJobDescription = generatedJobDescriptions

  // Format arrays to bullet points string
  const formatPoints = (array) =>
    array?.map((item) => `${item}`).join("\n") || "";


  const validateCurrentStep = () => {
    let errors = {};
    let isValid = true;

    switch (currentStep) {
      case 1:
        // Skills validation
        if (!hiringData?.skills || hiringData?.skills?.length === 0) {
          errors.skills = true;
          isValid = false;
        }
        break;

      case 2:
        // Basic job details validation
        const requiredFields = [
          "role",
          "dept_type",
          "emp_type",
          "edu_level",
          "experience",
          "salary",
          "mode",
        ];

        requiredFields.forEach((field) => {
          if (!hiringData[field] || hiringData[field].trim() === "") {
            errors[field] = true;
            isValid = false;
          }
        });
        break;

      case 3:
        // Advanced job details validation
        if (
          !hiringData?.candidate_profile ||
          hiringData?.candidate_profile.trim() === ""
        ) {
          errors.candidate_profile = true;
          isValid = false;
        }
        break;

      case 4:
        // Company details validation
        if (
          !hiringData?.company_location ||
          hiringData?.company_location.trim() === ""
        ) {
          errors.company_location = true;
          isValid = false;
        }
        break;
    }

    setJobFieldErrors(errors);
    return isValid;
  };

  const handleNext = async () => {
    // if (!validateCurrentStep()) {
    //   // Show error message
    //   handleFailure("Please fill in all required fields");
    //   return;
    // }

    //     if (isEditing) {
    //   setCurrentStep((prevStep) => prevStep + 1);
    //   return;
    // }


    if (currentStep === 1) {
      setIsLoadingSkills(true);
      const {
        role: role,
        dept_type: departmentType,
        emp_type: employmentType,
        edu_level: education,
        salary: salary,
        experience: experience,
      } = hiringData;
      setIsLoadingSkills(true);
      try {
        await dispatch(
          generateAISkills({
            role,
            departmentType,
            employmentType,
            education,
            salaryRange: salary, // Assuming salary is an object
            experienceRange: experience,
          })
        );
      } finally {
        setIsLoadingSkills(false);
      }
    }
    if (currentStep === 2) {
      // Destructure and rename required fields
      const {
        role: role,
        // about_company:about_company,
        company_name: companyName,
        dept_type: departmentType,
        emp_type: employmentType,
        edu_level: education,
        location: jobLocation,
        mode: mode,
        skills: keySkills,
      } = hiringData;

      // Create payload with required structure
      const generationPayload = {
        role,
        companyName,
        departmentType,
        employmentType,
        education,
        jobLocation,
        mode,
        keySkills,
        roleCategory: null, // Add default null value for this field
      };
      setIsLoadingDescription(true);

      try {
        const result = await dispatch(
          generateJobDescription(generationPayload)
        );
        if (result?.payload) {
          setHiringData((prev) => ({
            ...prev,
            job_description_md: result?.payload
          }));
        }
      } finally {
        setIsLoadingDescription(false);
      }
    }
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handleEditResponseClick = () => {
    setCurrentStep(4);
  };

  const handleEditSkillClick = () => {
    setCurrentStep(1);
  };

  const handleBack = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  const handleCancel = () => {
    // Reset all states
    setHiringData({
      role: "",
      company_name: "",
      company_url: "",
      dept_type: "",
      emp_type: "",
      edu_level: "",
      experience: "",
      salary: "",
      location: "",
      mode: "",
      skills: [],
      candidate_profile: "",
      company_location: "",
      no_of_rounds: 0,
      no_of_open_positions: 0,
    });
    setCurrentStep(1);
    setSelectedChips([]);
    setJobFieldErrors({});
    handleHiringModalClose();
  };

  const [chips, setChips] = useState([
    "html",
    "css",
    "javaScript",
    "React",
    "Redux",
    "Node",
    "Express",
    "MongoDB",
    "UI Design",
    "Figma",
    "Adobe",
  ]);


  const isExperienceFormValid = () => {
    // Check all required fields
    const requiredFields = [
      "companyName",
      "companyDomain",
      "location",
      "roleTitle",
      "startMonth",
      "startYear",
      "endMonth",
      "endYear",
    ];

    // Check if logo is uploaded (has data)
    const hasLogo = currentExperience.companylogo &&
      currentExperience.companylogo.data &&
      currentExperience.companylogo.data !== "";

    // Check if all text fields have values
    const allFieldsFilled = requiredFields.every(field =>
      currentExperience[field] && currentExperience[field].toString().trim() !== ""
    );

    return allFieldsFilled && hasLogo;
  };

  const handleHiringSubmit = async () => {
    try {
      const errors = {};
      let errorMessage = "";

      if (Object.keys(errors)?.length > 0) {
        // Remove trailing comma and space
        errorMessage = errorMessage.slice(0, -2);
        handleInfo(`Please fill in the following fields: ${errorMessage}`);

        // Update UI to show red borders (you'll need to add this state to your component)
        // setFieldErrors(errors);
        return;
      }
      // Validate fields
      const isDataComplete = Object.values(hiringData).every((field) => {
        return (
          field !== null &&
          field !== "" &&
          !(Array.isArray(field) && field?.length === 0)
        );
      });

      // if (!isDataComplete) {

      //   alert("Please fill all the fields before submitting.");
      //   return;
      // }

      // ✅ Format the data properly
      const companyId =
        hiringData.company_id ||
        getCompanyIdFromUserType(userTypeDetails, hiringData.company_name);

      const formattedHiringData = {
        ...hiringData,
        company_id: companyId || hiringData.company_id || undefined,
        skills: JSON.stringify(hiringData.skills),
        // responsibility: JSON.stringify(hiringData.responsibility),
        // qualifications: JSON.stringify(hiringData.qualifications),
        // perks: JSON.stringify(hiringData.perks),
        // pre_requisites: JSON.stringify(hiringData.pre_requisites),
        no_of_open_positions: Number(hiringData.no_of_open_positions),
      };

      //  Dispatch the action instead of making a direct API call
      const response = await dispatch(createJob(formattedHiringData));


      if (
        response.payload?.statusCode == 201 ||
        response.payload?.statusCode == 200 ||
        response?.payload?.success === true
      ) {
        // Sync created job with Enterprise service
        const createdJobId =
          response?.payload?.data?.id ||
          response?.payload?.data?.jobId ||
          response?.payload?.data?.job_id ||
          response?.payload?.id ||
          response?.payload?.jobId ||
          (typeof response?.payload?.data === "number" ? response?.payload?.data : null);

        const enterpriseCompanyId =
          hiringData.enterprise_company_id ||
          getEnterpriseEntityIdFromUserType(
            userTypeDetails,
            hiringData.company_name || companyId
          );

        if (createdJobId && enterpriseCompanyId) {
          try {
            await syncEnterpriseJobAPI({
              jobId: createdJobId,
              companyId: enterpriseCompanyId,
              jobtype: hiringData.emp_type || "full-time/permanent",
            });
          } catch (syncErr) {
            console.error("Error syncing job with enterprise service:", syncErr);
          }
        }

        handleSuccess("Job posting created successfully!");

        handleHiringModalClose();
        setHiringData({
          role: "",
          company_name: "",
          company_url: "",
          dept_type: "",
          emp_type: "",
          edu_level: "",
          experience: "",
          salary: "",
          location: "",
          mode: "",
          skills: [],
          candidate_profile: "",
          company_location: "",
          company_id: "",
          no_of_rounds: 0,
          no_of_open_positions: 0,
        });
        // setLocalGeneratedSkills("");
        setCurrentStep(1);
        navigate("/alljobs");
      } else {
        handleFailure("Failed to create job posting");
      }
    } catch (error) {
      console.error("Error submitting hiring data:", error.message);
      alert(
        "Error submitting hiring data. Please check the console for details."
      );
    }
  };

  // console.log("selectedChips", selectedChips)

  // const handleChipToggle = (chip) => {
  //   if (selectedChips.includes(chip)) {
  //     setSelectedChips(selectedChips.filter((item) => item !== chip));

  //   } else {
  //     setSelectedChips([...selectedChips, chip]);

  //   }
  // };

  // const handleChipToggle = (chip) => {
  //   const updatedChips = selectedChips.includes(chip)
  //     ? selectedChips.filter((item) => item !== chip)
  //     : [...selectedChips, chip];

  //   setSelectedChips(updatedChips);
  //   setHiringData((prev) => ({ ...prev, skills: updatedChips }));
  // };

  const handleChipToggle = (chip) => {
    const updatedChips = selectedChips.includes(chip)
      ? selectedChips.filter((item) => item !== chip)
      : [...selectedChips, chip];

    setSelectedChips(updatedChips);
    setHiringData((prev) => ({ ...prev, skills: updatedChips }));
  };

  // const handleHiringChipDelete = (chip) => {
  //   const updatedChips = chips.filter((item) => item !== chip);
  //   const updatedSelected = selectedChips.filter((item) => item !== chip);

  //   setChips(updatedChips);
  //   setSelectedChips(updatedSelected);
  //   setHiringData((prev) => ({ ...prev, skills: updatedSelected }));
  // }

  const handleHiringChipDelete = (chip) => {
    setLocalGeneratedSkills((prev) => prev.filter((item) => item !== chip));
    setSelectedChips((prev) => prev.filter((item) => item !== chip));
    setHiringData((prev) => ({ ...prev, skills: selectedChips }));
  };

  // const handleHiringAddChip = () => {
  //   if (hiringInputValue && !chips.includes(hiringInputValue)) {
  //     setChips([...chips, hiringInputValue]);
  //     setHiringInputValue("");
  //   }
  // };
  const handleHiringAddChip = (newChip) => {
    if (
      newChip &&
      !localGeneratedSkills.includes(newChip) &&
      newChip.trim() !== ""
    ) {
      // Add to local skills
      setLocalGeneratedSkills((prev) => [...prev, newChip]);
      // Select the chip immediately
      setSelectedChips((prev) => [...prev, newChip]);
      // Update hiringData.skills
      setHiringData((prev) => ({
        ...prev,
        skills: [...(prev.skills || []), newChip],
      }));
      setHiringInputValue("");
    }
  };

  const jobTypeImages = {
    "Full-Time": ft_job,
    Freelancer: freelance,
    "Part-Time": pt_job,
    Internship: intern,
    "Hiring Information": hiring,
  };

  const handleJobSave = async () => {
    if (isSaving) return;

    const errors = {
      tagName: !jobFormValues.tagName,
      preferredRole: !jobFormValues.preferredRole,
    };

    setFormErrors(errors);

    if (errors.tagName || errors.preferredRole) return;

    try {
      setIsSaving(true); // Start loading

      const payload = {
        tagName: jobFormValues.tagName,
        showBadge: jobFormValues.showBadge,
        preferredRole: jobFormValues.preferredRole,
        preferredWorkMode: jobFormValues.preferredWorkMode,
        preferredLocation: jobFormValues.preferredLocation || null,
        isVisibleRecruiter: jobFormValues.isVisibleRecruiter ? true : false, // Only true when checked
      };
      // let response;
      const response = await dispatch(postJobPreferences(payload));

      if (response.payload?.statusCode === 200) {
        // Update local state
        setJobFormValues((prev) => ({
          ...prev,
          ...payload,
        }));

        // Refresh data
        await dispatch(getProfessionalInfoReducer());

        // Close modal and show success
        setJobsModalOpen(false);
        setSubMenuOpen(false);
        handleSuccess("Job preferences updated successfully");
      } else {
        handleFailure("Failed to update job preferences");
      }
    } catch (error) {
      console.error("Error saving job preferences:", error);
      handleFailure("Failed to update job preferences");
    } finally {
      setIsSaving(false);
    }
  };

  // Add this utility function to validate logos before attempting to display them

  const validateLogoUrl = async (url) => {
    if (!url) return { valid: false, reason: 'No URL' };

    // Check if it's a blob URL (these are usually valid)
    if (url.startsWith('blob:')) {
      return { valid: true, type: 'blob' };
    }

    // Check if it's a data URL
    if (url.startsWith('data:')) {
      return { valid: true, type: 'data' };
    }

    // For HTTP URLs, try to validate
    if (url.startsWith('http')) {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 3000);

        // Try with HEAD request first (faster)
        const response = await fetch(url, {
          method: 'HEAD',
          signal: controller.signal,
          mode: 'no-cors' // This will work even with CORS issues
        });

        clearTimeout(timeoutId);

        // With no-cors, we can't access status, so assume it's valid if no error
        return { valid: true, type: 'http', url };
      } catch (error) {
        return {
          valid: false,
          reason: error.name === 'AbortError' ? 'Timeout' : error.message,
          url
        };
      }
    }

    return { valid: false, reason: 'Invalid URL format', url };
  };

  // Use it in your component:
  useEffect(() => {
    const checkLogo = async () => {
      if (currentEducation?.instlogo?.data) {
        const result = await validateLogoUrl(currentEducation.instlogo.data);
        // console.log("Logo validation:", result);

        if (!result.valid) {
          // Logo is invalid, maybe set a flag or use fallback
          console.warn("Invalid logo detected:", result);
        }
      }
    };

    checkLogo();
  }, [currentEducation?.instlogo?.data]);

  const renderMenuContent = () => {
    switch (activeMenu) {
      case "my_profile":
        return (
          <div>
            <div className="about-me-personal text-left">
              <div className="form-display-title">
                <h2 className="headingforContent mb-0">About Me</h2>
                <div className="prof-profile-tab-actions">
                  <div className="flex-center">
                    <IconButton
                      onClick={() => {
                        setAboutOpen(true);
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                    <div className="sort-icons-cont">Edit</div>
                  </div>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={ProfessionalData?.is_about_public}
                          onChange={handleAboutMeSwitch}
                        />
                      }
                      label={ProfessionalData?.is_about_public ? "Public" : "Private"}
                    />
                  </FormGroup>
                </div>
              </div>
              <div className="text-left line-break m-0 p-0">
                {ProfessionalData?.about_me}
              </div>
            </div>

            <div className="about-me-personal">
              <div className="form-display-title mb-3">
                <h2 className="headingforContent mb-0">
                  Professional Information
                </h2>
                <div className="prof-profile-tab-actions">
                  <div className="flex-center" onClick={handleEditClick}>
                    <IconButton>
                      <EditIcon
                        className={`${professionOpen ? "color-blue" : ""}`}
                      />
                    </IconButton>
                    <div
                      className={`sort-icons-cont ${professionOpen ? "color-blue" : ""
                        }`}
                    >
                      Edit
                    </div>
                  </div>
                </div>
              </div>

              <div className="my-2 user-details-container">
                <div className="prof-profile-tab-item">
                  <div className="shared-profile-view">
                    <div className="profile-tab-item-details text-start">
                      {ProfessionalEdited?.CompanyName &&
                        ProfessionalEdited?.isFieldVisible?.CompanyName ? (
                        <div className="university-name">
                          {ProfessionalEdited?.CompanyName}
                        </div>
                      ) : null}

                      {ProfessionalEdited?.CompanyWeb &&
                        ProfessionalEdited?.isFieldVisible?.CompanyWeb ? (
                        <div className="bordered-study-year2 design-lighter-text flex-center my-0">
                          {ProfessionalEdited?.CompanyWeb}
                        </div>
                      ) : null}

                      {ProfessionalEdited?.CompanyAddress &&
                        ProfessionalEdited?.isFieldVisible?.CompanyAddress && (
                          <div>{ProfessionalEdited?.CompanyAddress}</div>
                        )}

                      <div className="bordered-study-year2 design-lighter-text flex-center mt-0">
                        {ProfessionalEdited?.StartDate
                          ? ProfessionalEdited?.StartDate
                          : ""}{" "}
                        {ProfessionalEdited?.isCurrentlyWorking
                          ? " - Present"
                          : ProfessionalEdited?.EndDate
                            ? "- " + ProfessionalEdited?.EndDate
                            : ""}
                      </div>

                      {/* Display Designation and Department based on the logic provided */}
                      {ProfessionalEdited?.isFieldVisible?.Designation &&
                        ProfessionalEdited?.Designation &&
                        ProfessionalEdited?.isFieldVisible?.Department &&
                        ProfessionalEdited?.Department ? (
                        <div>
                          {ProfessionalEdited?.Designation} -{" "}
                          {ProfessionalEdited?.Department}
                        </div>
                      ) : ProfessionalEdited?.isFieldVisible?.Designation &&
                        ProfessionalEdited?.Designation ? (
                        <div>{ProfessionalEdited?.Designation}</div>
                      ) : ProfessionalEdited?.isFieldVisible?.Department &&
                        ProfessionalEdited?.Department ? (
                        <div>{ProfessionalEdited?.Department}</div>
                      ) : null}

                      {ProfessionalEdited?.isFieldVisible?.CompanyEmail &&
                        ProfessionalEdited?.CompanyEmail &&
                        ProfessionalEdited?.isFieldVisible?.CompanyPhone &&
                        ProfessionalEdited?.CompanyPhone ? (
                        <div className="bordered-study-year2 design-lighter-text flex-center mt-0">
                          {ProfessionalEdited?.CompanyEmail} -{" "}
                          {ProfessionalEdited?.CompanyPhone.replace(/\s+/g, '')}
                        </div>
                      ) : ProfessionalEdited?.isFieldVisible?.CompanyEmail &&
                        ProfessionalEdited?.CompanyEmail ? (
                        <div className="bordered-study-year2 design-lighter-text flex-center mt-0">
                          {ProfessionalEdited?.CompanyEmail}
                        </div>
                      ) : ProfessionalEdited?.isFieldVisible?.CompanyPhone &&
                        ProfessionalEdited?.CompanyPhone ? (
                        <div className="bordered-study-year2 design-lighter-text flex-center mt-0">
                          {" "}
                          {ProfessionalEdited?.CompanyPhone.replace(/\s+/g, '')}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* {services?.services_info?.length > 0 && (
              <div className="professional-page-section">
                <div className="form-display-title">
                  <h2 className="headingforContent">Services</h2>
                  <div className="prof-profile-tab-actions">
                    <div
                      className="flex-center"
                      onClick={handleEditServicesClick}
                    >
                      <IconButton>
                        <EditIcon
                          className={`${OpenAddMoreSection ? "color-blue" : ""
                            }`}
                        />
                      </IconButton>
                      <div
                        className={`sort-icons-cont ${OpenAddMoreSection ? "color-blue" : ""
                          }`}
                      >
                        Edit
                      </div>
                    </div>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={isSectionPublicInfo?.services}
                            onChange={handleSectionSwitch(SERVICES, "services")}
                          />
                        }
                        label="Public"
                      />
                    </FormGroup>
                  </div>
                </div>

                <div className="education-list">
                  <div className="education-item text-left profile-form-display">
                    <div>
                      <div className="project-profile">Services Provided:</div>
                      {parsedServices?.services_info?.length > 0 && (
                        <div className="design-lighter-textNew">
                          {parsedServices?.services_info?.map((service, index) => (
                            <span key={index}>
                              {service} {index < parsedServices?.services_info?.length - 1 && <span>&middot;</span>}
                            </span>
                          ))}
                        </div>
                      )}
                    </div>
                    {services?.about_services?.trim() !== "" && (
                      <div>
                        <div className="project-profile">Service Details:</div>
                        <div className="design-lighter-textNew line-break">
                          {services?.about_services}
                        </div>
                      </div>
                    )}
                    {services?.location !== "" ||
                      (services?.is_available_remote !== "" && (
                        <div>
                          <div className="project-profile">Work Location:</div>
                          <div className="design-lighter-textNew">
                            {services?.location} <span>&middot;</span>{" "}
                            {services?.remote}
                          </div>
                        </div>
                      ))}

                    <div>
                      {((services?.start_day && services.end_day) ||
                        (services?.starting_hour && services?.ending_hour)) && (
                          <>
                            <div className="project-profile">Working Hours:</div>
                            <div className="design-lighter-textNew">
                              {services?.start_day && services.end_day && (
                                <>
                                  {services?.start_day} to {services?.end_day}
                                  <span> &middot; </span>
                                </>
                              )}
                              {services?.start_day && services?.ending_hour && (
                                <>
                                  {formatTime(services?.start_day)} to{" "}
                                  {formatTime(services?.ending_hour)}
                                </>
                              )}
                            </div>
                          </>
                        )}
                    </div>

                    {services?.hourly_rate > 0 && (
                      <div>
                        <div className="project-profile">Pricing:</div>
                        <div className="design-lighter-textNew me-2">
                          Starting at {services?.currency ?? 0} {services?.hourly_rate}
                          /hour
                        </div>
                      </div>
                    )}

                    {services?.attachments?.length !== 0 && (
                      <div>
                        <div className="project-profile">Attachments:</div>
                        {services?.attachments
                          ?.filter((attachment) => !attachment?.toBeDeleted)
                          ?.map((attachment, idx) => (
                            <div
                              key={idx}
                              className="profile-project-display mb-3"
                            >
                              {typeof attachment === "string" ? (
                                <div className="design-lighter-textNew">
                                  {attachment}
                                </div>
                              ) : (
                                <div className="Documents-Attachments">
                                  <PreviewFileItem file={attachment} />
                                </div>
                              )}
                            </div>
                          ))}
                      </div>
                    )}
                    <div className="divider" />
                  </div>
                </div>
              </div>
            )} */}

            {ProfessionalServices?.length > 0 &&
              ProfessionalServices.map(
                (service, index) =>
                  service?.services_info &&
                  JSON.parse(service?.services_info || "[]")?.length > 0 && (
                    <div key={index} className="professional-page-section">
                      <div className="form-display-title">
                        <h2 className="headingforContent">Services</h2>
                        <div className="prof-profile-tab-actions">
                          <div
                            className="flex-center"
                            onClick={handleEditServicesClick}
                          >
                            <IconButton>
                              <EditIcon
                                className={`${OpenAddMoreSection ? "color-blue" : ""
                                  }`}
                              />
                            </IconButton>
                            <div
                              className={`sort-icons-cont ${OpenAddMoreSection ? "color-blue" : ""
                                }`}
                            >
                              Edit
                            </div>
                          </div>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={Boolean(
                                    ProfessionalServices?.[0]?.is_public
                                  )}
                                  onChange={handleSectionSwitch(
                                    SERVICES,
                                    "services"
                                  )}
                                />
                              }
                              label={Boolean(
                                ProfessionalServices?.[0]?.is_public
                              ) ? "Public" : "Private"}
                            />
                          </FormGroup>
                        </div>
                      </div>

                      <div className="education-list">
                        <div className="education-item text-left profile-form-display">
                          {/* Services Provided */}
                          <div>
                            <div className="project-profile">
                              Services Provided:
                            </div>
                            <div className="design-lighter-textNew">
                              {JSON.parse(service?.services_info || "[]").map(
                                (item, idx, arr) => (
                                  <span key={idx}>
                                    {item}{" "}
                                    {idx < arr?.length - 1 && (
                                      <span>&middot;</span>
                                    )}
                                  </span>
                                )
                              )}
                            </div>
                          </div>

                          {/* Service Details */}
                          {service?.about_services?.trim() !== "" && (
                            <div>
                              <div className="project-profile">
                                Service Details:
                              </div>
                              <div className="design-lighter-textNew line-break">
                                {service?.about_services}
                              </div>
                            </div>
                          )}

                          {/* Work Location */}
                          {(service?.location ||
                            service?.is_available_remote) && (
                              <div>
                                <div className="project-profile">
                                  Work Location:
                                </div>
                                <div className="design-lighter-textNew">
                                  {service?.location}{" "}
                                  {service?.is_available_remote && (
                                    <span>&middot; Remote</span>
                                  )}
                                </div>
                              </div>
                            )}

                          {/* Working Hours */}
                          {((service?.start_day && service?.end_day) ||
                            (service?.starting_hour &&
                              service?.ending_hour)) && (
                              <div>
                                <div className="project-profile">
                                  Working Hours:
                                </div>
                                <div className="design-lighter-textNew">
                                  {service?.start_day && service?.end_day && (
                                    <>
                                      {service?.start_day} to {service?.end_day}
                                      <span> &middot; </span>
                                    </>
                                  )}
                                  {service?.starting_hour &&
                                    service?.ending_hour && (
                                      <>
                                        {formatTime(service?.starting_hour)} to{" "}
                                        {formatTime(service?.ending_hour)}
                                      </>
                                    )}
                                </div>
                              </div>
                            )}

                          {/* Pricing */}
                          {parseFloat(service?.hourly_rate) > 0 && (
                            <div>
                              <div className="project-profile">Pricing:</div>
                              <div className="design-lighter-textNew me-2">
                                Starting at {service?.currency ?? ""}{" "}
                                {service?.hourly_rate} /hour
                              </div>
                            </div>
                          )}

                          {/* Attachments */}
                          {service?.attachments?.length > 0 && (
                            <div>
                              <div className="project-profile">
                                Attachments:
                              </div>
                              {service?.attachments
                                ?.filter(
                                  (attachment) => !attachment?.toBeDeleted
                                )
                                ?.map((attachment, idx) => (
                                  <div
                                    key={idx}
                                    className="profile-project-display my-3"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleOpenPreview(attachment)}
                                  >
                                    {typeof attachment === "string" ? (
                                      <a href={attachment?.data}>
                                        <div className="design-lighter-textNew">
                                          {attachment}
                                        </div>
                                      </a>
                                    ) : (
                                      <div className="Documents-Attachments" style={{ display: 'flex', alignItems: 'center' }}>
                                        <PreviewFileItem
                                          file={attachment}
                                          fontColor="#00000099"
                                          showOnlyIcon={true}
                                        />
                                        <IconButton
                                          onClick={(e) => { e.stopPropagation(); handleOpenPreview(attachment); }}
                                          sx={{ color: '#00000099' }}
                                        >
                                          <VisibilityIcon />
                                        </IconButton>
                                      </div>
                                    )}
                                  </div>
                                ))}
                            </div>
                          )}

                          <div className="divider" />
                        </div>
                      </div>
                    </div>
                  )
              )}

            <div className="professional-page-section">
              <div className="d-flex justify-content-between align-items-center">
                <h2 className="headingforContent">Soft Skills</h2>
                <div className="prof-profile-tab-actions">
                  <div
                    className="flex-center"
                    onClick={() => handleOpenSkillsModal("softSkills")}
                  >
                    <IconButton>
                      <AddCircleRoundedIcon />
                    </IconButton>
                    <div className="sort-icons-cont">Add</div>
                  </div>
                  <div
                    className="flex-center"
                    onClick={() => handleEditSkillChange("softSkills")}
                  >
                    <IconButton>
                      <EditIcon
                        className={`${isSkillEdit?.softSkills ? "color-blue" : ""
                          }`}
                      />
                    </IconButton>
                    <div
                      className={`sort-icons-cont  ${isSkillEdit?.softSkills ? "color-blue" : ""
                        }`}
                    >
                      Edit
                    </div>
                  </div>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={
                            ProfessonalSoftSkills?.is_public === 1
                              ? true
                              : false
                          }
                          onChange={handleSectionSwitch(
                            SOFT_SKILLS,
                            "softSkills"
                          )}
                        />
                      }
                      label={ProfessonalSoftSkills?.is_public === 1 ? "Public" : "Private"}
                    />
                  </FormGroup>
                </div>
              </div>

              <div className="skills-list-professional">
                {Skills?.softSkills?.map((skill, index) => (
                  <SkillItem
                    key={skill}
                    label={skill}
                    skillsKey={"softSkills"}
                    isEdit={isSkillEdit?.softSkills}
                    onAdd={handleAddSkill}
                  />
                ))}
                <SkillItemForNewAddItem
                  selectedSkills={Skills?.softSkills}
                  skillsKey="softSkills"
                  onAdd={handleManualAddSkill}
                  label={"Type Skills"}
                />
              </div>
              {isSkillEdit.softSkills && (
                <div className="mt-3 d-flex justify-content-end">
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: "#0044C6" }}
                    onClick={() => handleSkillsSave("softSkills", SOFT_SKILLS)}
                  >
                    Save
                  </Button>
                </div>
              )}
            </div>

            <div className="professional-page-section">
              <div className="d-flex justify-content-between align-items-center">
                <h2 className="headingforContent">Professional Skills</h2>
                <div className="prof-profile-tab-actions">
                  <div
                    className="flex-center"
                    onClick={() => handleOpenSkillsModal("profSkills")}
                  >
                    <IconButton>
                      <AddCircleRoundedIcon />
                    </IconButton>
                    <div className="sort-icons-cont">Add</div>
                  </div>
                  <div
                    className="flex-center"
                    onClick={() => handleEditSkillChange("profSkills")}
                  >
                    <IconButton>
                      <EditIcon
                        className={`${isSkillEdit.profSkills ? "color-blue" : ""
                          }`}
                      />
                    </IconButton>
                    <div
                      className={`sort-icons-cont  ${isSkillEdit.profSkills ? "color-blue" : ""
                        }`}
                    >
                      Edit
                    </div>
                  </div>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={
                            ProfessonalSkills?.is_public === 1 ? true : false
                          }
                          onChange={handleSectionSwitch(
                            PROFESSIONAL_SKILLS,
                            "profSkills"
                          )}
                        />
                      }
                      label={ProfessonalSkills?.is_public === 1 ? "Public" : "Private"}
                    />
                  </FormGroup>
                </div>
              </div>

              <div className="skills-list-professional">
                {Skills?.profSkills?.map((skill, index) => (
                  <SkillItem
                    key={skill}
                    label={skill}
                    skillsKey={"profSkills"}
                    isEdit={isSkillEdit.profSkills}
                    onAdd={handleAddSkill}
                  />
                ))}
                <SkillItemForNewAddItem
                  selectedSkills={Skills?.profSkills}
                  skillsKey="profSkills"
                  onAdd={handleManualAddSkill}
                  label={"Type Skills"}
                />
              </div>
              {isSkillEdit.profSkills && (
                <div className="mt-3 d-flex justify-content-end">
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: "#0044C6" }}
                    onClick={() =>
                      handleSkillsSave("profSkills", PROFESSIONAL_SKILLS)
                    }
                  >
                    Save
                  </Button>
                </div>
              )}
            </div>

            <div className="professional-page-section">
              <div className="d-flex justify-content-between align-items-center">
                <h2 className="headingforContent">Recommendations</h2>
                <div className="recommendations-tab-actions">
                  <IconButton
                    onClick={() => {
                      setaddRecommendation(true);
                      setOpenAddMoreSection(false);
                    }}

                    title="Add Recommendation"
                  >
                    <AddCircleRoundedIcon /> <spam className="sort-icons-cont">Add</spam>
                  </IconButton>

                </div>
              </div>

              {!Recommendation || visible?.length === 0 ? (
                <div className="py-1">No recommendations available.</div> // Message for empty recommendations
              ) : (
                <div
                  className="recommendations-list"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                    gap: "20px",
                  }}
                >
                  {Recommendation?.visileRecommendations?.map(
                    (recommendation) => (
                      <div
                        key={recommendation.id} // Ensure unique key is used
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          gap: "30px",
                          width: "100%",
                        }}
                      >
                        {/* Profile Picture & Name */}
                        <div
                          className="recommendation-item"
                          onClick={() => handleProfileClick(recommendation)} // Click to open modal with details
                          style={{ cursor: "pointer", textAlign: "center" }}
                        >
                          {recommendation.profilePic ? (
                            <img
                              src={recommendation.profilePic} // Removed redundant fallback
                              alt={`${recommendation.firstName} ${recommendation.lastName}`}
                              style={{
                                width: "60px",
                                height: "60px",
                                borderRadius: "50%",
                                marginBottom: "10px",
                                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                              }}
                              onError={(e) =>
                              (e.target.src =
                                "https://via.placeholder.com/50")
                              } // Handle broken image links
                            />
                          ) : (
                            <Avatar
                              sx={{
                                width: "60px",
                                height: "60px",
                                borderRadius: "50%",
                                marginBottom: "10px",
                                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                              }}
                            >
                              <InsertPhotoIcon
                                sx={{ color: "white" }}
                                fontSize="large"
                              />
                            </Avatar>
                          )}

                          <div>
                            {recommendation.firstName} {recommendation.lastName}
                          </div>
                        </div>

                        {/* Toggle Public Switch */}
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={recommendation?.isVisible}
                                onChange={handleRecommendationVisibility(
                                  recommendation.id
                                )}
                              />
                            }
                            label={recommendation?.isVisible ? "Public" : "Private"}
                          />
                        </FormGroup>

                        {/* Delete Icon */}
                        <IconButton
                          onClick={() =>
                            handleRemoveRecommendation(recommendation.id)
                          }
                        >
                          <DeleteIcon />
                        </IconButton>
                      </div>
                    )
                  )}
                </div>
              )}

              {addRecommendation && (
                <div className="lightbox-overlay">
                  <div className="lightbox-content-2 p-0" style={{ width: "40%" }}>
                    <AddRecommendation
                      setaddRecommendation={setaddRecommendation}
                      setOpenAddMoreSection={setOpenAddMoreSection}
                    />
                  </div>
                </div>
              )}

              {/* Modal for displaying the full recommendation details */}
              <Dialog
                open={openModal}
                onClose={handleCloseModal}
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle>Recommendation Details</DialogTitle>
                <DialogContent>
                  {selectedRecommendation && (
                    <>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "20px",
                          marginTop: "10px",
                        }}
                      >
                        {selectedRecommendation.profilePic ? (
                          <img
                            src={
                              selectedRecommendation.profilePic ||
                              "https://via.placeholder.com/80"
                            }
                            alt={selectedRecommendation.firstName}
                            style={{
                              width: "80px",
                              height: "80px",
                              borderRadius: "50%",
                              marginRight: "20px",
                              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                            }}
                          />
                        ) : (
                          <Avatar
                            sx={{
                              width: "60px",
                              height: "60px",
                              borderRadius: "50%",
                              marginBottom: "20px",
                              marginRight: "20px",
                              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            <InsertPhotoIcon
                              sx={{ color: "white" }}
                              fontSize="large"
                            />
                          </Avatar>
                        )}

                        <div>
                          <h4>{`${selectedRecommendation.firstName} ${selectedRecommendation.lastName}`}</h4>
                          <p>{selectedRecommendation.text}</p>
                        </div>
                      </div>
                    </>
                  )}
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseModal} color="primary">
                    Close
                  </Button>
                </DialogActions>
              </Dialog>
            </div>

            <div className="professional-page-section">
              <div className="d-flex justify-content-between align-items-center">
                <h2 className="headingforContent">Tools</h2>
                <div className="prof-profile-tab-actions">
                  <div
                    className="flex-center"
                    onClick={() => handleOpenSkillsModal("profTools")}
                  >
                    <IconButton>
                      <AddCircleRoundedIcon />
                    </IconButton>
                    <div className="sort-icons-cont">Add</div>
                  </div>
                  <div
                    className="flex-center"
                    onClick={() => {
                      handleEditSkillChange("profTools");
                    }}
                  >
                    <IconButton>
                      <EditIcon
                        className={`${isSkillEdit.profTools ? "color-blue" : ""
                          }`}
                      />
                    </IconButton>
                    <div
                      className={`sort-icons-cont  ${isSkillEdit.profTools ? "color-blue" : ""
                        }`}
                    >
                      Edit
                    </div>
                  </div>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={
                            ProfessonalToolsSkills?.is_public === 1
                              ? true
                              : false
                          }
                          onChange={handleSectionSwitch(TOOLS, "profTools")}
                        />
                      }
                      label={ProfessonalToolsSkills?.is_public === 1 ? "Public" : "Private"}
                    />
                  </FormGroup>
                </div>
              </div>

              <div className="skills-list-professional">
                {Skills?.profTools?.map((skill, index) => (
                  <SkillItem
                    key={skill}
                    label={skill}
                    skillsKey="profTools"
                    isEdit={isSkillEdit?.profTools}
                    onAdd={handleAddSkill}
                  />
                ))}
                <SkillItemForNewAddItem
                  selectedSkills={Skills?.profTools}
                  skillsKey="profTools"
                  onAdd={handleManualAddSkill}
                  label={"Type Skills"}
                />
              </div>
              {isSkillEdit.profTools && (
                <div className="mt-3 d-flex justify-content-end">
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: "#0044C6" }}
                    onClick={() => handleSkillsSave("profTools", TOOLS)}
                  >
                    Save
                  </Button>
                </div>
              )}
            </div>

            {sortedProjectList?.length > 0 && (
              <div className="professional-page-section">
                <div className="form-display-title">
                  <h2 className="headingforContent">Project Details</h2>
                  <div className="prof-profile-tab-actions">
                    <div className="flex-center" onClick={handleProjectAddMore}>
                      <IconButton>
                        <AddCircleRoundedIcon />
                      </IconButton>
                      <div className="sort-icons-cont">Add Project</div>
                    </div>
                  </div>
                </div>

                <div className="education-list">
                  {sortedProjectList?.map((project, index) => (
                    <div
                      key={index}
                      className="education-item text-left profile-form-display"
                    >
                      <div className="prof-profile-tab-actions form-display-edit">
                        <div
                          className="flex-center"
                          onClick={() => handleEditProject(index)}
                        >
                          <IconButton>
                            <EditIcon
                              className={isEditProject ? "color-blue" : ""}
                            />
                          </IconButton>
                          <div
                            className={`sort-icons-cont ms-0 ${isEditProject ? "color-blue" : ""
                              }`}
                          >
                            Edit
                          </div>
                        </div>
                        <FormGroup>
                          <FormControlLabel
                            control={
                              <Switch
                                checked={project?.is_public}
                                onChange={handleItemSwitch(
                                  PROJECTS,
                                  project?.id
                                )}
                              />
                            }
                            label={project?.is_public ? "Public" : "Private"}
                          />
                        </FormGroup>
                      </div>
                      <div>
                        <div className="project-profile">Name:</div>
                        <div className="design-lighter-textNew">
                          {project?.project_name}
                        </div>
                      </div>
                      {((project?.start_month && project?.start_year) ||
                        (project?.end_month && project?.end_year)) && (
                          <div>
                            <div className="project-profile">Duration:</div>
                            <div className="design-lighter-textNew">
                              {project?.start_month} {project?.start_year} -{" "}
                              {project?.is_current_project
                                ? "Present"
                                : project?.end_month + " " + project?.end_year}
                            </div>
                          </div>
                        )}
                      {project?.project_description?.length !== 0 && (
                        <div>
                          <div className="project-profile">Description:</div>
                          <div className="design-lighter-textNew me-2 line-break">
                            {project.project_description}
                          </div>
                        </div>
                      )}
                      {project?.attachments?.length !== 0 && (
                        <>
                          <div>
                            <div className="project-profile">Attachments:</div>
                            {project?.attachments
                              ?.filter((attachment) => !attachment.toBeDeleted)
                              ?.map((attachment, idx) => (
                                <div
                                  key={idx}
                                  className="profile-project-display my-3"
                                >
                                  {typeof attachment === "string" ? (
                                    <a href={attachment?.data}>
                                      <div className="design-lighter-textNew">
                                        {attachment}
                                      </div>
                                    </a>
                                  ) : (
                                    <div className="Documents-Attachments">
                                      <PreviewFileItem
                                        file={attachment}
                                        fontColor="#00000099"
                                      />
                                    </div>
                                  )}
                                </div>
                              ))}
                          </div>
                        </>
                      )}
                      <div className="divider" />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {sortedAwardsList?.length > 0 && (
              <div className="professional-page-section">
                <div className="form-display-title">
                  <h2 className="headingforContent">Honors and Awards</h2>
                  <div className="prof-profile-tab-actions">
                    <div className="flex-center" onClick={handleAwardsAddMore}>
                      <IconButton>
                        <AddCircleRoundedIcon />
                      </IconButton>
                      <div className="sort-icons-cont">Add Award</div>
                    </div>
                  </div>
                </div>

                <div className="education-list">
                  {sortedAwardsList?.map((award, index) => {

                    return (
                      <div
                        key={award?.id}
                        className="education-item text-left profile-form-display"
                      >
                        <div className="prof-profile-tab-actions form-display-edit">
                          <div
                            className="flex-center"
                            onClick={() => handleEditAwards(index)}
                          >
                            <IconButton>
                              <EditIcon />
                            </IconButton>
                            <div className={`sort-icons-cont ms-0`}>Edit</div>
                          </div>
                          <FormGroup>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={award?.isPublic}
                                  onChange={handleItemSwitch(
                                    AWARDS_HONOUS,
                                    award.id
                                  )}
                                />
                              }
                              label={award?.isPublic ? "Public" : "Private"}
                            />
                          </FormGroup>
                        </div>
                        <div>
                          <div className="project-profile">Title:</div>
                          <div className="design-lighter-textNew">
                            {award?.award_title}
                          </div>
                        </div>
                        {(award?.issue_month || award?.issue_year) && (
                          <div>
                            <div className="project-profile">Issue Date:</div>
                            <div className="design-lighter-textNew">
                              {award?.issue_month} {award?.issue_year}
                            </div>
                          </div>
                        )}
                        {award?.associated_with && (
                          <div>
                            <div className="project-profile">
                              Associated With:
                            </div>
                            <div className="design-lighter-textNew">
                              {award?.associated_with}
                            </div>
                          </div>
                        )}
                        {award?.issuer && (
                          <div>
                            <div className="project-profile">Issuer:</div>
                            <div className="design-lighter-textNew">
                              {award?.issuer}
                            </div>
                          </div>
                        )}
                        {award?.description?.length !== 0 && (
                          <div>
                            <div className="project-profile">Description:</div>
                            <div className="design-lighter-textNew me-2 line-break">
                              {award?.description}{" "}
                            </div>
                          </div>
                        )}
                        {award?.attachments?.length !== 0 && (
                          <div>
                            <div className="project-profile">Attachments:</div>

                            {award?.attachments
                              ?.filter((attachment) => !attachment.toBeDeleted)
                              ?.map((attachment, idx) => (
                                <div
                                  key={idx}
                                  className="profile-project-display my-3"
                                >
                                  {typeof attachment === "string" ? (
                                    <a href={attachment}>
                                      <div className="design-lighter-textNew">
                                        {attachment}
                                      </div>
                                    </a>
                                  ) : (
                                    <div className="Documents-Attachments" style={{ display: 'flex', alignItems: 'center' }}>
                                      <PreviewFileItem
                                        file={attachment}
                                        fontColor="#00000099"
                                        showOnlyIcon={true}
                                      />
                                      <IconButton
                                        onClick={(e) => { e.stopPropagation(); handleOpenPreview(attachment); }}
                                        sx={{ color: '#00000099' }}
                                      >
                                        <VisibilityIcon />
                                      </IconButton>
                                    </div>
                                  )}
                                </div>
                              ))}
                          </div>
                        )}
                        <div className="divider" />
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        );
      case "education":
        return (
          <div>
            <div className="about-me-personal text-left">
              <div className="mb-2 d-flex justify-content-between align-items-center">
                <h2 className="headingforContent">Education</h2>
                <div className="prof-profile-tab-actions">
                  <div className="flex-center" onClick={handleEduAddMore}>
                    <IconButton>
                      <AddCircleRoundedIcon />
                    </IconButton>
                    <div className="sort-icons-cont">Add Education</div>
                  </div>
                </div>
              </div>

              <div className="education-list">
                {sortedEducationList?.map((education, index) => (
                  <div className="education-item" key={index}>
                    <div className="prof-profile-tab-item">
                      <div className="institute-logo-container flex-center">
                        {/* {education?.logo_link ? (
                          <img src={education?.logo_link} alt="Institute" />
                        ) : (
                          <img src={DefaultLogo} alt="Not Available" />
                        )} */}
                        {/* <RobustLogo
                          src={education?.logo_link}
                          alt={education?.institute_name || "Institute"}
                          className="institute-logo"
                          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                          fallbackService={true}
                          onErrorLog={true}
                        /> */}
                        {education?.logo_link && typeof education?.logo_link === 'string' &&
                          (education?.logo_link?.startsWith('https') || education?.logo_link?.startsWith('data:')) || education?.logo_link?.startsWith('http') ? (
                          <RobustLogo
                            src={education?.logo_link || ""}
                            alt={education?.institute_name || "Institute"}
                            className="institute-logo"
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                          />
                        ) : (
                          <img
                            src={DefaultLogo}
                            alt="Institute"
                            className="institute-logo"
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                          />
                        )}
                      </div>
                      <div className="institute-details d-flex flex-column text-left">
                        <div className="d-flex justify-content-between align-items-end mb-0">
                          <div className="university-name">
                            <span>{education?.institute_name}</span>
                            <span className="span-center-align">
                              {education?.is_verified === true ? (
                                <VerifiedTick className="green-verified-tick" />
                              ) : (
                                <VerifiedTick />
                              )}
                            </span>
                          </div>
                          <div className="prof-profile-tab-actions form-display-edit">
                            {education?.is_verified === true ? (
                              ""
                            ) : (
                              <div
                                className="flex-center"
                                onClick={() =>
                                  handleVerifyEducationModal(education, index)
                                }
                              >
                                <IconButton>
                                  <VerifyIcon />
                                </IconButton>
                                <div className={`sort-icons-cont ms-0`}>
                                  Verify
                                </div>
                              </div>
                            )}

                            <div
                              className="flex-center"
                              onClick={() =>
                                handleEditEducation(education, index)
                              }
                            >
                              <IconButton>
                                <EditIcon />
                              </IconButton>
                              <div className={`sort-icons-cont ms-0`}>Edit</div>
                            </div>
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={education?.is_public ?? true}
                                    onChange={handleItemSwitch(
                                      EDUCATION,
                                      education.id
                                    )}
                                  />
                                }
                                label={education?.is_public ? "Public" : "Private"}
                              />
                            </FormGroup>
                          </div>
                        </div>
                        <div className="bordered-study-year2 design-lighter-text flex-center">
                          {education?.start_year} -{" "}
                          {education?.is_pursuing === true
                            ? "Present"
                            : education?.end_year}
                        </div>
                        {education?.degree ? (
                          <div className="mb-1">{education?.degree}</div>
                        ) : null}
                        {education?.field_of_study ? (
                          <div className="mb-1">
                            {education?.field_of_study}
                          </div>
                        ) : null}
                        {education?.educational_level === "SSLC" ? (
                          <div className="mb-1">
                            {education?.educational_level}
                          </div>
                        ) : null}
                        <div className="mb-1">{education?.board}</div>
                        {education?.desc ||
                          ("" !== "" && (
                            <>
                              <div className="mb-1">Details:</div>
                              <div className="design-lighter-text margin-bottom-8px word-break line-break">
                                {education?.desc}
                              </div>
                            </>
                          ))}
                        {education?.certificate_link && (
                          <div
                            className="d-flex align-items-center flex-start pointer"
                            onClick={() =>
                              openDocumentViewer({
                                document_url: education?.certificate_link,
                                document_type: getDocumentType(education?.certificate_link),
                                document_name: "certificate.png",
                              })
                            }
                          >
                            <div className="Certificate-design me-2">
                              Certificate
                            </div>
                            <IoLinkSharp className="icon-color" />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="divider" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
      case "certificate":
        return (
          <>
            <div>
              <div className="about-me-personal text-left">
                <div className="mb-2 d-flex justify-content-between align-items-center">
                  <h2 className="headingforContent">Certificate</h2>
                  <div className="prof-profile-tab-actions">
                    <div className="flex-center" onClick={handleCertAddMore}>
                      <IconButton>
                        <AddCircleRoundedIcon />
                      </IconButton>
                      <div className="sort-icons-cont"> Add Certificate</div>
                    </div>
                  </div>
                </div>

                <div className="education-list">
                  {sortedCertificateList?.map((certification, index) => (
                    <div className="education-item" key={index}>
                      <div className="prof-profile-tab-item">
                        <div className="institute-logo-container mt-1 flex-center">
                          {certification?.certificate_logo ? (
                            <>
                              <img
                                src={certification?.certificate_logo}
                                alt="Certificate Logo"
                              />
                            </>
                          ) : (
                            <img src={DefaultLogo} alt="Not Available" />
                          )}
                        </div>
                        <div className="institute-details d-flex flex-column text-left">
                          <div className="d-flex justify-content-between align-items-end mb-0">
                            <div className="university-name">

                              {certification?.course_name}
                              <span className="span-center-align">
                                {certification?.is_verified === true ? (
                                  <VerifiedTick className="green-verified-tick" />
                                ) : (
                                  <VerifiedTick /> // This will show gray/unverified tick
                                )}
                              </span>
                            </div>
                            <div className="prof-profile-tab-actions form-display-edit">
                              {certification?.is_verified === true ? (
                                ""
                              ) : (
                                <div
                                  className="flex-center"
                                  onClick={() =>
                                    handleVerifyCertificateModal(
                                      certification,
                                      index
                                    )
                                  }
                                >
                                  <IconButton>
                                    <VerifyIcon />
                                  </IconButton>
                                  <div className={`sort-icons-cont ms-0`}>
                                    Verify
                                  </div>
                                </div>
                              )}

                              <div
                                className="flex-center"
                                onClick={() =>
                                  handleEditCertificate(certification, index)
                                }
                              >
                                <IconButton>
                                  <EditIcon />
                                </IconButton>
                                <div className={`sort-icons-cont ms-0`}>
                                  Edit
                                </div>
                              </div>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={certification?.is_public ?? true}
                                      onChange={handleItemSwitch(
                                        CERTIFICATE,
                                        certification.id
                                      )}
                                    />
                                  }
                                  label={certification?.is_public ?? true ? "Public" : "Private"}
                                />
                              </FormGroup>
                            </div>
                          </div>
                          <div className="mb-1">
                            {certification?.organisation_name}
                          </div>
                          {(certification?.issue_date ||
                            certification?.year) && (
                              <div className="bordered-study-year2 design-lighter-text flex-center">
                                {certification?.issue_date} {certification?.year}
                              </div>
                            )}

                          {certification?.description && (
                            <>
                              <div className="mb-1">Details:</div>
                              <div className="design-lighter-text margin-bottom-8px word-break line-break">
                                {certification?.description}
                              </div>
                            </>
                          )}
                          {certification?.certificate_doc && (
                            <div
                              className="d-flex align-items-center flex-start pointer"
                              onClick={() =>
                                openDocumentViewer({
                                  document_url: certification?.certificate_doc,
                                  // document_type: "image/png",
                                  document_type: getDocumentType(certification?.certificate_doc),
                                  document_name: "certificate.png",
                                })
                              }
                            >
                              <div className="Certificate-design me-2">
                                Certificate
                              </div>
                              <IoLinkSharp className="icon-color" />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="divider" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        );
      case "experience":
        return (
          <>
            <div>
              <div className="about-me-personal text-left">
                <div className="mb-2 d-flex justify-content-between align-items-center">
                  <h2 className="headingforContent">Experience</h2>
                  <div className="prof-profile-tab-actions">
                    <div className="flex-center" onClick={handleExpAddMore}>
                      <IconButton>
                        <AddCircleRoundedIcon />
                      </IconButton>
                      <div className="sort-icons-cont">Add Experience</div>
                    </div>
                  </div>
                </div>

                <div className="education-list">
                  {sortedExperienceList?.map((experience, index) => (
                    <div className="education-item" key={index}>
                      <div className="prof-profile-tab-item">
                        <div className="institute-logo-container mt-1 flex-center">
                          {experience?.company_logo ? (
                            <img
                              src={experience?.company_logo}
                              alt={experience.companylogo?.name}
                            />
                          ) : (
                            <img src={DefaultLogo} alt="Not Available" />
                          )}
                        </div>
                        <div className="institute-details experience-info d-flex flex-column text-left">
                          <div className="d-flex justify-content-between align-items-end mb-0">
                            <div className="university-name">
                              {experience?.role_title}
                              <span className="span-center-align">
                                {experience?.is_verified === true ? (
                                  <VerifiedTick className="green-verified-tick" />
                                ) : (
                                  <VerifiedTick />
                                )}
                              </span>
                            </div>
                            <div className="prof-profile-tab-actions form-display-edit">
                              {experience?.is_verified === true ? (
                                ""
                              ) : (
                                <div
                                  className="flex-center"
                                  onClick={() => {
                                    handleVerifyExperienceModal(
                                      experience,
                                      index
                                    );
                                  }}
                                >
                                  <IconButton>
                                    <VerifyIcon />
                                  </IconButton>
                                  <div className={`sort-icons-cont ms-0`}>
                                    Verify
                                  </div>
                                </div>
                              )}

                              <div
                                className="flex-center"
                                onClick={() =>
                                  handleEditExperience(experience, index)
                                }
                              >
                                <IconButton>
                                  <EditIcon />
                                </IconButton>
                                <div className={`sort-icons-cont ms-0`}>
                                  Edit
                                </div>
                              </div>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={experience?.is_public}
                                      onChange={handleItemSwitch(
                                        EXPERIENCE,
                                        experience.id
                                      )}
                                    />
                                  }
                                  label={experience?.is_public ? "Public" : "Private"}
                                />
                              </FormGroup>
                            </div>
                          </div>
                          <div className="role-title-bold pt-1">
                            {experience?.company_name}
                          </div>
                          {experience?.profile_headline && <div>{experience?.profile_headline}</div>}
                          <div className="d-flex align-items-center justify-content-start design-lighter-text">
                            <div>{experience?.location}</div>
                            <span className="dot-locationtype">.</span>
                            <div>{experience?.location_type}</div>
                          </div>
                          <div className="bordered-study-year2 design-lighter-text flex-center mb-2">
                            {experience?.start_month
                              ?.substring(0, 3)
                              ?.toUpperCase()}{" "}
                            {experience?.start_year || ""} -{" "}
                            {experience?.is_currently_working
                              ? "Present"
                              : experience?.end_month && experience?.end_year
                                ? `${experience?.end_month
                                  .substring(0, 3)
                                  .toUpperCase()} ${experience?.end_year}`
                                : ""}
                          </div>
                          {/* <div className="role-title-bold">
                            {experience?.role_title}
                          </div> */}
                          <div className="">{experience?.employee_type}</div>
                          {experience?.responsibility?.length > 0 && (
                            <div className="design-lighter-text">
                              {experience?.responsibility
                                ? experience?.responsibility
                                  .split(", ")
                                  .filter(Boolean)
                                  .join(" • ")
                                : []}
                            </div>
                          )}
                          {experience?.details && (
                            <>
                              <div className="mb-1">Details:</div>
                              <div className="design-lighter-text margin-bottom-8px word-break line-break">
                                {experience?.details}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="divider" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        );
      case "resume":
        return (
          <>
            <div>
              <div className="about-me-personal text-left">
                <div className="d-flex justify-content-between align-items-center">
                  <h2 className="headingforContent">Resume</h2>
                  <div className="prof-profile-tab-actions">
                    <div
                      className="flex-center"
                      onClick={() => {
                        setisModalResume(true);
                      }}
                    >
                      <IconButton>
                        <AddCircleRoundedIcon />
                      </IconButton>
                      <div className="sort-icons-cont">Add</div>
                    </div>
                    {/* <div className="flex-center" onClick={() => { setisModalResume(true) }}>
                      <IconButton>
                        <EditIcon className={isModalResume ? 'color-blue' : ''} />
                      </IconButton>
                      <div className={`sort-icons-cont  ${isModalResume ? 'color-blue' : ''}`}>Edit</div>
                    </div> */}
                    {/* <FormGroup>
                      <FormControlLabel
                        control={<Switch defaultChecked />}
                        label="Public"
                      />
                    </FormGroup> */}
                  </div>
                </div>

                <div className="mt-2 mb-4">
                  <div className="mb-3">
                    <Button
                      variant="contained"
                      sx={{ backgroundColor: "#0044C6" }}
                      onClick={handleOpenResumeComponent}
                    >
                      Generate AI Resume
                    </Button>
                    <div className="sub-heading-style-16 mt-12px fw-bold">
                      <span className="span-center-align">
                        <InfoIcon className="me-2" />
                        <span>
                          Generate your AI-based resume. Details will be filled
                          from your profile inputs.
                        </span>
                      </span>
                    </div>
                    <div className="divider" />
                  </div>
                  {Resumedata?.length === 0 ? (
                    // <FileDragUpload maxSize={10000000} accept={ACCEPT} inputId={`file-upload-${inputId}`} contextUpdate={updateAttachDocs} />
                    <></>
                  ) : (
                    <>
                      {Resumedata?.length > 0 && (
                        <>
                          {Resumedata?.map((file, index) => (
                            <div className="education-list mb-3" key={index}>
                              <div className="resume-item">
                                <div className="d-flex">
                                  <div className="documents-logo-container flex-center">
                                    {/* Add a placeholder or icon for file type here */}
                                    {getFileIcon(file?.document_name)}
                                  </div>
                                  <div className="ms-3 institute-details d-flex flex-column text-left">
                                    <div className="d-flex justify-content-between align-items-center">
                                      <div className="file-name margin-bottom-8px">
                                        {file?.document_name.split(".")[0]}
                                      </div>
                                      <div className="prof-profile-tab-actions">
                                        <IconButton
                                          onClick={() =>
                                            handleShareResume(
                                              file?.document_url
                                            )
                                          }
                                        >
                                          <ShareIcon className="color-grey" />
                                        </IconButton>
                                        {/* <IconButton
                                          onClick={() => {
                                            setSelectedResume(file?.id);
                                            setDeleteResume(true);
                                          }}
                                        >
                                          <DeleteIcon />
                                        </IconButton> */}
                                      </div>
                                    </div>
                                    <div className="design-lighter-text margin-bottom-8px">
                                      Format:{" "}
                                      {file?.document_name
                                        .split(".")
                                        .pop()
                                        .toUpperCase()}{" "}
                                      | Upload: {file?.created_at}
                                    </div>
                                    <div
                                      className="d-flex justify-content-start align-items-center pointer"
                                      onClick={() => openDocumentViewer(file)}
                                    >
                                      <div className="Certificate-design me-1">
                                        Resume
                                      </div>
                                      <IoLinkSharp className="icon-color mt-1" />
                                    </div>
                                  </div>
                                </div>
                                <div className="divider" />
                              </div>
                            </div>
                          ))}
                        </>
                      )}

                      {/* {AttachDocs.images.length > 0 && (
                        <>
                          {AttachDocs.images.map((file, index) => (
                            <div className='education-list mb-3' key={index}>
                              <div className="resume-item">
                                <div className="d-flex">
                                  <div className="documents-logo-container flex-center">
                                    Add a placeholder or icon for file type here
                                    {getFileIcon(file.name)}
                                  </div>
                                  <div className="ms-3 institute-details d-flex flex-column text-left">
                                    <div className="d-flex justify-content-between">
                                      <div className="file-name margin-bottom-8px">{file.name.split('.')[0]}</div>
                                    </div>
                                    <div className="design-lighter-text margin-bottom-8px">Format: {file.name.split('.').pop().toUpperCase()} | Upload: {file.date}</div>
                                    <div className="d-flex flex-start">
                                      <div className="Certificate-design">Resume</div>
                                      <a href={file.data} target="_blank" rel="noopener noreferrer" className="ms-1 flex-center icon-new">
                                        <IoLinkSharp className="icon-color" />
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div className="divider" />
                              </div>
                            </div>
                          ))}
                        </>
                      )} */}
                      {/* <div className="d-flex justify-content-end">
                        <Button variant="contained" sx={{ backgroundColor: "#0044C6" }}>Save</Button>
                      </div> */}
                    </>
                  )}
                </div>

                <div className="mt-1 d-flex justify-content-between align-items-center">
                  <h2 className="headingforContent">Video Resume</h2>
                  <div className="prof-profile-tab-actions">
                    <Link
                      to="/myprofile/create-video-resume"
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <div className="flex-center">
                        <IconButton>
                          <AddCircleRoundedIcon />
                        </IconButton>
                        <div className="sort-icons-cont">Create New</div>
                      </div>
                    </Link>
                  </div>
                </div>
                {/* <div className="px-5 py-1">
                  <video width="85%" height="45%" controls style={{ borderRadius: "6px" }}>
                    <source src={videoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div> */}

                <div className="my-4">
                  {videoUrlArray?.length === 0 ? (
                    // <FileDragUpload maxSize={10000000} accept={['video/*']} inputId={`file-upload-${inputId}`} contextUpdate={updateAttachDocs} />
                    <></>
                  ) : (
                    <>
                      {/* {videoUrlArray?.length > 0 && (
                        <div>
                          {Resume.videos.map((file, index) => (
                            <div key={index}>
                              <div className="education-list mb-3">
                                <div className="education-item">
                                  <div className="d-flex">
                                    <div className="resume-image-container flex-center">
                                      <ReactPlayer
                                        url={videoUrl}
                                        className="react-player"
                                        playing={false}
                                        controls={false}
                                        loop={false}
                                        width="100%"
                                        height="100%"
                                      />
                                      <div
                                        className="custom-controls"
                                        onClick={() => {
                                          setPlaying(true);
                                        }}
                                      >
                                        <FaPlay size={50} color="white" />
                                      </div>

                                      {playing && (
                                        <div className="lightbox-overlay">
                                          <div
                                            className="lightbox-content-2"
                                            style={{ width: "40%" }}
                                          >
                                            <div className="active-component-container">
                                              <>
                                                <div className="d-flex justify-content-between">
                                                  <div className="card-edit-info-heading">
                                                    <h5 className="text-left">
                                                      Resume Video
                                                    </h5>
                                                  </div>
                                                  <button
                                                    className="lightbox-close2 pointer"
                                                    onClick={() =>
                                                      setPlaying(false)
                                                    }
                                                  >
                                                    ×
                                                  </button>
                                                </div>
                                                <ReactPlayer
                                                  url={file.data}
                                                  loop
                                                  controls
                                                  className="mx-auto preview-media-display"
                                                />
                                              </>
                                            </div>{" "}
                                          </div>{" "}
                                        </div>
                                      )}
                                    </div>
                                    <div className="ms-3 institute-details d-flex flex-column text-left">
                                      <div className="d-flex justify-content-between">
                                        <div className="file-name margin-bottom-8px">
                                          {file.name.split(".")[0]}
                                        </div>
                                      </div>
                                      <div className="design-lighter-text margin-bottom-8px">
                                        Format:{" "}
                                        {file.name
                                          .split(".")
                                          .pop()
                                          .toUpperCase()}{" "}
                                        | Upload: {file.date}
                                      </div>
                                      <div className="d-flex flex-start">
                                        <div className="Certificate-design">
                                          Resume
                                        </div>
                                        <a
                                          href={file.data}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="ms-1 flex-center icon-new"
                                        >
                                          <IoLinkSharp className="icon-color" />
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="divider" />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )} */}

                      {videoUrlArray && videoUrlArray?.length > 0 && (
                        <div>
                          <div key={0}>
                            <div className="education-list mb-3">
                              <div className="education-item">
                                <div className="d-flex">
                                  <div className="resume-image-container flex-center">
                                    <ReactPlayer
                                      url={videoUrlArray[0]?.document_url} // Accessing the first video URL directly
                                      className="react-player"
                                      playing={false}
                                      controls={false}
                                      loop={false}
                                      width="100%"
                                      height="100%"
                                    />
                                    <div
                                      className="custom-controls"
                                      onClick={() => {
                                        setPlaying(true);
                                      }}
                                    >
                                      <FaPlay size={50} color="white" />
                                    </div>

                                    {playing && (
                                      <div className="lightbox-overlay">
                                        <div
                                          className="lightbox-content-2"
                                          style={{ width: "40%" }}
                                        >
                                          <div className="active-component-container">
                                            <>
                                              <div className="d-flex justify-content-between">
                                                <div className="card-edit-info-heading">
                                                  <h5 className="text-left">
                                                    Resume Video
                                                  </h5>
                                                </div>
                                                <button
                                                  className="lightbox-close2 pointer"
                                                  onClick={() =>
                                                    setPlaying(false)
                                                  }
                                                >
                                                  ×
                                                </button>
                                              </div>
                                              <ReactPlayer
                                                url={
                                                  videoUrlArray[0]?.document_url
                                                } // Accessing the first video URL directly
                                                loop
                                                controls
                                                className="mx-auto preview-media-display"
                                              />
                                            </>
                                          </div>{" "}
                                        </div>{" "}
                                      </div>
                                    )}
                                  </div>
                                  <div className="ms-3 institute-details d-flex flex-column text-left">
                                    <div className="d-flex justify-content-between">
                                      <div className="file-name margin-bottom-8px">
                                        {
                                          videoUrlArray[0]?.document_name.split(
                                            "."
                                          )[0]
                                        }
                                      </div>
                                    </div>
                                    <div className="design-lighter-text margin-bottom-8px">
                                      Format:{" "}
                                      {videoUrlArray[0]?.document_name
                                        .split(".")
                                        .pop()
                                        .toUpperCase()}{" "}
                                      | Upload: {videoUrlArray[0]?.created_at}
                                    </div>
                                    <div
                                      className="d-flex flex-start"
                                      onClick={() =>
                                        openDocumentViewer(videoUrlArray[0])
                                      }
                                    >
                                      {/* <a
                                        href={videoUrlArray[0]?.document_url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="ms-1 flex-center icon-new"
                                      > */}
                                      <div className="Certificate-design me-1">
                                        Video Resume
                                      </div>
                                      <IoLinkSharp className="icon-color" />
                                      {/* </a> */}
                                    </div>
                                  </div>
                                </div>
                                <div className="divider" />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        );
      case "portfolio":
        return (
          <div>
            <div
              className="about-me-personal text-left"
              style={{ minHeight: "auto" }}
            >
              <div className="d-flex justify-content-between align-items-center">

                <a
                  href={`/portfolio?encryptedId=${encryptedUrlRef.current}&link=${objectId}`}
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div className="d-flex">
                    <h2 className="text-left m-0 p-0 color-blue fw-bold link-design-professional headingforContent">
                      Your Portfolio
                    </h2>
                    <PublicIcon className="ms-2 icon-color" />
                  </div>
                </a>
                <div className="prof-profile-tab-actions">
                  <div className="flex-center" onClick={handleSharePortfolio}>
                    <IconButton>
                      <ShareIcon className="color-grey" />
                    </IconButton>
                    <div className="sort-icons-cont">Share</div>
                  </div>
                  {/* <div className="flex-center">
                    <IconButton>
                      <EditIcon />
                    </IconButton>
                    <div className="sort-icons-cont">Edit</div>
                  </div> */}
                  {/* <FormGroup>
                    <FormControlLabel
                      control={<Switch defaultChecked />}
                      label="Public"
                    />
                  </FormGroup> */}
                </div>
              </div>
              <div className="sub-heading-style-16 mt-12px fw-bold">
                <span className="span-center-align align-items-start">
                  <InfoIcon className="me-2" />
                  <span>
                    Your Porfolio is created from the data in your Profile and
                    Professional Card.
                  </span>
                </span>
              </div>
            </div>
          </div>
        );
      default:
        return <>Menu not Found</>;
    }
  };

  return (
    <>
      <div className="wrapper">
        <Modal
          open={jobsModalOpen}
          onClose={handleJobsModalClose}
          sx={{
            "& .MuiBackdrop-root": {
              backgroundColor: "rgba(0,0,0,0.1)",
            },
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90vw", sm: 500 },
              maxHeight: "90vh",
              overflowY: "scroll",
              scrollbarWidth: "none",
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              p: 2,
              "&:focus-visible": {
                outline: "none",
              },
            }}
          >
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1,
              }}
            >
              <Typography variant="h6" fontWeight="bold">
                {jobType}
              </Typography>
              <IconButton
                onClick={handleJobsModalClose}
                size="small"
                sx={{ color: "text.secondary" }}
              >
                <CloseRoundedIcon fontSize="small" />
              </IconButton>
            </Box>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Fill in your details so recruiters can find you
            </Typography>

            {/* Profile Picture Section */}
            <Paper
              elevation={0}
              sx={{
                borderRadius: 2,
                p: 1.5,
                mb: 2,
                bgcolor: "grey.100",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  mb: 1,
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: 120,
                    height: 120,
                    mb: 1,
                  }}
                >
                  <Avatar
                    sx={{
                      width: 120,
                      height: 120,
                      border: "2px solid white",
                    }}
                    src={profilePicturePersonal}
                  />
                  {jobFormValues?.showBadge && jobFormValues?.tagName && (
                    <Box
                      component="img"
                      src={jobTypeImages[jobFormValues.tagName]}
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: 1,
                        height: 1,
                        pointerEvents: "none",
                      }}
                    />
                  )}
                </Box>

                <FormControlLabel
                  control={
                    <Checkbox
                      name="showBadge"
                      checked={jobFormValues.showBadge}
                      onChange={handleJobInputChange}
                      size="small"
                      disabled={!jobFormValues.tagName}
                    />
                  }
                  label="Show Badge"
                  sx={{
                    "& .MuiFormControlLabel-label": { fontSize: "0.875rem" },
                  }}
                />
              </Box>
            </Paper>

            {/* Form Content */}
            <Box sx={{ "& > :not(style)": { mb: 2 } }}>
              <FormControl fullWidth required error={formErrors.tagName}>
                <InputLabel>Tag Name</InputLabel>
                <Select
                  name="tagName"
                  value={jobFormValues.tagName || ""}
                  onChange={handleJobInputChange}
                  label="Tag Name"
                  size="small"
                >
                  {["Full-Time", "Part-Time", "Internship", "Freelancer"].map(
                    (option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    )
                  )}
                </Select>
              </FormControl>

              <TextField
                name="preferredRole"
                label="Role Title"
                value={jobFormValues.preferredRole}
                onChange={handleJobInputChange}
                required
                error={formErrors.preferredRole}
                fullWidth
                size="small"
              />

              <TextField
                name="preferredLocation"
                label="Location"
                value={jobFormValues.preferredLocation}
                onChange={handleJobInputChange}
                fullWidth
                size="small"
              />

              <FormControl fullWidth>
                <InputLabel>Work Mode</InputLabel>
                <Select
                  name="preferredWorkMode"
                  value={jobFormValues.preferredWorkMode}
                  onChange={handleJobInputChange}
                  label="Work Mode"
                  size="small"
                >
                  {["Remote", "On-site", "Hybrid"].map((mode) => (
                    <MenuItem key={mode} value={mode}>
                      {mode}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControlLabel
                control={
                  <Checkbox
                    name="isVisibleRecruiter"
                    checked={jobFormValues.isVisibleRecruiter}
                    onChange={handleJobInputChange}
                    size="small"
                  />
                }
                label={
                  <Typography variant="body2">
                    Would you like to share your professional profile details
                    with recruiters to enhance your job opportunities?
                  </Typography>
                }
                sx={{ alignItems: "flex-start", mt: 1 }}
              />
            </Box>

            {/* Actions */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
                mt: 3,
              }}
            >
              <Button
                variant="outlined"
                onClick={handleJobsModalClose}
                size="small"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleJobSave}
                disabled={!jobFormValues.tagName || isSaving}
                size="small"
              >
                {isSaving ? (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CircularProgress size={20} />
                    Saving...
                  </Box>
                ) : (
                  "Save"
                )}
              </Button>
            </Box>
          </Box>
        </Modal>

        <div
          className="my-profile-bg"
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="outiline-editicon flex-center">
            <label
              htmlFor="bgImageInput"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
            >
              <EditIcon />
            </label>
          </div>
          <input
            type="file"
            onChange={handleBgImageChange}
            style={{ display: "none" }}
            id="bgImageInput"
            accept="image/*"
            ref={bgImageRef}
          />
          <div className="My-Profile-Scanner-image">
            {/* <a
              href={`${process.env.REACT_APP_CARD_URL}/digital-identity/Personal/${objectId}`}
              target="_blank"
              rel="noopener noreferrer"

            > */}
            <div className="profile-qr-container flex-center">
              <QrCodeProfile
                className="container-gift-2"
                qrCodeUrl={`${process.env.REACT_APP_CARD_URL}/profile?encryptedId=${encryptedUrlRef.current}`}
                size={qrCodeSize}
                logo={mostRecentExpLogo}
              />
            </div>
            {/* </a> */}
          </div>
          <div className="My-Profile-imgOutline flex-center">
            <div>
              <LightTooltip
                title={professionaProfile && jobFormValues?.tagName !== "" ? (
                  <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                  >
                    <Box
                      p={2}
                      sx={{
                        textAlign: "center",
                        minWidth: 250,
                        position: "relative",
                        borderRadius: 2,
                        backgroundColor: "#216eff",
                        backgroundImage:
                          "linear-gradient(19deg, #216eff 0%, #ffffff 24%, #ffffff 49%, #ffffff 75%, #12c6ef 100%)",
                        color: "black",
                        boxShadow: "0px 4px 10px rgba(0,68,198,0.2)",
                      }}
                    >
                      {/* Eye Emoji at Top Left */}
                      <Box
                        sx={{
                          position: "absolute",
                          top: 2,
                          right: 8,
                          fontSize: 24,
                          alignItems: "left",
                          // border:"1px solid red"
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end", // Ensures the image is aligned to the right
                        }}
                      >
                        👀
                        {/* <img width={"10%"} src='https://cliply.co/wp-content/uploads/2020/03/392001500_EYES_EMOJI_400px.gif' /> */}
                      </Box>

                      <Typography
                        variant="subtitle2"
                        fontWeight="bold"
                        gutterBottom
                      >
                        Job Preferences
                      </Typography>
                      <Grid container spacing={0.5}>
                        <Grid item xs={6}>
                          <Typography
                            fontWeight="bold"
                            sx={{ fontSize: "0.75rem", color: "black" }}
                          >
                            Job Role:
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            sx={{ fontSize: "0.75rem", color: "black" }}
                          >
                            {professionaProfile?.preferred_role}
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          <Typography
                            fontWeight="bold"
                            sx={{ fontSize: "0.75rem", color: "black" }}
                          >
                            Work Mode:
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            sx={{ fontSize: "0.75rem", color: "black" }}
                          >
                            {professionaProfile?.preferred_work_mode}
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          <Typography
                            fontWeight="bold"
                            sx={{ fontSize: "0.75rem", color: "black" }}
                          >
                            Location:
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography
                            sx={{ fontSize: "0.75rem", color: "black" }}
                          >
                            {professionaProfile?.preferred_location || "Not provided"}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </motion.div>
                ) : (
                  ""
                )
                }
                arrow
                placement="right"
              >
                <Badge
                  overlap="circular"
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  badgeContent={
                    <Avatar sx={{ bgcolor: "#0044C6" }}>
                      <label
                        htmlFor="profilePicture-input"
                        style={{ cursor: "pointer" }}
                      >
                        <EditIcon className="white-svg" />
                      </label>
                      <input
                        id="profilePicture-input"
                        ref={profilePicRef}
                        type="file"
                        style={{ display: "none" }}
                        onChange={handleProfilePicChange}
                        accept="image/*"
                      />
                    </Avatar>
                  }
                >
                  <Avatar sx={avatarStyles}>
                    {profilePicturePersonal ? (
                      <img
                        src={profilePicturePersonal}
                        alt="profilepicture"
                        className="profile-pic-avatar"
                      />
                    ) : (
                      <>
                        <InsertPhotoIcon
                          sx={{ color: "grey" }}
                          fontSize="large"
                        />
                      </>
                    )}

                    {/* Conditionally render badgeChecked or hiringChecked */}
                    {(professionaProfile?.show_badge || hiringChecked) && (
                      <>
                        {/* If badgeChecked is true, render the badge from jobType */}
                        {professionaProfile?.show_badge && (
                          <div
                            style={{ position: "absolute", top: 0, right: 0 }}
                          >
                            <img
                              src={`${jobTypeImages[jobFormValues.tagName]}`} // Replace with actual image paths
                              alt="Badge"
                              style={{ width: "100%", height: "100%" }} // Adjust size of the badge as needed
                            />
                          </div>
                        )}

                        {/* If hiringChecked is true and badgeChecked is not, render the hiring badge */}
                        {hiringChecked && !professionaProfile?.show_badge && (
                          <div
                            style={{ position: "absolute", top: 110, right: 0 }}
                          >
                            <img
                              src={`${jobTypeImages[hiringType]}`} // Replace with actual image paths
                              alt="Hiring Badge"
                              style={{ width: "100%", height: "100%" }} // Adjust size of the badge as needed
                            />
                          </div>
                        )}
                      </>
                    )}
                  </Avatar>
                </Badge>
              </LightTooltip>
            </div>
          </div>
        </div>
        <div className="col sec-first second-part-of-Screen">
          <div className="my-profile-heading-container word-break">
            <div className="my-profile-heading d-flex flex-column">
              <span className="my-profile-heading name">
                {userDetails?.name}
              </span>
              <span className="subheading mb-0">
                {ProfessionalEdited?.Designation}
              </span>
            </div>

            <div className="recent-experience">
              {ExperienceList?.length !== 0 && (
                <div className="d-flex align-items-center gap-3">
                  <div className="d-flex">
                    <div className="recent-logo">
                      <img
                        src={
                          mostRecentExperience?.companylogo?.data
                            ? mostRecentExpLogo
                            : DefaultLogo
                        }
                        className="contain-image-100"
                        alt="logo"
                      />
                    </div>
                  </div>
                  <div>{mostRecentExperience?.companyName || ""}</div>
                </div>
              )}

              {sortedEducationList?.length !== 0 && (
                <div className="d-flex align-items-center gap-3">
                  <div className="d-flex">
                    <div className="recent-logo">
                      <img
                        src={
                          mostRecentEducation?.instlogo?.data
                            ? mostRecentEduLogo
                            : DefaultLogo
                        }
                        className="contain-image-100"
                        alt="logo"
                      />
                    </div>
                  </div>
                  <div>{mostRecentEducation?.institute || ""}</div>
                </div>
              )}
            </div>
          </div>

          <div className="my-profile-heading-content mt-1 mb-4">
            <div className="uid-container">UID: {userDetails?.uniqueId}</div>
            <div
              className="profile-meta-info pointer"
              onClick={() => {
                setConnectionViewModal(true);
              }}
            >
              <GroupsIcon />{" "}
              <span className="color-blue">
                {Personaldata?.connection_count || 0} Connections
              </span>
            </div>
            <Divider orientation="vertical" />
            <div
              className="profile-meta-info pointer"
              onClick={handleShareProfile}
            >
              <ShareIcon /> <span> Share </span>
            </div>
            <Divider orientation="vertical" />
            <div
              className="profile-meta-info pointer"
              onClick={() => {
                setOpenInviteProfile(true);
              }}
            >
              <InviteIcon /> <span> Invite </span>
            </div>
          </div>

          <div className="my-profile-actions">
            <div className="my-profile-status flex-center">
              <div className="probar">
                <CircularProgressbarWithChildren
                  className="profile-completion-bar"
                  value={profileCompletionPercentage}
                  styles={buildStyles({
                    pathColor:
                      profileCompletionPercentage === 100
                        ? "#4CAF50"
                        : "#FFA000",
                    trailColor:
                      profileCompletionPercentage === 100
                        ? "#C8E6C9"
                        : "#FFDDA4",
                    textColor: "#333",
                    textSize: "10px",
                  })}
                >
                  <div style={{ fontSize: "10px" }}>Status</div>
                  <div
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      color:
                        profileCompletionPercentage === 100
                          ? "#4CAF50"
                          : "#525252",
                    }}
                  >
                    {profileCompletionPercentage}%
                  </div>
                </CircularProgressbarWithChildren>
              </div>
              <div className="col probar-content">
                <h3 className="tit">Profile Completion</h3>
                <p className="tit-cont">
                  {profileCompletionPercentage === 100 ? (
                    <>Well Done! Your Profile is completed.</>
                  ) : (
                    <>
                      Uh-oh! Looks like your profile needs some attention to be
                      fully complete.
                    </>
                  )}
                </p>
              </div>
            </div>

            <div>
              <button
                className={`my-profile-open flex-center flex-column ${Boolean(anchorEl) ? "button-clicked" : ""
                  }`}
                onClick={handleClick}
              >
                <OpenToIcon style={{ color: "#0044C6" }} /> Open to
              </button>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                className="profile-popup-menu mt-1"
              >
                <MenuItem onClick={handleOpportunitiesMenu}>
                  {/* <Link to="/jobopening" className="d-flex flex-column text-decoration-none text-reset"> */}
                  <div className="d-flex flex-column">
                    <div className="open-to-menu-title">
                      Job Opportunities{" "}
                      {opportunitiesMenuOpen ? <ExpandLess /> : <ExpandMore />}{" "}
                    </div>
                    <div className="open-to-menu-subtitle">
                      Providing services to clients/customers
                    </div>
                  </div>
                  {/* </Link> */}
                </MenuItem>

                <Collapse
                  in={opportunitiesMenuOpen}
                  timeout="auto"
                  unmountOnExit
                >
                  <List>
                    <ListItemButton component={Link} to="/jobopening">
                      <ListItemText primary="Job Openings" />
                    </ListItemButton>
                    <ListItemButton component={Link} to="/applicant">
                      <ListItemText primary="Job Applications" />
                    </ListItemButton>
                    <ListItemButton component={Link} to="/favourite-jobs">
                      <ListItemText primary="Saved Jobs" />
                    </ListItemButton>
                  </List>
                </Collapse>

                <MenuItem onClick={() => handleJobsModalOpen("Tags")}>
                  <div className="d-flex flex-column">
                    <div className="open-to-menu-title">
                      Tags{" "}
                      {/* {subMenuOpen ? <ExpandLess /> : <ExpandMore />}{" "} */}
                    </div>
                    <div className="open-to-menu-subtitle">
                      Explore various job openings
                    </div>
                  </div>
                </MenuItem>
                <Collapse
                  in={subMenuOpen}
                  timeout="auto"
                  unmountOnExit
                ></Collapse>

                <MenuItem onClick={handleHiringClick}>
                  <div className="d-flex flex-column">
                    <div>
                      Hiring {hiringMenuOpen ? <ExpandLess /> : <ExpandMore />}{" "}
                    </div>
                    <div className="open-to-menu-subtitle">
                      Hiring Talented & Qualified Candidates
                    </div>
                  </div>
                </MenuItem>
                <Collapse in={hiringMenuOpen} timeout="auto" unmountOnExit>
                  <List>
                    {/* <ListItemButton onClick={() => handleHiringModalOpen("Hiring Information")}> */}
                    {/* <ListItemButton onClick={handleHiringPopupClick}> */}
                    <ListItemButton onClick={handleHiringPopupClick}>
                      <ListItemText
                        className="fs-12px"
                        primary="Post a New Job"
                      />
                    </ListItemButton>
                    {/* <ListItemButton component={Link} to="/global-search">
                      <ListItemText className="fs-12px" primary="Search Candidates" />
                    </ListItemButton>
                    <ListItemButton component={Link} to="/alljobs">
                      <ListItemText className="fs-12px" primary="Posted Jobs" />
                    </ListItemButton> */}
                    {/* <ListItemButton component={Link} to="/recruitment-Status"> */}
                    <ListItemButton component={Link} to="/analytics-dashboard">
                      <ListItemText
                        className="fs-12px"
                        primary="Recruitment Dashboard"
                      />
                    </ListItemButton>
                  </List>

                  <Dialog
                    open={alertOpen}
                    onClose={handleAlertClose}
                    sx={{
                      "& .MuiDialog-paper": {
                        maxWidth: "400px",
                        borderRadius: "8px",
                        p: 1,
                      },
                    }}
                  >
                    <DialogTitle
                      sx={{
                        pb: 1,
                        color: "error.main",
                        fontWeight: 600,
                      }}
                    >
                      Access Restricted
                    </DialogTitle>
                    <DialogContent>
                      <Typography
                        variant="body1"
                        sx={{ color: "text.primary" }}
                      >
                        Only currently employed users can access hiring
                        features. Please update your work experience to proceed.
                      </Typography>
                    </DialogContent>
                    <DialogActions sx={{ p: 2, pt: 1 }}>
                      <Button
                        onClick={handleAlertClose}
                        variant="contained"
                        color="primary"
                        sx={{
                          textTransform: "none",
                          minWidth: "80px",
                        }}
                      >
                        Close
                      </Button>
                      <Button
                        onClick={() => {
                          handleAlertClose();
                          setActiveMenu("experience");
                        }}
                        variant="outlined"
                        color="primary"
                        sx={{
                          textTransform: "none",
                          minWidth: "140px",
                        }}
                      >
                        Update Experience
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Collapse>
                <MenuItem onClick={handleClose}>
                  <div className="d-flex flex-column">
                    <div>Services</div>
                    <div className="open-to-menu-subtitle">
                      Providing services to clients/customers
                    </div>
                  </div>
                </MenuItem>
              </Menu>
            </div>
            <button
              className={`my-profile-section my-profile-open flex-center flex-column ${OpenAddMoreSection ? "button-clicked" : ""
                }`}
              onClick={handleAddSectionClick}
            >
              <AddSectionIcon style={{ color: "#0044C6" }} />
              Add Section
            </button>
            <button
              className={`my-profile-open flex-center flex-column ${Boolean(anchorElMore) ? "button-clicked" : ""
                }`}
              onClick={handleMoreClick}
            >
              <OverFlowMenu style={{ color: "#0044C6" }} /> More
            </button>
            <Menu
              anchorEl={anchorElMore}
              open={Boolean(anchorElMore)}
              onClose={handleMoreClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              className="profile-popup-menu mt-1"
            >
              <MenuItem onClick={handleMoreClose}>
                <Link
                  to="/myprofile/create-video-resume"
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <div className="d-flex flex-column">
                    <div>Create Video Resume</div>
                    <div className="open-to-menu-subtitle">
                      AI-driven resume videos
                    </div>
                  </div>
                </Link>
              </MenuItem>
              <MenuItem onClick={handleOpenResumeComponent}>
                <div className="d-flex flex-column">
                  <div>Generate AI PDF</div>
                  <div className="open-to-menu-subtitle">
                    Download your Resume in PDF Format
                  </div>
                </div>
              </MenuItem>
              {/* <MenuItem onClick={handleMoreClose}>
                <div className="d-flex flex-column">
                  <div>Profile Info</div>
                  <div className="open-to-menu-subtitle">
                    Know more about your profile{" "}
                  </div>
                </div>
              </MenuItem> */}
            </Menu>
          </div>
        </div>

        <div className="p-3">
          <div className="menu">
            <Tabs
              value={activeMenu}
              onChange={(event, newValue) => setActiveMenu(newValue)}
              aria-label="Profile Tabs"
              variant="scrollable"
              scrollButtons="auto"
              className="custom-profile-tabs"
              selectionFollowsFocus
            >
              <Tab label="My Profile" value="my_profile" />
              <Tab label="Education" value="education" />
              <Tab label="Certificate" value="certificate" />
              <Tab label="Experience" value="experience" />
              <Tab label="Resume" value="resume" />
              <Tab label="Portfolio" value="portfolio" />
            </Tabs>
          </div>

          <div className="rsuite-container">
            <div className="content-for-Email">{renderMenuContent()}</div>
          </div>
        </div>

        {/* Initially planned to give those add Section List from Parent to child --------Now those datas are inside the Context */}
        <AddSection
          OpenAddMoreSection={OpenAddMoreSection}
          setOpenAddMoreSection={setOpenAddMoreSection}
          // OtherNewSections={OtherNewSections}
          // setOtherNewSections={setOtherNewSections}
          // setOpenLanguage={setOpenLanguage}
          // setOpenModalSkills={setOpenModalSkills}
          initialTab={initialTab}
          handleGenerateDescription={handleGenerateDescription}
          handleSuccess={handleSuccess}
          handleFailure={handleFailure}
          openSnackbar={openSnackbar}
          servicesDetails={ProfessionalServices}
        />
        <Modal open={isModalResume} onClose={() => setisModalResume(false)}>
          <ResumeGenerate
            onClose={() => setisModalResume(false)}
            handleSuccess={handleSuccess}
            handleFailure={handleFailure}
            handleAlert={openResumeAlert}
            handleInfo={handleInfo}
          />
        </Modal>

        {isProjectModalOpen && (
          <AddProject
            open={isProjectModalOpen}
            onClose={() => {
              setIsProjectModalOpen(false);
              setIsEditProject(false);
            }}
            isEditing={editProjectIndex !== null}
            editProjectIndex={editProjectIndex}
            handleGenerateDescription={handleGenerateDescription}
            handleSuccess={handleSuccess}
            handleFailure={handleFailure}
            projectDetails={projectDetails}
          />
        )}

        {isAwardsModalOpen && (
          <AddAwards
            open={isAwardsModalOpen}
            onClose={() => {
              setIsAwardsModalOpen(false);
            }}
            isEditing={awardEditIndex !== null}
            editAwardIndex={awardEditIndex}
            handleGenerateDescription={handleGenerateDescription}
            handleSuccess={handleSuccess}
            handleFailure={handleFailure}
            awardDetails={awardDetails}
          />
        )}

        {LightBoxExperience && (
          <div className="lightbox-overlay">
            <div className="lightbox-content-2" style={{ width: "60%" }}>
              <div className="active-component-container">
                <>
                  <div className="d-flex justify-content-between">
                    <div className="card-edit-info-heading">
                      <h5 className="text-left">{editExperienceIndex !== null ? "Update Experience" : "Add Experience"}</h5>
                      <span className="sub-text-lightbox">
                        {editExperienceIndex !== null
                          ? "Update your Experience details"
                          : "Add your Experience details"}
                      </span>
                    </div>
                    <button
                      className="lightbox-close pointer"
                      onClick={() => setLightBoxExperience(false)}
                    >
                      ×
                    </button>
                  </div>

                  <div className="my-2 user-details-container text-start">
                    <Grid container spacing={2}>
                      <Grid item xs={3} xl={4}></Grid>
                      <Grid item xs={6} xl={4}>
                        <FileDragUploadWithContext
                          label="Add logo*"
                          contextKey="companylogo"
                          accept={["image/jpeg", "image/png"]}
                          maxSize={1}
                          inputId="companylogo-upload"
                          context={currentExperience}
                          updateContext={updateCurrentExperience}
                          required={true}
                          error={expErrors?.companylogo}
                          helperText={expErrors?.companylogo ? "Company logo is required" : ""}
                        />
                      </Grid>

                      <Grid item xs={3} xl={4}></Grid>

                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <Autocomplete
                            freeSolo
                            options={searchItems || []}
                            value={selectedExperience || null}
                            inputValue={currentExperience?.companyName || ""}
                            onInputChange={handleSearchLogo} // This updates searchQuery
                            onChange={handleSelected}
                            getOptionLabel={(option) =>
                              typeof option === "string"
                                ? option
                                : option?.legal_name || ""
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                label="Company"
                                variant="outlined"
                                fullWidth
                                onClick={() => {
                                  setMenuItem("Experience"); //  This is where you set it
                                }}
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      {/* THE USER SHOULD NOT BE MANUALLY ENTERING THE WEBSITE OR DOMAIN */}
                      <Grid item xs={6}>
                        {/* <TextField
                          name="companyDomain"
                          label="Company Website/Domain"
                          className="summary-field"
                          fullWidth
                          value={currentExperience.companyDomain}
                          onChange={handleExperienceItems("companyDomain")}
                          required
                        /> */}

                        <FormControl fullWidth>
                          <Autocomplete
                            freeSolo
                            options={searchItems}
                            value={selectedExperienceDomain || null}
                            inputValue={currentExperience?.companyDomain || ""}
                            onInputChange={handleSearchDomain} // This updates searchQuery
                            onChange={handleSelectedDomain}
                            getOptionLabel={(option) =>
                              typeof option === "string"
                                ? option
                                : option?.website || ""
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                required
                                name="companyDomain"
                                label="Company Website/Domain"
                                variant="outlined"
                                fullWidth
                                onClick={() => {
                                  setMenuItem("Experience"); //  This is where you set it
                                }}
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          name="location"
                          label="Location"
                          required
                          className="course-name"
                          fullWidth
                          value={currentExperience.location}
                          onChange={handleExperienceItems("location")}
                          error={expErrors?.location}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <FormControl
                          fullWidth
                          required
                          error={expErrors?.locationType}
                        >
                          <TextField
                            name="locationType"
                            label="Location Type"
                            select
                            value={currentExperience.locationType}
                            onChange={handleExperienceItems("locationType")}
                            InputLabelProps={{ required: false }}
                            fullWidth
                            className="textfield-widthNew"
                          >
                            <MenuItem value="Onsite">Onsite</MenuItem>
                            <MenuItem value="Hybrid">Hybrid</MenuItem>
                            <MenuItem value="Remote">Remote</MenuItem>
                          </TextField>
                        </FormControl>
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          label="Role Title"
                          name="roleTitle"
                          required
                          className="course-name"
                          fullWidth
                          value={currentExperience.roleTitle}
                          onChange={handleExperienceItems("roleTitle")}
                          error={expErrors?.roleTitle}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <FormControl
                          fullWidth
                          required
                          error={expErrors?.employmentType}
                        >
                          <TextField
                            name="employmentType"
                            label="Employment Type"
                            select
                            value={currentExperience.employmentType}
                            onChange={handleExperienceItems("employmentType")}
                            InputLabelProps={{ required: false }}
                            fullWidth
                            className="textfield-widthNew"
                          >
                            <MenuItem value="Full-time">Full-time</MenuItem>
                            <MenuItem value="Part-time">Part-time</MenuItem>
                            <MenuItem value="Freelance">Freelance</MenuItem>
                            <MenuItem value="Internship">Internship</MenuItem>
                            <MenuItem value="Trainee">Trainee</MenuItem>
                          </TextField>
                        </FormControl>
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          name="company_email"
                          label="company email"
                          required
                          className="course-name"
                          fullWidth
                          value={currentExperience.company_email}
                          onChange={handleExperienceItems("company_email")}
                        // error={expErrors?.location}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          multiline
                          rows={3}
                          name="details"
                          label="Details"
                          placeholder="Description (500 characters Maximum)"
                          autoComplete="off"
                          variant="outlined"
                          inputProps={{ max: MAX_DESC_LENGTH }}
                          fullWidth
                          value={currentExperience.details}
                          onChange={handleExperienceItems("details")}
                        />
                        <div className="d-flex justify-content-end align-items-start my-2">
                          {/* <div className="invite-modal-subtitle">Enable AI Generation with minimum 15 words</div> */}
                          <Button
                            variant="outlined"
                            sx={{ color: "#0044C6" }}
                            className="ai-rewrite-button"
                            onClick={() =>
                              handleGenerateDescription(
                                {
                                  roleTitle: currentExperience.roleTitle,
                                  companyName: currentExperience.companyName,
                                  location: currentExperience.location,
                                  employmentType:
                                    currentExperience.employmentType,
                                  startMonth: currentExperience.startMonth,
                                  startYear: currentExperience.startYear,
                                  endMonth: currentExperience.isCurrentlyWorking
                                    ? "Present"
                                    : currentExperience.endMonth,
                                  endYear: currentExperience.isCurrentlyWorking
                                    ? "Present"
                                    : currentExperience.endYear,
                                  responsibilities:
                                    currentExperience.responsibility,
                                  description: currentExperience.details,
                                },
                                "experience",
                                "details",
                                updateCurrentExperience
                              )
                            }
                            // disabled={!currentExperience.details || currentExperience.details.split(" ").length < 15}
                            startIcon={<AiLogo />}
                          >
                            Generate
                          </Button>
                        </div>
                      </Grid>

                      <Grid item xs={6}>
                        <span>Start Date</span>
                      </Grid>
                      <Grid item xs={6}></Grid>

                      <Grid item xs={6}>
                        <FormControl
                          fullWidth
                          required
                          error={expErrors?.startMonth}
                        >
                          <InputLabel id="startMonth-label">Month</InputLabel>
                          <Select
                            labelId="month-label"
                            value={currentExperience?.startMonth || ""}
                            onChange={handleExperienceItems("startMonth")}
                            label="Month"
                            className="text-left"
                            required
                          >
                            {months?.map((month, index) => (
                              <MenuItem key={index} value={month}>
                                {month}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={6}>
                        <FormControl
                          fullWidth
                          required
                          error={expErrors?.startYear}
                        >
                          <InputLabel id="start-year-label">Year</InputLabel>
                          <Select
                            labelId="year-label"
                            value={currentExperience?.startYear || ""}
                            onChange={handleExperienceItems("startYear")}
                            label="Year"
                            className="text-left"
                            required
                          >
                            {years?.map((year, index) => (
                              <MenuItem key={index} value={year}>
                                {year}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={6}>
                        <span>End Date</span>
                      </Grid>
                      <Grid item xs={6}></Grid>

                      <Grid item xs={6}>
                        <FormControl
                          fullWidth
                          required
                          error={
                            expErrors?.endMonth ||
                            expErrors?.endMonthInvalid ||
                            expErrors?.endYearInvalid
                          }
                        >
                          <InputLabel id="month-label">Month</InputLabel>
                          <Select
                            labelId="month-label"
                            value={currentExperience?.endMonth || ""}
                            onChange={handleExperienceItems("endMonth")}
                            label="Month"
                            className="text-left"
                            disabled={currentExperience.isCurrentlyWorking}
                            required
                          >
                            {currentExperience.isCurrentlyWorking && (
                              <MenuItem value="Present">Present</MenuItem>
                            )}
                            {months?.map((month, index) => (
                              <MenuItem key={index} value={month}>
                                {month}
                              </MenuItem>
                            ))}
                          </Select>
                          {expErrors.endMonthInvalid &&
                            expErrors.endYearInvalid && (
                              <FormHelperText>
                                {ERRORS.invalidDate}
                              </FormHelperText>
                            )}
                        </FormControl>
                      </Grid>

                      <Grid item xs={6}>
                        <FormControl
                          fullWidth
                          required
                          error={
                            expErrors?.endYear ||
                            expErrors?.endMonthInvalid ||
                            expErrors?.endYearInvalid
                          }
                        >
                          <InputLabel id="end-year-label">Year</InputLabel>
                          <Select
                            labelId="year-label"
                            value={currentExperience?.endYear || ""}
                            onChange={handleExperienceItems("endYear")}
                            label="Year"
                            className="text-left"
                            disabled={currentExperience.isCurrentlyWorking}
                          >
                            {currentExperience?.isCurrentlyWorking && (
                              <MenuItem value="Present">Present</MenuItem>
                            )}
                            {years?.map((year, index) => (
                              <MenuItem key={index} value={year}>
                                {year}
                              </MenuItem>
                            ))}
                          </Select>
                          {/* <Select
                            labelId="year-label"
                            value={currentExperience?.endYear || ""}
                            onChange={handleExperienceItems("endYear")}
                            label="Year"
                            className="text-left"
                            disabled={false} // always enabled
                          >
                            <MenuItem value="Present">Present</MenuItem>
                            {years?.map((year, index) => (
                              <MenuItem key={index} value={year}>
                                {year}
                              </MenuItem>
                            ))}
                          </Select> */}
                        </FormControl>
                      </Grid>

                      <Grid item style={{ textAlign: "left" }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={currentExperience.isCurrentlyWorking}
                              onChange={handleCheckboxExperience}
                              name="current-working"
                            />
                          }
                          label="Currently Working"
                        />
                      </Grid>

                      {/* <Grid item xs={12}>
                        <TextField
                          name="responsibility"
                          label="KPI's"
                          placeholder="Ex: Backend Development"
                          autoComplete="on"
                          variant="outlined"
                          fullWidth
                          inputProps={{ maxLength: MAX_DESC_LENGTH }}
                          value={currentExperience.responsibility}
                          onChange={handleExperienceItems('responsibility')}
                        />
                      </Grid> */}

                      <Grid item xs={12}>
                        <Autocomplete
                          freeSolo
                          options={kpiOptions}
                          multiple
                          PaperComponent={customHealthPaper}
                          value={currentExperience?.responsibility || ''}
                          onChange={(event, newValue) =>
                            setCurrentExperience({
                              ...currentExperience,
                              responsibility: newValue,
                            })
                          }
                          inputValue={responsibilityInput}
                          onInputChange={(event, newInputValue) => {
                            setResponsibilityInput(newInputValue); // Update the input value
                          }}
                          onKeyDown={(event) =>
                            handleAddChip(
                              event,
                              responsibilityInput,
                              "responsibility"
                            )
                          }
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <CustomChip
                                key={index}
                                variant="outlined"
                                label={option}
                                onDelete={() =>
                                  handleDeleteChip("responsibility", option)
                                }
                                {...getTagProps({ index })}
                              />
                            ))
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              label="Responsibilities"
                              placeholder="Your Key Responsibilities"
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          name="profile_headline"
                          label="Profile headline"
                          // required
                          className="course-name"
                          fullWidth
                          value={currentExperience?.profile_headline}
                          onChange={handleExperienceItems("profile_headline")}
                        // error={expErrors?.location}
                        />
                      </Grid>
                      <p className="ms-3 sub-text-lightbox">
                        This will appear below your company name.
                      </p>
                      {/* <Grid item xs={12}>
                        <TextField
                          name="headline"
                          label="Profile Headline"
                          placeholder="Profile Heading"
                          autoComplete="on"
                          variant="outlined"
                          fullWidth
                          value={currentExperience.headline}
                          onChange={handleExperienceItems('headline')}
                          helperText="Appears below your name at the top of the profile"
                        />
                      </Grid> */}
                    </Grid>
                  </div>

                  <div className="mt-4 d-flex justify-content-between">
                    {editExperienceIndex !== null ? (
                      <>
                        <div>
                          <Button
                            variant="contained"
                            sx={{ backgroundColor: "#0044C6" }}
                            onClick={handleVerifyExp}
                            disabled={
                              !areExpFieldsFilled("add") ||
                              currentExperience.isVerified
                            }
                            className={`verify-button ${currentExperience.isVerified
                              ? "success-green"
                              : ""
                              }`}
                          >
                            {currentExperience.isVerified
                              ? "Verified"
                              : "Verify"}
                          </Button>
                        </div>
                        <div>
                          <Button
                            className="secondary-btn me-3"
                            onClick={() => {
                              setdeleteExperience(true);
                              setLightBoxExperience(false);
                            }}
                          >
                            Delete
                          </Button>
                          <Button
                            variant="contained"
                            sx={{ backgroundColor: "#0044C6" }}
                            onClick={handleAddExperience}
                            disabled={!isExperienceFormValid() || submittingSection === "experience"} // Disable if form is invalid
                          >
                            {submittingSection === "experience" ? (
                              <span className="d-flex align-items-center">
                                <CircularProgress size={16} sx={{ mr: 1, color: "white" }} />
                                Saving...
                              </span>
                            ) : (
                              "Save"
                            )}
                          </Button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div>
                          <Button
                            className="secondary-btn me-3"
                            onClick={() => {
                              setLightBoxExperience(false);
                              resetCurrentExperience();
                            }}
                          >
                            Cancel
                          </Button>
                        </div>
                        <div>
                          <Button
                            variant="contained"
                            sx={{ backgroundColor: "#0044C6" }}
                            onClick={handleAddExperience}
                            disabled={!isExperienceFormValid() || submittingSection === "experience"} // Disable if form is invalid
                          >
                            {submittingSection === "experience" ? (
                              <span className="d-flex align-items-center">
                                <CircularProgress size={16} sx={{ mr: 1, color: "white" }} />
                                Adding...
                              </span>
                            ) : (
                              "Add"
                            )}
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                </>
              </div>
            </div>
          </div>
        )}

        {deleteExperience && (
          <>
            <DeleteLightBox
              LightBoxCloseFunction={setdeleteExperience}
              Title={"Experience"}
              Label={"Do you really want to delete this Experience details?"}
              DeleteFunction={handleDeleteExperience}
              clearFields={resetCurrentExperience}
            />
          </>
        )}
        {LightBoxCertificate && (
          <div className="lightbox-overlay">
            <div className="lightbox-content-2 thin-lightbox">
              <div className="active-component-container">
                <>
                  <div className="d-flex justify-content-between">
                    <div className="card-edit-info-heading">
                      {/* <h5 className="text-left">{editCertificateIndex ? "Edit Certificate" : "Add Certificate"}</h5> */}
                      <h5 className="text-left">{editCertificateIndex !== null ? "Edit Certificate" : "Add Certificate"}</h5>
                      <span className="sub-text-lightbox">
                        {editCertificateIndex ? "Update your course certification details" : "Add your course certification details"}
                      </span>
                    </div>
                    <button
                      className="lightbox-close pointer"
                      // onClick={() => setLightBoxCertificate(false)}
                      onClick={() => {
                        setLightBoxCertificate(false);
                        setEditCertificateIndex(null); // add this
                        resetCurrentCertificate();
                      }}
                    >
                      x
                    </button>
                  </div>

                  <div className="my-2 user-details-container">
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Grid container direction="column" spacing={2}>
                          <Grid item>
                            <FileDragUploadWithContext
                              label="Add logo"
                              contextKey="certificateLogo"
                              accept={["image/jpeg", "image/png"]}
                              maxSize={1}
                              inputId="instlogo-upload"
                              context={currentCertificate}
                              updateContext={updateCurrentCertificate}
                            />
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={6}>
                        <Grid container direction="column" spacing={2}>
                          <Grid item>
                            <FileDragUploadWithContext
                              label="Add Certificate*"
                              contextKey="certificatePDF"
                              accept={["image/jpeg", "image/png", "application/pdf"]}
                              maxSize={5}
                              inputId="certificatePDF-upload"
                              context={currentCertificate}
                              updateContext={updateCurrentCertificate}
                              required={true}
                              error={certErrors?.certificatePDF}
                              helperText={certErrors?.certificatePDF ? "Certificate file is required" : ""}
                            />
                            {certErrors?.certificatePDF && (
                              <FormHelperText error>Certificate is required</FormHelperText>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12}>
                        <Grid item xs={6}>
                          <FormControl fullWidth error={certErrors?.organName}>
                            <Autocomplete
                              freeSolo
                              value={selectedCertificate}
                              options={searchItems || []}
                              inputValue={currentCertificate?.organName || ""}
                              onInputChange={handleSearchLogo}
                              onChange={handleSelected}
                              getOptionLabel={(option) =>
                                typeof option === "string"
                                  ? option
                                  : option?.legal_name || ""
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Organization Name *"
                                  variant="outlined"
                                  required
                                  fullWidth
                                  error={certErrors?.organName}
                                  helperText={certErrors?.organName ? "Organization name is required" : ""}
                                  onClick={() => {
                                    setMenuItem("Certificate");
                                  }}
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>
                      </Grid>

                      <Grid item xs={12}>
                        <FormControl fullWidth error={certErrors?.organDomain}>
                          <Autocomplete
                            freeSolo
                            value={selectedCertificateDomain}
                            options={searchItems}
                            inputValue={currentCertificate?.organDomain || ""}
                            onInputChange={handleSearchDomain}
                            onChange={handleSelectedDomain}
                            getOptionLabel={(option) =>
                              typeof option === "string"
                                ? option
                                : option?.website || ""
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Organization Website/Domain *"
                                variant="outlined"
                                fullWidth
                                required
                                error={certErrors?.organDomain}
                                helperText={certErrors?.organDomain ? "Organization website/domain is required" : ""}
                                onClick={() => {
                                  setMenuItem("Certificate");
                                }}
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          label="Course Name *"
                          className="course-name"
                          fullWidth
                          value={currentCertificate.courseName}
                          onChange={handleCertifiItems("courseName")}
                          required
                          error={certErrors?.courseName}
                          helperText={certErrors?.courseName ? "Course name is required" : ""}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          label="Certificate Link"
                          fullWidth
                          value={currentCertificate.certificateLink}
                          onChange={handleCertifiItems("certificateLink")}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          multiline
                          rows={3}
                          name="description"
                          label="Description"
                          placeholder="Description (500 characters Maximum)"
                          autoComplete="off"
                          variant="outlined"
                          inputProps={{ maxLength: MAX_DESC_LENGTH }}
                          fullWidth
                          value={currentCertificate.certifiDetails}
                          onChange={handleCertifiItems("certifiDetails")}
                        />
                        <div className="d-flex justify-content-end align-items-start my-2">
                          <Button
                            variant="outlined"
                            sx={{ color: "#0044C6" }}
                            className="ai-rewrite-button"
                            onClick={() =>
                              handleGenerateDescription(
                                {
                                  organization: currentCertificate?.organName,
                                  courseTitle: currentCertificate?.courseName,
                                  description:
                                    currentCertificate?.certifiDetails,
                                  issueDate:
                                    currentCertificate?.certifiMonth +
                                    " " +
                                    currentCertificate.certifiYear,
                                },
                                "certificate",
                                "certifiDetails",
                                updateCurrentCertificate
                              )
                            }
                            startIcon={<AiLogo />}
                          >
                            Generate
                          </Button>
                        </div>
                      </Grid>

                      <Grid item xs={12}>
                        <Typography
                          variant="h6"
                          className="text-left mx-2 my-2"
                        >
                          Issue Date *
                        </Typography>
                      </Grid>

                      <Grid item xs={6}>
                        <FormControl
                          fullWidth
                          required
                          error={certErrors?.certifiMonth}
                        >
                          <InputLabel id="month-label">Month *</InputLabel>
                          <Select
                            labelId="month-label"
                            value={currentCertificate?.certifiMonth || ""}
                            onChange={handleCertifiItems("certifiMonth")}
                            label="Month *"
                            className="text-left"
                          >
                            {months?.map((month, index) => (
                              <MenuItem key={index} value={month}>
                                {month}
                              </MenuItem>
                            ))}
                          </Select>
                          {certErrors?.certifiMonth && (
                            <FormHelperText>Month is required</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>

                      <Grid item xs={6}>
                        <FormControl
                          fullWidth
                          required
                          error={certErrors?.certifiYear}
                        >
                          <InputLabel id="year-label">Year *</InputLabel>
                          <Select
                            labelId="year-label"
                            value={currentCertificate?.certifiYear || ""}
                            onChange={handleCertifiItems("certifiYear")}
                            label="Year *"
                            className="text-left"
                          >
                            {years?.map((year, index) => (
                              <MenuItem key={index} value={year}>
                                {year}
                              </MenuItem>
                            ))}
                          </Select>
                          {certErrors?.certifiYear && (
                            <FormHelperText>Year is required</FormHelperText>
                          )}
                        </FormControl>
                      </Grid>
                    </Grid>
                  </div>

                  <div className="mt-4 d-flex justify-content-between">
                    {editCertificateIndex !== null ? (
                      <>
                        <div>
                          <Button
                            variant="contained"
                            sx={{ backgroundColor: "#0044C6" }}
                            onClick={handleVerifyCert}
                            disabled={
                              !areCertFieldsFilled("add") ||
                              currentCertificate.isVerified
                            }
                            className={`verify-button ${currentCertificate.isVerified
                              ? "success-green"
                              : ""
                              }`}
                          >
                            {currentCertificate.isVerified
                              ? "Verified"
                              : "Verify"}
                          </Button>
                        </div>
                        <div>
                          <Button
                            className="secondary-btn me-3"
                            onClick={() => {
                              setDeleteCertificate(true);
                              setLightBoxCertificate(false);
                            }}
                          >
                            Delete
                          </Button>
                          <Button
                            variant="contained"
                            sx={{ backgroundColor: "#0044C6" }}
                            onClick={handleAddCertificate}
                            disabled={!areCertFieldsFilled("add") || submittingSection === "certificate"}
                          >
                            {/* Save */}
                                                       {submittingSection === "certificate" ? (
                              <span className="d-flex align-items-center">
                                <CircularProgress size={16} sx={{ mr: 1, color: "white" }} />
                                Saving...
                              </span>
                            ) : (
                              "Save"
                            )}

                          </Button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div>
                          <Button
                            className="secondary-btn me-3"
                            onClick={() => {
                              setLightBoxCertificate(false);
                              resetCurrentCertificate();
                            }}
                          >
                            Cancel
                          </Button>
                        </div>
                        <div>
                          <Button
                            variant="contained"
                            sx={{ backgroundColor: "#0044C6" }}
                            onClick={handleAddCertificate}
                            disabled={!areCertFieldsFilled("add") || submittingSection === "certificate"}
                          >
                            {/* Add */}                          {submittingSection === "education" ? (
                              <span className="d-flex align-items-center">
                                <CircularProgress size={16} sx={{ mr: 1, color: "white" }} />
                                Adding...
                              </span>
                            ) : (
                              "Add"
                            )}
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                </>
              </div>
            </div>
          </div>
        )}

        {/* <Modal open={openSearchBar} onClose={() => setOpenSearchBar(false)}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 500,
              bgcolor: "background.paper",
              boxShadow: 24,
              // p: 4,
              borderRadius: 2,
            }}
          >
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6" className="px-4 pt-3">Search Data</Typography>
              {/* <IconButton onClick={() => setOpenSearchBar(false)}>
                <CloseIcon />
              </IconButton> */}
        {/* <button
          className="lightbox-close pointer"
          onClick={() => setOpenSearchBar(false)}
        >
          ×
        </button>
      </Box> */}

        {/* Search Input */}
        {/* <div className="mx-4">
        <TextField
          fullWidth
          label="Search..."
          variant="outlined"
          margin="normal"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div> */}
        {/* Display Matching Results */}
        {/* <ul>
              {searchItems?.length > 0 ? (
                searchItems.map((item) => (
                  <li
                    key={item?.id}
                    onClick={() => handleSelected(item)}
                    style={{ cursor: 'pointer', padding: '10px', listStyle: 'none', borderBottom: '1px solid #ddd' }}
                  >
                    {item?.legal_name}
                  </li>
                ))
              ) : (
                <li>No results found</li>
              )}
            </ul> */}

        {/* {openSearchBar && searchItems?.length > 0 && (
        <ul style={{
          //  border: "1px solid #ddd",
          padding: "0px",
          margin: "0px",
          listStyle: "none"
        }}>
          {searchItems
            .filter((item) => item?.legal_name) //  Only include valid items
            .map((item) => (
              <li className="d-flex flex-column align-items-start px-3"
                key={item.id}
                style={{ padding: "10px", cursor: "pointer", borderBottom: "1px solid #ddd" }}
                onClick={() => handleSelected(item, menuItem)}
              >
                {item.legal_name}
              </li>
            ))}
        </ul>
      )}

    </Box > */}
        {/* </Modal >  */}

        {DeleteCertificate && (
          <>
            <DeleteLightBox
              LightBoxCloseFunction={setDeleteCertificate}
              Title={"Certificate"}
              Label={"Do you really want to delete this certificate details?"}
              DeleteFunction={handleDeleteCertificate}
              clearFields={resetCurrentCertificate}
            />
          </>
        )}

        {isModalOpen && (
          <div className="lightbox-overlay">
            <div className="lightbox-content-2 profile-lightbox">
              <div className="active-component-container">
                <>
                  <div className="d-flex justify-content-between">
                    <div className="card-edit-info-heading">
                      <h5 className="text-left">
                        {editIndexEducation !== null ? "Update Education" : "Add Education"}
                      </h5>
                      <span className="sub-text-lightbox">
                        {editIndexEducation !== null
                          ? "Update your Educational details"
                          : "Add your Educational details"}
                      </span>
                    </div>
                    {/* <button className="lightbox-close pointer" onClick={() => setIsModalOpen(false)}>&times;</button> */}
                    <IconButton
                      className="modal-close-button"
                      onClick={() => setIsModalOpen(false)}
                    >
                      <CloseRoundedIcon />
                    </IconButton>
                  </div>

                  <div className="my-2 user-details-container">
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <FileDragUploadWithContext
                          label="Add logo*"
                          contextKey="instlogo"
                          accept={["image/jpeg", "image/png"]}
                          maxSize={1}
                          inputId="instlogo-upload"
                          context={currentEducation}
                          updateContext={updateCurrentEducation}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <FileDragUploadWithContext
                          label="Add Certificate"
                          contextKey="certificatepic"
                          accept={[
                            "image/jpeg",
                            "image/png",
                            // "application/pdf",
                          ]}
                          maxSize={5}
                          inputId="certificate-pic"
                          context={currentEducation}
                          updateContext={updateCurrentEducation}
                        />
                      </Grid>

                      {/* THE USER SHOULD NOT BE MANUALLY ENTERING THE WEBSITE OR DOMAIN */}
                      <Grid item xs={12}>
                        {/* <TextField
                            label="Institute Website/Domain"
                            className="summary-field"
                            fullWidth
                            value={currentEducation?.instituteDomain}
                            onChange={handleChangeEducationItems('instituteDomain')}
                            required
                            error={eduErrors?.instituteDomain}
                          /> */}

                        <FormControl fullWidth>
                          <Autocomplete
                            value={selectedInstituteDomain || null}
                            freeSolo
                            options={searchItems || []}
                            inputValue={currentEducation?.instituteDomain || ""}
                            onInputChange={(event, value) => {
                              setMenuItem("Education"); // Set correct menu context
                              handleSearchDomain(event, value); // Same search logic
                            }}
                            onChange={(event, value) =>
                              handleSelectedDomain(event, value)
                            } // Reuse the same handler
                            getOptionLabel={(option) =>
                              typeof option === "string"
                                ? option
                                : option?.website || ""
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Institute Website/Domain"
                                variant="outlined"
                                fullWidth
                                required
                                error={eduErrors?.instituteDomain}
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={6}>
                        <FormControl fullWidth>
                          <TextField
                            name="eduLevel"
                            label="Education level"
                            select
                            value={currentEducation?.eduLevel}
                            onChange={handleChangeEducationItems("eduLevel")}
                            fullWidth
                            className="textfield-widthNew"
                            required
                            error={eduErrors?.eduLevel}
                          >
                            <MenuItem value="SSLC">
                              Secondary School (10th Grade / Equivalent)
                            </MenuItem>
                            <MenuItem value="HSC">
                              Higher Secondary (12th Grade / Equivalent)
                            </MenuItem>
                            <MenuItem value="UG">Undergraduate</MenuItem>
                            <MenuItem value="PG">Postgraduate</MenuItem>
                            <MenuItem value="HigherEd">
                              Higher Education
                            </MenuItem>
                          </TextField>
                        </FormControl>
                      </Grid>

                      <Grid item xs={6}>
                        <Autocomplete
                          value={selectedUniversity || null}
                          onChange={handleSelectedUniversity}
                          inputValue={currentEducation?.universityName || ''}
                          onInputChange={handleSearchUniversity}
                          options={isCollege ? filteredUniversities : []}
                          freeSolo
                          getOptionLabel={(option) =>
                            option ? option.name : ""
                          }
                          ListboxProps={{
                            onScroll: (event) =>
                              handleDropdownScroll(event, "universities"),
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={
                                currentEducation?.eduLevel === "SSLC"
                                  ? "Board"
                                  : "Board/University"
                              }
                              variant="outlined"
                              fullWidth
                              required
                              error={eduErrors.universityName}
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        {/* <Autocomplete
                          value={selectedInstitute}
                          onChange={handleSelectedInstitute}
                          inputValue={currentEducation.institute}
                          onInputChange={handleSearchInstitute}
                          options={isCollege ? filteredColleges : []}
                          freeSolo
                          getOptionLabel={(option) =>
                            option ? option.college_name : ""
                          }
                          ListboxProps={{
                            onScroll: (event) =>
                              handleDropdownScroll(event, "colleges"),
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Institute"
                              variant="outlined"
                              fullWidth
                              required
                              error={eduErrors?.institute}
                              // onClick={() => {
                              //   setOpenSearchBar(true);
                              //   searchItems("");
                              //   setMenuItem("Education");
                              // }}
                              onClick={() => {
                                setOpenSearchBar(true)
                                setSearchQuery("");
                                setMenuItem("Education")
                              }}
                            />
                          )}
                        /> */}

                        <FormControl fullWidth>
                          <Autocomplete
                            value={selectedInstitute || null}
                            freeSolo
                            options={searchItems || []}
                            inputValue={currentEducation?.institute || ""}
                            onInputChange={(event, value) => {
                              setMenuItem("Education"); // Set correct menu context
                              handleSearchLogo(event, value); // Same search logic
                            }}
                            onChange={(event, value) =>
                              handleSelected(event, value)
                            } // Reuse the same handler
                            getOptionLabel={(option) =>
                              typeof option === "string"
                                ? option
                                : option?.legal_name || ""
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Institute"
                                variant="outlined"
                                fullWidth
                                required
                                error={eduErrors?.institute}
                              />
                            )}
                          />
                        </FormControl>
                      </Grid>

                      {currentEducation?.eduLevel !== "SSLC" && (
                        <Grid item xs={6}>
                          {degreeOptions?.length > 0 ? (
                            // <Autocomplete
                            //   freeSolo
                            //   options={degreeOptions}
                            //   value={currentEducation.degree || ''}
                            //   onChange={(e, newValue) =>
                            //     handleChangeEducationItems("degree")({ target: { value: newValue || '' } })
                            //   }
                            //   renderInput={(params) => (
                            //     <TextField
                            //       {...params}
                            //       label={
                            //         currentEducation.eduLevel === "HSC"
                            //           ? "Stream"
                            //           : "Degree"
                            //       }
                            //       fullWidth
                            //       required
                            //       error={eduErrors?.degree}
                            //     />
                            //   )}
                            // />
                            //
                            <Autocomplete
                              freeSolo
                              options={degreeOptions}
                              value={currentEducation.degree || ""}
                              inputValue={inputDegree}
                              onInputChange={(e, newInputValue) => {
                                setInputDegree(newInputValue);
                                handleChangeEducationItems("degree")({
                                  target: { value: newInputValue },
                                });
                              }}
                              onChange={(e, newValue) => {
                                const value = newValue || "";
                                setInputDegree(value);
                                handleChangeEducationItems("degree")({
                                  target: { value },
                                });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={
                                    currentEducation.eduLevel === "HSC"
                                      ? "Stream"
                                      : "Degree"
                                  }
                                  fullWidth
                                  required
                                  error={eduErrors?.degree}
                                />
                              )}
                            />
                          ) : (
                            <TextField
                              label={
                                currentEducation.eduLevel === "HSC"
                                  ? "Stream"
                                  : "Degree"
                              }
                              fullWidth
                              value={currentEducation.degree}
                              onChange={handleChangeEducationItems("degree")}
                              required
                              error={eduErrors?.degree}
                            />
                          )}
                        </Grid>
                      )}

                      {currentEducation?.eduLevel !== "SSLC" && (
                        <Grid item xs={6}>
                          {currentEducation?.eduLevel === "HSC" ? (
                            <TextField
                              label="Subjects"
                              fullWidth
                              value={currentEducation.fieldofStudy}
                              onChange={handleChangeEducationItems(
                                "fieldofStudy"
                              )}
                              required
                              error={eduErrors?.fieldofStudy}
                            />
                          ) : (
                            <Autocomplete
                              options={fieldOfStudyOptions}
                              value={currentEducation?.fieldofStudy}
                              onChange={(e, newValue) => {
                                const value = newValue || "";
                                setInputFieldOfStudy(value);
                                handleChangeEducationItems("fieldofStudy")({
                                  target: { value },
                                });
                              }}
                              inputValue={inputFieldOfStudy}
                              onInputChange={(e, newValue) => {
                                setInputFieldOfStudy(newValue);
                                handleChangeEducationItems("fieldofStudy")({
                                  target: { value: newValue || "" },
                                });
                              }}
                              freeSolo
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Field of Study"
                                  fullWidth
                                  required
                                  error={eduErrors?.fieldofStudy}
                                />
                              )}
                            />
                          )}
                        </Grid>
                      )}

                      <Grid item xs={6}>
                        <TextField
                          label="GPA/Grade"
                          fullWidth
                          value={currentEducation.grade}
                          onChange={handleChangeEducationItems("grade")}
                        />
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          label="Starting Year"
                          fullWidth
                          value={currentEducation.startYear || ""}
                          onChange={handleChangeEducationItems("startYear")}
                          select
                          required
                          error={eduErrors?.startYear}
                        >
                          {currentEducation?.isCurrentlyPursuing && (
                            <MenuItem value="Present">Present</MenuItem>
                          )}
                          {years.map((year, index) => (
                            <MenuItem key={index} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </TextField>
                        {/* {(currentEducation?.eduLevel!=='SSLC' && currentEducation?.eduLevel!=='HSC')&& */}
                        <Grid item className="mt-3">
                          <TextField
                            label="Student Email Id"
                            fullWidth
                            value={currentEducation?.institute_email}
                            onChange={handleChangeEducationItems('institute_email')}
                            // error={emailError}
                            error={eduErrors?.institute_email}
                            helperText={eduErrors?.institute_email ? 'Please enter a valid email address' : ''}
                          />
                        </Grid>
                        {/* } */}

                        <Grid item sx={{ textAlign: "left" }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={currentEducation?.isCurrentlyPursuing}
                                onChange={handleEduCheckbox}
                                name="current-pursuing"
                              />
                            }
                            label="Currently Pursuing"
                          />
                        </Grid>
                      </Grid>

                      <Grid item xs={6}>
                        <TextField
                          label="Ending Year"
                          fullWidth
                          value={currentEducation?.endYear || ""}
                          onChange={handleChangeEducationItems("endYear")}
                          disabled={currentEducation?.isCurrentlyPursuing}
                          select
                          required
                          error={
                            eduErrors?.endYear || eduErrors?.endYearInvalid
                          }
                          helperText={
                            eduErrors?.endYearInvalid && ERRORS.invalidDate
                          }
                        >
                          {currentEducation?.isCurrentlyPursuing && (
                            <MenuItem value="Present">Present</MenuItem>
                          )}
                          {years.map((year, index) => (
                            <MenuItem key={index} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </TextField>
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          label="Description"
                          className="summary-field"
                          fullWidth
                          value={currentEducation?.description}
                          onChange={handleChangeEducationItems("description")}
                          multiline
                          minRows={2}
                          placeholder="Description (500 characters Maximum)"
                          inputProps={{ maxLength: MAX_DESC_LENGTH }}
                        />
                        <div className="d-flex justify-content-end align-items-start my-2">
                          {/* <div className="invite-modal-subtitle">Enable AI Generation with minimum 15 words</div> */}
                          <Button
                            variant="outlined"
                            sx={{ color: "#0044C6" }}
                            className="ai-rewrite-button"
                            onClick={() =>
                              handleGenerateDescription(
                                {
                                  institute: currentEducation?.institute,
                                  universityOrBoard:
                                    currentEducation?.universityName,
                                  grade: currentEducation?.grade,
                                  fieldOfStudy: currentEducation?.fieldofStudy,
                                  startYear: currentEducation?.startYear,
                                  endYear: currentEducation?.isCurrentlyPursuing
                                    ? "Present"
                                    : currentEducation?.endYear,
                                  degree: currentEducation?.degree,
                                  description: currentEducation?.description,
                                },
                                "education",
                                "description",
                                updateCurrentEducation
                              )
                            }
                            // disabled={!currentExperience.details || currentExperience.details.split(" ").length < 15}
                            startIcon={<AiLogo />}
                          >
                            Generate
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                  </div>

                  <div className="mt-4 d-flex justify-content-between">
                    {editIndexEducation !== null ? (
                      <>
                        <div>
                          <Button
                            variant="contained"
                            sx={{ backgroundColor: "#0044C6" }}
                            onClick={handleVerifyEdu}
                            disabled={
                              !areEduFieldsFilled("add") ||
                              currentEducation?.isVerified
                            }
                            className={`verify-button ${currentEducation?.isVerified ? "success-green" : ""
                              }`}
                          >
                            {currentEducation?.isVerified
                              ? "Verified"
                              : "Verify"}
                          </Button>
                        </div>
                        <div>
                          <Button
                            className="secondary-btn me-3"
                            onClick={() => {
                              setIsModalOpen(false);
                              setDeleteEducation(true);
                            }}
                          >
                            Delete
                          </Button>
                          <Button
                            variant="contained"
                            sx={{ backgroundColor: "#0044C6" }}
                            onClick={handleAddEducation}
                            disabled={submittingSection === "education" || !areEduFieldsFilled("add")}
                          >
                            {/* Save */}
                         {submittingSection === "education" ? (
                              <span className="d-flex align-items-center">
                                <CircularProgress size={16} sx={{ mr: 1, color: "white" }} />
                                Saving...
                              </span>
                            ) : (
                              "Save"
                            )}
                         </Button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div>
                          {/* <Button
                            variant="contained"
                            sx={{ backgroundColor: "#0044C6" }}
                            onClick={handleVerifyEdu}
                            disabled={!areEduFieldsFilled("add")}
                          >
                            Verify
                          </Button> */}
                          <Button
                            className="secondary-btn me-3"
                            onClick={() => {
                              setIsModalOpen(false);
                              resetCurrentEducation();
                            }}
                          >
                            Cancel
                          </Button>
                        </div>
                        <div>
                          <Button
                            variant="contained"
                            sx={{ backgroundColor: "#0044C6" }}
                            onClick={handleAddEducation}
                          >
                            {/* Add */}
                          {submittingSection === "education" ? (
                              <span className="d-flex align-items-center">
                                <CircularProgress size={16} sx={{ mr: 1, color: "white" }} />
                                Adding...
                              </span>
                            ) : (
                              "Add"
                            )}
                          </Button>
                        </div>
                      </>
                    )}
                  </div>
                </>
              </div>
            </div>
          </div>
        )}

        {DeleteEducation && (
          <>
            <DeleteLightBox
              LightBoxCloseFunction={setDeleteEducation}
              Title={"Education"}
              Label={"Do you really want to delete this Education details?"}
              DeleteFunction={handleDeleteEducation}
              clearFields={resetCurrentEducation}
            />
          </>
        )}

        {deleteResume && (
          <>
            <DeleteLightBox
              LightBoxCloseFunction={setDeleteResume}
              Title={"Resume"}
              Label={
                " This is a Permanent Action. Do you really want to delete this Resume?"
              }
              DeleteFunction={() => handleDeleteResume(selectedResume)}
              clearFields={() => setSelectedResume(null)}
            />
          </>
        )}

        {deleteVideoResume && (
          <>
            <DeleteLightBox
              LightBoxCloseFunction={setDeleteVideoResume}
              Title={"Video Resume"}
              Label={
                " This is a Permanent Action. Do you really want to delete this Video Resume?"
              }
              DeleteFunction={() =>
                handleDeleteVideoResume(selectedVideoResume)
              }
              clearFields={() => setSelectedVideoResume(null)}
            />
          </>
        )}

        {resumeAlert && (
          <AlertDialog
            open={resumeAlert}
            onClose={closeAlertDialog}
            dialogTitle={resumeAlertConfig.title}
            dialogMessage={resumeAlertConfig.message}
            cancelFn={resumeAlertConfig.cancelFn}
            continueFn={resumeAlertConfig.continueFn}
            continueLabel={resumeAlertConfig.continueLabel}
          />
        )}

        {aboutOpen && (
          <div className="lightbox-overlay">
            <div className="lightbox-content-2 p-4">
              <>
                <div className="d-flex justify-content-between">
                  <h6 className="about-me-title mt-2 mb-0">About Me</h6>
                  <div className="d-flex about-me-actions">
                    {/* <div className="d-flex">
                      <div className="icon flex-center mx-2"> <img src={Aigenerate} alt="aigenerate" /> </div>
                      <div className="content no-wrap pointer" style={{ whiteSpace: 'nowrap' }}>AI Generate</div>
                    </div> */}
                    <Button
                      variant="outlined"
                      sx={{ color: "#0044C6" }}
                      className="ai-rewrite-button"
                      onClick={handleGenerateAboutMe}
                      // disabled={status === "recording"}
                      startIcon={<AiLogo />}
                    >
                      Generate
                    </Button>
                    <IconButton
                      onClick={() => {
                        setAboutOpen(false);
                      }}
                    >
                      <CloseRoundedIcon />
                    </IconButton>
                  </div>
                </div>
                <div className="about-me-edit-container mt-3">
                  <textarea
                    // value={ProfessionalEdited?.aboutme}
                    // onChange={(e) => {
                    //   setText(e.target.value);
                    // }}
                    value={getProfFieldValue("aboutme")}
                    onChange={handleInputChange("aboutme")}
                    className="About-me-edit"
                    maxLength={1000}
                    placeholder="Write something about yourself"
                    required
                    pattern="^[A-Za-z]+$"
                  />
                  <div className="about-me-edit-count">
                    {ProfessionalEdited?.aboutme?.length
                      ? ProfessionalEdited?.aboutme?.length
                      : 0}
                    /1000
                  </div>
                </div>

                <div className="mt-3 d-flex justify-content-end">
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: "#0044C6" }}
                    // disabled={!ProfessionalEdited?.aboutme}
                    onClick={handleAboutMeSave}
                  >
                    Save
                  </Button>
                </div>
              </>
            </div>
          </div>
        )}

        <CompanySelectionModal
          open={showCompanySelection}
          onClose={() => setShowCompanySelection(false)}
          companies={
            enterpriseCompanies.length > 0
              ? enterpriseCompanies
              : ProfessionalExperience?.filter(
                  (exp) => exp.is_currently_working === true
                ) || []
          }
          experiences={
            enterpriseCompanies.length > 0
              ? enterpriseCompanies
              : ProfessionalExperience?.filter(
                  (exp) => exp.is_currently_working === true
                ) || []
          }
          onSelectCompany={(selectedExperience) => {
            const companyId =
              selectedExperience.cid ||
              selectedExperience.uniqueId ||
              getCompanyIdFromUserType(
                userTypeDetails,
                selectedExperience.companyName || selectedExperience.company_name
              );
            const enterpriseCompanyId =
              selectedExperience.id ||
              selectedExperience.entityId ||
              getEnterpriseEntityIdFromUserType(
                userTypeDetails,
                selectedExperience.companyName || selectedExperience.company_name || companyId
              );
            const targetCompName = (selectedExperience.companyName || selectedExperience.company_name || "")?.trim()?.toLowerCase();
            const targetCid = (companyId || selectedExperience.cid || selectedExperience.uniqueId || "")?.toString()?.trim()?.toLowerCase();
            const targetLogo = (selectedExperience.companyLogo || selectedExperience.company_logo || "")?.trim();

            const matchedExp = (Array.isArray(ProfessionalExperience) ? ProfessionalExperience : []).find((exp) => {
              const expCid = (exp?.cid || exp?.uniqueId || exp?.company_id || "")?.toString()?.trim()?.toLowerCase();
              const expName = (exp?.company_name || exp?.companyName || "")?.trim()?.toLowerCase();
              const expLogo = (exp?.company_logo || exp?.companylogo?.data || "")?.toString()?.trim();

              if (expCid && targetCid && expCid === targetCid) return true;
              if (expName && targetCompName && expName === targetCompName) return true;
              if (expLogo && targetLogo && expLogo === targetLogo) return true;
              if (expName && targetCompName && (expName.includes(targetCompName) || targetCompName.includes(expName))) return true;
              return false;
            });

            let companyDomain =
              selectedExperience.company_domain ||
              selectedExperience.companyDomain ||
              selectedExperience.company_url ||
              selectedExperience.website ||
              matchedExp?.company_domain ||
              matchedExp?.companyDomain ||
              matchedExp?.website ||
              matchedExp?.company_url ||
              hiringData?.company_url ||
              "";

            if (!companyDomain && matchedExp?.company_email && matchedExp.company_email.includes("@")) {
              const emailDomain = matchedExp.company_email.split("@")[1]?.trim()?.toLowerCase();
              const publicProviders = ["gmail.com", "yahoo.com", "outlook.com", "hotmail.com", "icloud.com"];
              if (emailDomain && !publicProviders.includes(emailDomain)) {
                companyDomain = emailDomain;
              }
            }

            setHiringData((prev) => ({
              ...prev,
              company_name: selectedExperience.companyName || selectedExperience.company_name || "",
              company_url: companyDomain || prev?.company_url || "",
              company_location: selectedExperience.location || matchedExp?.location || prev?.company_location || "",
              emp_type: selectedExperience.employee_type || selectedExperience.role || matchedExp?.employee_type || prev?.emp_type || "",
              mode: selectedExperience.location_type || selectedExperience.location || matchedExp?.location_type || "Remote",
              company_logo: selectedExperience.companyLogo || selectedExperience.company_logo || matchedExp?.company_logo || "",
              company_id: companyId || "",
              enterprise_company_id: enterpriseCompanyId || undefined,
            }));
            setShowCompanySelection(false);
            setHiringModalOpen(true);
          }}
        />

        <PostingJobModal
          open={hiringModalOpen}
          onClose={handleClose}
          currentStep={currentStep}
          hiringData={hiringData}
          companyLogo={companyLogo}
          menuOptions={menuOptions}
          hiringInputValue={hiringInputValue}
          localGeneratedSkills={localGeneratedSkills}
          selectedChips={selectedChips}
          isLoadingSkills={isLoadingSkills}
          isLoadingDescription={isLoadingDescription}
          handleHiringModalClose={handleHiringModalClose}
          handleHiringInputChange={handleHiringInputChange}
          handleKeyDown={handleKeyDown}
          handleHiringAddChip={handleHiringAddChip}
          handleChipToggle={handleChipToggle}
          handleHiringChipDelete={handleHiringChipDelete}
          handleEditSkillClick={handleEditSkillClick}
          handleEditResponseClick={handleEditResponseClick}
          handleBack={handleBack}
          handleNext={handleNext}
          handleClose={handleClose}
          handleHiringSubmit={handleHiringSubmit}
          setHiringInputValue={setHiringInputValue}
          setCurrentStep={setCurrentStep}
          fieldErrors={fieldJobErrors}
        />

        <Modal open={professionOpen} onClose={() => setprofessionOpen(false)}>
          <Box
            sx={{
              width: isSmallLaptop ? "80%" : "65%",
              maxWidth: "80%",
              maxHeight: "80%",
              p: 3,
            }}
            className="modal-box-1"
          >
            <div
              className="soc-modal-heading mb-3"
              style={{ position: "relative" }}
            >
              <strong>Edit Professional Information</strong>
              <span className="span-center-align file-attach-icon-container">
                <IconButton
                  color="rgb(0, 0, 0, 0.54)"
                  onClick={() => {
                    setprofessionOpen(false);
                  }}
                >
                  <CloseRoundedIcon />
                </IconButton>
              </span>
            </div>
            <div className="my-2 user-details-container">
              <Grid container spacing={3}>
                <Grid item xs={8}>
                  <Grid container spacing={2}>
                    {/* <Grid item xs={6}>
                      <TextField
                        label="Company Name"
                        fullWidth
                        value={getProfFieldValue("CompanyName")}
                        // value={ProfessionalEdited?.CompanyName || ""}
                        onChange={handleInputChange("CompanyName")}
                        disabled={!professionOpen}
                        required
                      />
                    </Grid> */}

                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <Autocomplete
                          freeSolo
                          options={searchItems || []}
                          value={selectedProfessionalCompany || null}
                          inputValue={ProfessionalEdited?.CompanyName || ''}
                          onInputChange={handleSearchLogo}
                          onChange={
                            // If the user selects from dropdown or types a new value
                            handleSelected}
                          getOptionLabel={(option) =>
                            typeof option === "string" ? option : option?.legal_name || ""
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Company Name"
                              variant="outlined"
                              fullWidth
                              disabled={!professionOpen}
                              required
                              onClick={() => {
                                setMenuItem("CompanyName"); //  This is where you set it
                              }}
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>

                    {/* <Grid item xs={6}>
                      <TextField
                        label="Company Website"
                        fullWidth
                        value={getProfFieldValue("CompanyWeb")}
                        onChange={handleInputChange("CompanyWeb")}
                        disabled={!professionOpen}
                      />
                    </Grid> */}
                    <Grid item xs={6}>
                      <FormControl fullWidth>
                        <Autocomplete
                          freeSolo
                          options={searchItems || []}
                          value={selectedProfessionalDomain || null}
                          inputValue={ProfessionalEdited?.CompanyWeb || ''}
                          onInputChange={handleSearchDomain
                          }
                          onChange={handleSelectedDomain}
                          getOptionLabel={(option) =>
                            typeof option === "string" ? option : option?.website || ""
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="companyDomain"
                              label="Company Website/Domain"
                              variant="outlined"
                              fullWidtha
                              disabled={!professionOpen}
                              onClick={() => setMenuItem("CompanyWebsite")}
                            />
                          )}
                        />
                      </FormControl>
                    </Grid>


                    <Grid item xs={6}>
                      <TextField
                        label="Designation"
                        fullWidth
                        value={getProfFieldValue("Designation")}
                        onChange={handleInputChange("Designation")}
                        disabled={!professionOpen}
                        required
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Department"
                        fullWidth
                        value={getProfFieldValue("Department")}
                        onChange={handleInputChange("Department")}
                        disabled={!professionOpen}
                        required
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label="Company Email"
                        fullWidth
                        value={getProfFieldValue("CompanyEmail")}
                        onChange={handleInputChange("CompanyEmail")}
                        disabled={!professionOpen}
                        required
                        error={emailError}
                        helperText={emailError ? "Invalid email address" : ""}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {ProfessionalEdited?.isVerified?.CompanyEmail ? (
                                <VerifiedTick className="green-verified-tick" />
                              ) : (
                                <VerifiedTick />
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <MuiTelInput
                        name="phone"
                        label="Phone Number"
                        required
                        value={getProfFieldValue("CompanyPhone")}
                        onChange={handleInputChange("CompanyPhone")}
                        defaultCountry="IN"
                        disabled={!professionOpen}
                        MenuProps={PhoneInputMenuProps}
                        fullWidth
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {ProfessionalEdited?.isVerified?.CompanyPhone ? (
                                <VerifiedTick className="green-verified-tick" />
                              ) : (
                                <VerifiedTick />
                              )}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label="Starting Date"
                        // type="date"
                        fullWidth
                        error={!!dateError}
                        helperText={dateError && "Please enter valid dates"}
                        value={getProfFieldValue("StartDate") || ""}
                        onChange={handleInputChange("StartDate")}
                        disabled={!professionOpen}
                      // InputLabelProps={{ shrink: true }}
                      // inputProps={{ max: today }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Ending Date"
                        // type="date"
                        fullWidth
                        error={!!dateError}
                        helperText={dateError && "Please enter valid dates"}
                        value={getProfFieldValue("EndDate") || ""}
                        onChange={handleInputChange("EndDate")}
                        disabled={
                          !professionOpen ||
                          ProfessionalEdited?.isCurrentlyWorking
                        }
                      // InputLabelProps={{ shrink: true }}
                      // inputProps={{ max: today }}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={getProfFieldValue("isCurrentlyWorking")}
                              onChange={handleCheckboxMyProfile}
                              disabled={!professionOpen}
                            />
                          }
                          label="Currently Working"
                        />
                      </FormGroup>
                    </Grid>

                    <Grid item xs={12}>
                      <TextField
                        label="Company Address"
                        className="summary-field"
                        fullWidth
                        value={getProfFieldValue("CompanyAddress")}
                        onChange={handleInputChange("CompanyAddress")}
                        disabled={!professionOpen}
                        inputProps={{ spellCheck: false, maxLength: 200 }}
                        multiline
                        placeholder="Max Characters 200"
                      />
                    </Grid>
                  </Grid>
                  <div className="d-flex flex-direction-row justify-content-between">
                    {ProfessionalEdited?.isVerified?.CompanyEmail &&
                      ProfessionalEdited?.isVerified?.CompanyPhone ? (
                      <div className="d-flex justify-content-start mt-3">
                        <Button
                          variant="contained"
                          className="verify-button success-green"
                          disabled
                        >
                          Verified
                        </Button>
                      </div>
                    ) : (
                      <div className="d-flex justify-content-start mt-3">
                        <Button
                          variant="contained"
                          sx={{ backgroundColor: "#0044C6" }}
                          onClick={() => sendEmailOtp(ProfessionalEdited?.CompanyEmail)}
                          disabled={!ProfessionalEdited.CompanyEmail}
                        >
                          {ProfessionalEdited?.isVerified?.CompanyEmail ?
                            "Email Verified" : "Verify Email"}
                        </Button>
                      </div>
                    )}

                    {professionOpen && (
                      <div className="d-flex justify-content-end mt-3">
                        <Button
                          variant="contained"
                          sx={{ backgroundColor: "#0044C6" }}
                          onClick={handleProfessionalInfoSave}
                        >
                          Save
                        </Button>
                      </div>
                    )}
                  </div>
                </Grid>

                <Grid item xs={4} className="pt-3">
                  <div className="view-options-menu">
                    <div className="flex-center-between">
                      <div className="mb-2">
                        <div className="menu-title">Customize User View</div>
                        <div className="menu-subtitle">
                          Manage what info to share
                        </div>
                      </div>
                      <IconButton
                        onClick={() => setShowViewOptions(!showViewOptions)}
                      >
                        <ViewOptionsIcon
                          className={`${showViewOptions ? "color-blue" : ""}`}
                        />
                      </IconButton>
                    </div>

                    <Collapse in={showViewOptions}>
                      <div className="view-options-checkboxes">
                        {viewOptionsOrder?.map((option) => (
                          <div
                            key={option}
                            className="view-options-checkbox-item"
                          >
                            <span
                              className={
                                disabledFields.includes(option)
                                  ? "disabled-text"
                                  : ""
                              }
                            >
                              {option
                                .replace(/([A-Z])/g, " $1")
                                .replace(/^./, (str) => str.toUpperCase())}
                            </span>
                            <Checkbox
                              checked={viewOptions[option]}
                              onChange={handleViewCheckboxChange}
                              name={option}
                              color="primary"
                              defaultChecked={
                                option === "firstName" || option === "lastName"
                              }
                              disabled={disabledFields.includes(option)}
                            />
                          </div>
                        ))}
                      </div>
                    </Collapse>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Box>
        </Modal>

        <Modal
          open={openFamilyVerify}
          onClose={() => {
            setOpenFamilyVerify(false);
            setisFamilyEdit(true);
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "auto",
              minWidth: "40%",
              bgcolor: "white",
              boxShadow: "0px 4px 4px 0px #00000040",
              borderRadius: 2,
              p: 3,
              maxHeight: "80%",
              overflowY: "auto",
            }}
          >
            {isPhoneVerified && isProfessionalEmailVerified ? (
              <div className="flex-center flex-column">
                <img
                  src={VerifySuccess}
                  alt="Successfully Verified"
                  className="dialogImage"
                />
                <div className="profile-modal-heading1 mb-2">
                  Email ID and Phone Number Verified
                </div>
                <div className="time-label">
                  Your professional details have been successfully verified.
                </div>
                <Button
                  className="mt-3"
                  variant="contained"
                  sx={{ backgroundColor: "#0044C6" }}
                  onClick={() => {
                    setOpenFamilyVerify(false);
                  }}
                  disableTouchRipple
                >
                  Continue
                </Button>
              </div>
            ) : (
              <div>
                <div className="modal-heading">
                  <div className="profile-modal-heading1">
                    Verify Email & Phone number{" "}
                  </div>
                  <span className="span-center-align file-attach-icon-container">
                    <IconButton
                      color="rgb(0, 0, 0, 0.54)"
                      disableTouchRipple
                      onClick={() => setOpenFamilyVerify(false)}
                    >
                      <CloseRoundedIcon />
                    </IconButton>
                  </span>
                </div>
                <div className="modal-body">
                  <div className="py-4">
                    {/* <TextField
                                        fullWidth
                                        value={emailOtp}
                                        onChange={(e) => setEmailOtp(e.target.value)}
                                        label="Enter Email OTP"
                                        autoFocus
                                        autoComplete={false}
                                        autoCorrect={false}
                                        disabled={isEmailVerified}
                                        error={!!emailError}
                                        helperText={emailError || ' '}
                                    /> */}
                    <TextField
                      fullWidth
                      value={professionalEmailOtp}
                      onChange={(e) => setProfessionalEmailOtp(e.target.value)}
                      label="Enter Email OTP"
                      autoFocus
                      autoComplete="off"
                      autoCorrect="off"
                      disabled={isProfessionalEmailVerified}
                      error={!!emailError}
                      helperText={emailError || " "}
                    />
                    <div className="mt-12px">
                      <span className="helper-text-style">
                        Remaining Time: 00.{emailOtpSeconds < 10 ? `0${emailOtpSeconds}` : emailOtpSeconds}s
                      </span>
                    </div>

                    <div className="d-flex justify-content-between mt-4">
                      <span className="span-center-align">
                        <span className="helper-text-style me-2">
                          Didn't receive the mail?
                        </span>
                        <Button
                          sx={{ color: "#0044C6" }}
                          disabled={isProfessionalEmailVerified || emailOtpSeconds > 0}
                          onClick={() => sendEmailOtp(ProfessionalEdited?.CompanyEmail)}
                        >
                          Resend
                        </Button>
                      </span>
                      <Button
                        variant="contained"
                        sx={{ backgroundColor: "#0044C6" }}
                        disabled={isProfessionalEmailVerified}
                        onClick={() => verifyProfessionalEmailOtp(ProfessionalEdited?.CompanyEmail)}
                        className={`verify-button ${isProfessionalEmailVerified ? "success-green" : ""}`}
                        disableTouchRipple
                      >
                        {isProfessionalEmailVerified ? "Verified" : "Verify"}
                      </Button>
                    </div>
                  </div>

                  <Divider
                    sx={{
                      backgroundColor: "#DDE0E6",
                      height: "1px",
                      opacity: 1,
                    }}
                  />

                  <div className="pt-4">
                    {/* <TextField
                                        fullWidth
                                        value={phoneOtp}
                                        onChange={(e) => setPhoneOtp(e.target.value)}
                                        label="Enter Phone OTP"
                                        autoFocus
                                        autoComplete={false}
                                        autoCorrect={false}
                                        disabled={!isEmailVerified}
                                        error={phoneError}
                                        helperText={phoneError || ' '}
                                    /> */}

                    <TextField
                      fullWidth
                      value={phoneOtp}
                      onChange={(e) => setPhoneOtp(e.target.value)}
                      label="Enter Phone OTP"
                      autoComplete="off"
                      autoCorrect="off"
                      disabled={isPhoneVerified}
                      error={!!phoneError}
                      helperText={phoneError || " "}
                    />
                    <div className="mt-12px">
                      <span className="helper-text-style">
                        Remaining Time: 00.{phoneOtpSeconds < 10 ? `0${phoneOtpSeconds}` : phoneOtpSeconds}s
                      </span>
                    </div>

                    <div className="d-flex justify-content-between mt-4">
                      <span className="span-center-align">
                        <span className="helper-text-style me-2">
                          Didn't receive the SMS?
                        </span>
                        <Button
                          sx={{ color: "#0044C6" }}
                          disabled={isPhoneVerified || phoneOtpSeconds > 0}
                          onClick={() => sendPhoneOtp(ProfessionalEdited?.CompanyPhone)}
                        >
                          Resend
                        </Button>
                      </span>
                      <Button
                        variant="contained"
                        sx={{ backgroundColor: "#0044C6" }}
                        disabled={isPhoneVerified}
                        onClick={() => verifyPhoneOtp(ProfessionalEdited?.CompanyPhone)}
                        className={`verify-button ${isPhoneVerified ? "success-green" : ""}`}
                        disableTouchRipple
                      >
                        {isPhoneVerified ? "Verified" : "Verify"}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Box>
        </Modal>

        <Modal
          open={openModalSkills.softSkills}
          onClose={() => handleCloseSkillsModal("softSkills")}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "auto",
              bgcolor: "white",
              boxShadow: "0px 4px 4px 0px #00000040",
              borderRadius: 2,
              maxWidth: "60%",
              maxHeight: "80%",
              overflowY: "auto",
            }}
          >
            <div className="px-3 pt-3">
              <div
                className="soc-modal-heading"
                style={{ position: "relative" }}
              >
                <h5>Add Soft Skills</h5>
                <span className="span-center-align file-attach-icon-container">
                  <IconButton
                    color="rgb(0, 0, 0, 0.54)"
                    onClick={() => handleCloseSkillsModal("softSkills")}
                  >
                    <CloseRoundedIcon />
                  </IconButton>
                </span>
              </div>
            </div>
            <Divider
              className="my-2"
              sx={{ backgroundColor: "#DDE0E6", height: "1px", opacity: 1 }}
            />
            <div
              className="p-3 mb-3"
              style={{ maxHeight: "calc(80vh - 150px)" }}
            >
              {profSoftSkills.map((item, index) => (
                <SkillItemForLightBox
                  key={item}
                  label={item}
                  selectedSkills={Skills?.softSkills}
                  skillsKey="softSkills"
                  onAdd={handleAddSkill}
                />
              ))}
            </div>
          </Box>
        </Modal>

        <Modal
          open={openModalSkills.profSkills}
          onClose={() => handleCloseSkillsModal("profSkills")}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "auto",
              bgcolor: "white",
              boxShadow: "0px 4px 4px 0px #00000040",
              borderRadius: 2,
              maxWidth: "60%",
              maxHeight: "80%",
              overflowY: "auto",
            }}
          >
            <div className="px-3 pt-3">
              <div
                className="soc-modal-heading"
                style={{ position: "relative" }}
              >
                <h5>Add Professional Skills</h5>
                <span className="span-center-align file-attach-icon-container">
                  <IconButton
                    color="rgb(0, 0, 0, 0.54)"
                    onClick={() => handleCloseSkillsModal("profSkills")}
                  >
                    <CloseRoundedIcon />
                  </IconButton>
                </span>
              </div>
            </div>
            <Divider
              className="my-2"
              sx={{ backgroundColor: "#DDE0E6", height: "1px", opacity: 1 }}
            />
            <div
              className="p-3 mb-3"
              style={{ maxHeight: "calc(80vh - 150px)" }}
            >
              {professionSkills.map((item, index) => (
                <section className="soc-modal-section pb-3" key={index}>
                  <div className="mb-3 profile-modal-heading1">
                    {item.title}
                  </div>
                  {item.skills.map((skill, linkIndex) => (
                    <SkillItemForLightBox
                      key={skill}
                      label={skill}
                      selectedSkills={Skills?.profSkills}
                      skillsKey={"profSkills"}
                      onAdd={handleAddSkill}
                    />
                  ))}
                </section>
              ))}
            </div>
          </Box>
        </Modal>

        <Modal
          open={openModalSkills.profTools}
          onClose={() => handleCloseSkillsModal("profTools")}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "auto",
              bgcolor: "white",
              boxShadow: "0px 4px 4px 0px #00000040",
              borderRadius: 2,
              maxWidth: "60%",
              maxHeight: "80%",
              overflowY: "auto",
            }}
          >
            <div className="px-3 pt-3">
              <div
                className="soc-modal-heading"
                style={{ position: "relative" }}
              >
                <h5>Add Tools</h5>
                <span className="span-center-align file-attach-icon-container">
                  <IconButton
                    color="rgb(0, 0, 0, 0.54)"
                    onClick={() => handleCloseSkillsModal("profTools")}
                  >
                    <CloseRoundedIcon />
                  </IconButton>
                </span>
              </div>
            </div>
            <Divider
              className="my-2"
              sx={{ backgroundColor: "#DDE0E6", height: "1px", opacity: 1 }}
            />
            <div
              className="p-3 mb-3"
              style={{ maxHeight: "calc(80vh - 150px)" }}
            >
              {professionalTools.map((item, index) => (
                <section className="soc-modal-section pb-3" key={index}>
                  <div className="mb-3 profile-modal-heading1">
                    {item.title}
                  </div>
                  {item.skills.map((skill, linkIndex) => (
                    <SkillItemForLightBox
                      key={skill}
                      label={skill}
                      selectedSkills={Skills?.profTools}
                      skillsKey={"profTools"}
                      onAdd={handleAddSkill}
                    />
                  ))}
                </section>
              ))}
            </div>
          </Box>
        </Modal>

        <Modal
          open={openModalLanguage}
          onClose={() => {
            setOpenLanguage(false);
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "auto",
              bgcolor: "white",
              boxShadow: "0px 4px 4px 0px #00000040",
              borderRadius: 2,
              minWidth: "80%",
              maxHeight: "80%",
              overflowY: "scroll",
            }}
          >
            <div className="px-3 pt-3">
              <div
                className="soc-modal-heading"
                style={{ position: "relative" }}
              >
                <h5>Add Languages</h5>
                <span>Select the Languages</span>
                <span className="span-center-align file-attach-icon-container">
                  <IconButton
                    color="rgb(0, 0, 0, 0.54)"
                    onClick={() => {
                      setOpenLanguage(false);
                    }}
                  >
                    <CloseRoundedIcon />
                  </IconButton>
                </span>
              </div>
            </div>
            <Divider
              className="my-2"
              sx={{ backgroundColor: "#DDE0E6", height: "1px", opacity: 1 }}
            />
            <div
              className="p-3 mb-3"
              style={{ maxHeight: "calc(80vh - 150px)" }}
            >
              <section className="soc-modal-section mb-3">
                {DefaultLanguages.map((language, index) => (
                  <SkillItemForLightBox
                    key={index}
                    label={language}
                    selectedSkills={profLanguages}
                    onAdd={handleAddLanguage}
                  />
                ))}
              </section>
            </div>
          </Box>
        </Modal>

        <Modal
          open={verifyEduModal}
          onClose={() => {
            setVerifyEduModal(false);
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "auto",
              bgcolor: "white",
              boxShadow: "0px 4px 4px 0px #00000040",
              p: 3,
              borderRadius: 2,
              minWidth: "35%",
              maxHeight: "80%",
              overflowY: "auto",
            }}
          >
            <div className="soc-modal-heading position-relative mb-4">
              <strong>Verify your Educational Info</strong>
              <span className="span-center-align file-attach-icon-container">
                <IconButton
                  color="rgb(0, 0, 0, 0.54)"
                  onClick={() => {
                    setVerifyEduModal(false);
                  }}
                >
                  <CloseRoundedIcon />
                </IconButton>
              </span>
            </div>
            <div className="profile-verify-fields">
              <TextField
                name="fullName"
                label="Full Name"
                value={currentEducation.fullName || userDetails.name || ""}
                onChange={handleChangeEducationItems("fullName")}
                fullWidth
                required
              />
              <TextField
                name="studentId"
                label="Student ID"
                value={currentEducation.studentId}
                onChange={handleChangeEducationItems("studentId")}
                fullWidth
                required
              />
              <TextField
                name="verifyMethod"
                label="Verification Method"
                value={currentEducation.verifyMethod}
                onChange={handleChangeEducationItems("verifyMethod")}
                fullWidth
                select
                required
              >
                {currentEducation?.isCurrentlyPursuing && <MenuItem value="studentEmailId">
                  Verify with OTP to your Student E-mail
                </MenuItem>}
                <MenuItem value="adminEmailId">
                  My Institute Admin E-mail ID
                </MenuItem>
                {/* <MenuItem value="verifyDoc">
                  Upload Verification Document
                </MenuItem> */}
              </TextField>
              {currentEducation?.verifyMethod !== "" && (
                <>
                  {currentEducation?.verifyMethod === "studentEmailId" && (
                    <TextField
                      name="studentEmail"
                      label="Your Student Email ID"
                      value={currentEducation?.institute_email}
                      // value={currentEducation.studentEmailId}
                      onChange={(e) => {
                        // handleChangeEducationItems("studentEmailId")(e);
                        handleChangeEducationItems("institute_email")(e);
                        validateEmail(
                          e.target.value || currentEducation?.institute_email,
                          currentEducation?.instituteDomain
                        );
                      }}
                      fullWidth
                      required
                      helperText="Verify your academic details securely using your student Email ID given by your institute. An OTP will be sent to the entered e-mail ID."
                    />
                  )}
                  {currentEducation.verifyMethod === "adminEmailId" && (
                    <>
                      <TextField
                        name="adminId"
                        label="Admin E-mail ID"
                        value={currentEducation.adminEmailId}
                        // onChange={handleChangeEducationItems("adminEmailId")}
                        onChange={(e) => {
                          handleChangeEducationItems("adminEmailId")(e);
                          validateEmail(
                            e.target.value,
                            currentEducation.instituteDomain
                          );
                        }}
                        fullWidth
                        required
                        helperText="Verify your academic details securely using your institute's admin ID."
                      />

                      <FileDragUploadWithContext
                        label="Upload Verification Document"
                        maxSize={5}
                        inputId="verifyEduDoc"
                        contextKey="verifyDoc"
                        context={currentEducation}
                        updateContext={updateCurrentEducation}
                        accept={["image/jpeg", "image/png", "application/pdf"]}
                      />
                    </>
                  )}
                  {currentEducation.verifyMethod === "verifyDoc" && (
                    <FileDragUploadWithContext
                      label="Upload Verification Document"
                      maxSize={5}
                      inputId="verifyEduDoc"
                      contextKey="verifyDoc"
                      context={currentEducation}
                      updateContext={updateCurrentEducation}
                      accept={["image/jpeg", "image/png", "application/pdf"]}
                    />
                  )}
                </>
              )}
            </div>
            <div className="mt-3 d-flex justify-content-end">
              <Button
                className="secondary-btn me-3"
                onClick={handleVerifyEduCancel}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#0044C6" }}
                onClick={handleVerifyEduButton}
                disabled={
                  !isEmailValid ||
                  (!currentEducation.institute_email &&
                    !currentEducation.adminEmailId)
                }
              >
                Verify
              </Button>
            </div>
          </Box>
        </Modal>

        <Modal
          open={verifyCertModal}
          onClose={() => {
            setVerifyCertModal(false);
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "auto",
              bgcolor: "white",
              boxShadow: "0px 4px 4px 0px #00000040",
              p: 3,
              borderRadius: 2,
              minWidth: "35%",
              maxHeight: "80%",
              overflowY: "auto",
            }}
          >
            <div
              className="soc-modal-heading mb-4"
              style={{ position: "relative" }}
            >
              <strong>Verify your Certification</strong>
              <span className="span-center-align file-attach-icon-container">
                <IconButton
                  color="rgb(0, 0, 0, 0.54)"
                  onClick={() => {
                    setVerifyCertModal(false);
                  }}
                >
                  <CloseRoundedIcon />
                </IconButton>
              </span>
            </div>
            <div className="profile-verify-fields">
              <TextField
                name="fullName"
                label="Full Name"
                value={userDetails?.name || ""}
                onChange={handleCertifiItems("fullName")}
                fullWidth
                required
              />
              <TextField
                label="Certificate Link"
                fullWidth
                value={currentCertificate?.certificateLink || ""}
                onChange={handleCertifiItems("certificateLink")}
                helperText="If available, it is recommended you paste the certification link for verification"
              />
              <TextField
                name="verifyMethod"
                label="Verification Method"
                value={currentCertificate?.verifyMethod}
                onChange={handleCertifiItems("verifyMethod")}
                fullWidth
                select
                required
              >
                <MenuItem value="orgEmailId">
                  Organization Admin E-mail ID
                </MenuItem>
                {/* <MenuItem value="verifyDoc">
                  Upload Verification Document
                </MenuItem> */}
              </TextField>
              {currentCertificate.verifyMethod !== "" && (
                <>
                  {currentCertificate.verifyMethod === "orgEmailId" && (
                    <>
                      <TextField
                        name="orgEmailId"
                        label="Admin Email ID"
                        // value={currentEducation.orgEmailId}
                        value={currentCertificate.orgEmailId}
                        // onChange={handleCertifiItems("orgEmailId")}
                        onChange={(e) => {
                          handleCertifiItems("orgEmailId")(e);
                          validateEmail(
                            e.target.value,
                            currentCertificate?.organDomain
                          );
                        }}
                        fullWidth
                        helperText="Verify your certification securely using the organization's admin ID."
                      />

                      <FileDragUploadWithContext
                        label="Upload Verification Document"
                        maxSize={5}
                        inputId="verifyCertDoc"
                        contextKey="verifyDoc"
                        context={currentCertificate}
                        updateContext={updateCurrentCertificate}
                        accept={["image/jpeg", "image/png", "application/pdf"]}
                      />
                    </>
                  )}
                  {currentCertificate.verifyMethod === "verifyDoc" && (
                    <FileDragUploadWithContext
                      label="Upload Verification Document"
                      maxSize={5}
                      inputId="verifyCertDoc"
                      contextKey="verifyDoc"
                      context={currentCertificate}
                      updateContext={updateCurrentCertificate}
                      accept={["image/jpeg", "image/png", "application/pdf"]}
                    />
                  )}
                </>
              )}
            </div>
            <div className="mt-3 d-flex justify-content-end">
              <Button
                className="secondary-btn me-3"
                onClick={handleVerifyCertCancel}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#0044C6" }}
                onClick={handleVerifyCertButton}
                // disabled={!isEmailValid || currentEducation.orgEmailId}
                disabled={!isEmailValid || !currentCertificate.orgEmailId}
              // disableTouchRipple
              >
                Verify
              </Button>
            </div>
          </Box>
        </Modal>

        <Modal
          open={verifyExpModal}
          onClose={() => {
            setVerifyExpModal(false);
            setIsEmailValid(false);
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "auto",
              bgcolor: "white",
              boxShadow: "0px 4px 4px 0px #00000040",
              p: 3,
              borderRadius: 2,
              minWidth: "35%",
              maxHeight: "80%",
              overflowY: "auto",
            }}
          >
            <div
              className="soc-modal-heading mb-4"
              style={{ position: "relative" }}
            >
              <strong>Verify your Experience</strong>
              <span className="span-center-align file-attach-icon-container">
                <IconButton
                  color="rgb(0, 0, 0, 0.54)"
                  onClick={() => {
                    setVerifyExpModal(false);
                    setIsEmailValid(false);
                  }}
                >
                  <CloseRoundedIcon />
                </IconButton>
              </span>
            </div>
            <div className="profile-verify-fields">
              <TextField
                name="fullName"
                label="Full Name"
                value={currentExperience.fullName || userDetails.name || ""}
                onChange={handleExperienceItems("fullName")}
                fullWidth
              />
              <TextField
                name="employeeId"
                label="Employee ID"
                value={currentExperience.employeeId}
                onChange={handleExperienceItems("employeeId")}
                fullWidth
              />
              <TextField
                name="verifyMethod"
                label="Verification Method"
                value={currentExperience.verifyMethod}
                onChange={handleExperienceItems("verifyMethod")}
                fullWidth
                select
                helperText="Verify your employment or experience by choosing any of the following methods."
              >
                <MenuItem
                  value="currentOtp"
                  disabled={!currentExperience.isCurrentlyWorking}
                >
                  Verify with OTP to Work E-mail (For Current Company only)
                </MenuItem>
                <MenuItem value="hrEmail">HR E-mail ID Verification</MenuItem>
                {/* <MenuItem value="previousHr">Previous HR Correspondence</MenuItem>
                <MenuItem value="previousHr">Previous HR Correspondence</MenuItem> */}
                {/* <MenuItem value="verifyDoc">
                  Upload Verification Document
                </MenuItem> */}
              </TextField>
              {currentExperience.verifyMethod === "currentOtp" && (
                <>
                  <TextField
                    name="workEmail"
                    label="Work E-mail ID"
                    value={currentExperience?.company_email}
                    // value={currentExperience.workEmail}

                    onChange={(e) => {
                      handleExperienceItems("company_email")(e);
                      validateEmail(
                        e.target.value || currentExperience?.company_email,
                        currentExperience?.companyDomain
                      );
                    }}
                    fullWidth
                    helperText="An OTP will be sent to the entered E-mail ID."
                  />
                </>
              )}
              {currentExperience.verifyMethod === "hrEmail" && (
                <>
                  <TextField
                    name="hrName"
                    label="HR Name"
                    value={currentExperience.hrName}
                    onChange={handleExperienceItems("hrName")}
                    fullWidth
                  // helperText="Verify your job details securely using your organization admin's ID."
                  />

                  <TextField
                    name="hrEmail"
                    label="HR Email ID"
                    value={currentExperience.hrEmail}
                    // onChange={handleExperienceItems("hrEmail")}
                    onChange={(e) => {
                      handleExperienceItems("hrEmail")(e);
                      validateEmail(
                        e.target.value,
                        currentExperience.companyDomain
                      );
                    }}
                    fullWidth
                    helperText="Verify your job details securely using your organization's HR email ID."
                  />

                  <div>
                    <p className="mt-0">Upload Verification Documents</p>
                    {currentExperience.verifyDocs?.map((attachment, index) => (
                      <div key={index} className="add-project-modal my-3">
                        <div className="d-flex align-items-center gap-2">
                          <div className="Documents-Attachments">
                            <PreviewFileItem
                              file={attachment}
                              fontColor="#00000099"
                            />
                          </div>
                          <IconButton
                            onClick={() => removeVerifyExpDoc(attachment.id)}
                            disableTouchRipple
                          >
                            <DeleteIcon />
                          </IconButton>
                        </div>
                      </div>
                    ))}
                    <FileDragUpload
                      maxSize={1}
                      inputId="verifyExpDoc3"
                      contextUpdate={updateVerifyExpDocs}
                      accept={[
                        "image/jpeg",
                        "image/png",
                        "application/pdf",
                        "eml",
                        "message/rfc822",
                      ]} // Images, PDF, EML
                    />
                  </div>

                  {/* {renderVerifyExpFields(currentExperience.verifyMethod)} */}
                </>
              )}
            </div>
            <div className="mt-3 d-flex justify-content-end">
              <Button
                className="secondary-btn me-3"
                onClick={handleVerifyExpCancel}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#0044C6" }}
                onClick={handleVerifyExpButton}
                disabled={
                  !isEmailValid ||
                  (!currentExperience.hrEmail &&
                    !currentExperience?.company_email)
                }
              >
                Verify
              </Button>
            </div>
          </Box>
        </Modal>

        {/* <Modal
          open={openRecommendation}
          onClose={() => {
            setOpenRecommendation(false);
          }}
        >
          {/* <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "auto",
              bgcolor: "white",
              boxShadow: "0px 4px 4px 0px #00000040",
              p: 3,
              borderRadius: 2,
              minWidth: "35%",
              maxHeight: "80%",
              overflowY: "auto",
            }}
          >
            
          </Box> */}

        {/* <div className="py-5" style={{ backgroundColor: "#f4f7fe", height: "100vh" }}>
          <div className='p-4 rounded bg-white' style={{ width: "55%", height: "35%", marginLeft: "20%", }}>
            <div className='d-flex align justify-content-between align-items-center'>
              <h6 className='mb-0' style={{ fontSize: "16px", fontWeight: "bold", color: "black" }}>
                Are you sure you want to delete Recommendation?
              </h6>
            </div>
            <Typography variant="body2" className="text-muted">This action cannot be undone. All information associated with this will be lost.</Typography> */}

        {/* <div className='mt-3'>
                <Grid container>
                  <Grid item xs={12}>
                    <TextField
                      variant="outlined"
                      label="Type Password"
                      fullWidth
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Grid>
                </Grid>
              </div> */}

        {/* {errorMessage && <Typography variant="body2" color="error">{errorMessage}</Typography>} */}

        {/* <div className='d-flex justify-content-end'>
              <Button onClick={() => { setOpenRecommendation(false); }} className="mx-2 mt-2">
                CANCEL
              </Button>
              <Button onClick={handleDeleteRecommendation} className="delete-button_configuration mt-2">
                DELETE
              </Button>
            </div>
          </div>
        </div>
      </Modal >  */}

        <Modal
          open={openRecommendation}
          onClose={() => setOpenRecommendation(false)}
          aria-labelledby="delete-recommendation-title"
          aria-describedby="delete-recommendation-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "600px", // Set a fixed width
              bgcolor: "white",
              boxShadow: 24,
              p: 3,
              borderRadius: 2,
              textAlign: "center",
            }}
          >
            <Typography
              id="delete-recommendation-title"
              variant="h6"
              fontWeight="bold"
            >
              Are you sure you want to delete this recommendation?
            </Typography>
            <Typography
              id="delete-recommendation-description"
              variant="body2"
              className="text-muted"
              mt={1}
            >
              This action cannot be undone. All information associated with{" "}
              <br />
              this will be lost.
            </Typography>

            <Box display="flex" justifyContent="center" gap={2} mt={3}>
              <Button
                onClick={() => setOpenRecommendation(false)}
                variant="outlined"
              >
                CANCEL
              </Button>
              <Button
                onClick={handleDeleteRecommendation}
                variant="contained"
                color="error"
              >
                DELETE
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={verifyOtpModal}
          onClose={() => {
            setVerifyOtpModal(false);
          }}
        >
          <Box
            sx={{
              p: 3,
              minWidth: "35%",
            }}
            className="modal-box-1"
          >
            <div>
              <div className="modal-heading">
                <div className="profile-modal-heading1">
                  Verify your {verifyOtpConfig.section}
                </div>
                <span className="span-center-align file-attach-icon-container">
                  <IconButton
                    color="rgb(0, 0, 0, 0.54)"
                    disableTouchRipple
                    onClick={() => setVerifyOtpModal(false)}
                  >
                    <CloseRoundedIcon />
                  </IconButton>
                </span>
              </div>
              <div className="modal-body">
                <div className="py-4">
                  {/* <TextField
                    fullWidth
                    value={emailOtp}
                    onChange={(e) => setEmailOtp(e.target.value)}
                    label="Enter Email OTP"
                    autoFocus
                    autoComplete={false}
                    autoCorrect={false}
                    disabled={isEmailVerified}
                    error={emailError}
                    helperText={emailError || ' '}
                  /> */}
                  <TextField
                    fullWidth
                    value={emailOtp}
                    onChange={(e) => setEmailOtp(e.target.value)}
                    label="Enter Email OTP"
                    autoFocus
                    autoComplete="off"
                    autoCorrect="off"
                    disabled={isEmailVerified}
                    // error={!!emailError} // Convert emailError to boolean
                    helperText={emailError || ""} // Show error message or a blank space
                  />
                  <div className="mt-12px">
                    <span className="helper-text-style">
                      Remaining Time: 00 :{" "}
                      {emailOtpSeconds < 10
                        ? `0${emailOtpSeconds}`
                        : emailOtpSeconds}
                      s
                    </span>
                  </div>

                  <div className="d-flex justify-content-between mt-4">
                    <span className="span-center-align">
                      <span className="helper-text-style me-2">
                        Didn't receive the mail?
                      </span>
                      <Button
                        sx={{ color: "#0044C6" }}
                        disabled={isEmailVerified}
                        onClick={verifyOtpConfig.sendOtpFunction}
                      >
                        Resend
                      </Button>
                    </span>
                    <Button
                      variant="contained"
                      sx={{ backgroundColor: "#0044C6" }}
                      disabled={isEmailVerified}
                      onClick={verifyEmailOtp}
                      className={`verify-button ${isEmailVerified ? "success-green" : ""
                        }`}
                      disableTouchRipple
                    >
                      {isEmailVerified ? "Verified" : "Verify"}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Modal>


        <Modal
          open={showActiveModal}
          onClose={() => {
            setShowActiveModal(false);
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "auto",
              bgcolor: "white",
              boxShadow: "0px 4px 4px 0px #00000040",
              p: 3,
              borderRadius: 2,
              minWidth: "35%",
              maxHeight: "80%",
              overflowY: "auto",
            }}
          >
            <div className="soc-modal-heading position-relative mb-4">

              <span className="span-center-align file-attach-icon-container">
                <IconButton
                  color="rgb(0, 0, 0, 0.54)"
                  onClick={() => {
                    setShowActiveModal(false);
                  }}
                >
                  <CloseRoundedIcon />
                </IconButton>
              </span>
            </div>

            <div className='d-flex flex-column align-items-center justify-content-center'>
              <img src={Secure} width="240" height="200" alt="image" />
              <p className='fw-normal'>Please activate your professional Card.</p>
            </div>
            <div className="mt-3 d-flex justify-content-center">

              <Button
                variant="contained"
                sx={{ backgroundColor: "#0044C6" }}
                onClick={handleOpenActivebutton}
              // disabled={
              //   !isEmailValid ||
              //   (!currentEducation.institute_email &&
              //     !currentEducation.adminEmailId)
              // }
              >
                Activate
              </Button>
            </div>
          </Box>
        </Modal>


        {chooseCategory &&
          <>
            <>
              <div className="lightbox-overlay">
                <div className="lightbox-content">
                  <>
                    <div className='d-flex align-items-center justify-content-between'>
                      <div className='d-flex align-items-center'>
                        {/* <IconButton onClick={() => { setchooseCategory(false) }}>
                          <ArrowBackIcon />
                        </IconButton> */}
                        <h6 className='heading-fav text-left mb-0 ms-1'>
                          Choose Category</h6>
                      </div>
                      {/* <button style={{ cursor: 'pointer' }} className="lightbox-close2" onClick={handleCloseVerifiedDialog}>×</button> */}
                      <IconButton
                        // onClick={handleCloseVerifiedDialog}
                        onClick={() => { setchooseCategory(false) }}
                        sx={{ margin: 0, padding: 0 }}>
                        <CloseRoundedIcon />
                      </IconButton>
                    </div>

                    <div className="mt-2 selectedOptions d-flex align-items-center justify-content-around">
                      {/* <div className={`mx-2 CardCategory flex-center flex-column `}
                        onClick={() => { setChooseCustomizeCategory(true); setchooseCategory(false) }}>
                        <div className="icon-outside-new"><PersonalCardIcon /></div>
                        <div className="myself">Customize</div>
                      </div> */}
                      {/* {(!cards.includes('Personal')) && (
                                            <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType == 'Personal' ? 'selected' : ''}`}
                                                onClick={() => handleCardTypeClick('Personal')}>
                                                <div className="icon-outside-new"><ProfessionalIcon /></div>
                                                <div className="myself">Personal</div>
                                            </div>
                                        )} */}
                      {(!cards?.includes('Professional')) && (
                        <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType == 'Professional' ? 'selected' : ''}`}
                          onClick={() => handleCardTypeClick('Professional')}>
                          <div className="icon-outside-new"><ProfessionalIcon /></div>
                          <div className="myself">Professional</div>
                        </div>
                      )}
                      {(!cards?.includes('Student')) && (
                        <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType === 'Student' ? 'selected' : ''}`}
                          onClick={() => handleCardTypeClick('Student')}>
                          <div className="icon-outside-new"><StudentIcon /></div>
                          <div className="myself">Student</div>
                        </div>
                      )}
                      {/* {(!cards.includes('GenZ')) && (
                                                <div className={`mx-2 CardCategory flex-center flex-column ${NewCardType === 'GenZ' ? 'selected' : ''}`}
                                                    onClick={() => handleCardTypeClick('GenZ')}>
                                                    <div className="icon-outside-new"><GenzIcon /></div>
                                                    <div className="myself">GenZ</div>
                                                </div>
                                            )} */}
                    </div>
                  </>
                </div>
              </div>
            </>
          </>
        }

        <CircleCropper
          open={openCropper}
          onClose={handleCropClose}
          onSave={handleSaveCroppedImage}
          file={selectedFile}
          selectedImage={selectedImage}
          aspectRatio={1}
          minDimension={100}
        />

        <RectangleCropper
          open={openRectCropper}
          onClose={handleRectCropperClose}
          onSave={handleSaveBgImage}
          file={selectedBgFile}
          selectedImage={selectedBgImage}
        />

        <ViewConnections
          open={connectionViewModal}
          onClose={() => setConnectionViewModal(false)}
          connectionCount={Personaldata?.connection_count || 0}
          connectionList={connectionList || []}
          setConnectionList={setConnectionList}
        />

        <ShareProfile
          open={shareProfileConfig.open}
          onClose={shareProfileConfig.onClose}
          qrCodeUrl={shareProfileConfig.qrCodeUrl}
          qrCodeLogo={shareProfileConfig.qrCodeLogo}
          showQr={shareProfileConfig.showQr}
          isDownload={shareProfileConfig.isDownload}
          profileType={shareProfileConfig.profileType}
          userName={shareProfileConfig.userName}
          handleSuccess={shareProfileConfig.handleSuccess}
          handleFailure={shareProfileConfig.handleFailure}
        />

        <InviteProfile
          open={openInviteProfile}
          setModalOpen={setOpenInviteProfile}
          handleSuccess={handleSuccess}
          handleFailure={handleFailure}
        />

        {/* <PreviewModal
          open={isPreviewOpen}
          file={previewFile}
          onClose={handleClosePreview}
        /> */}
      </div>
      {/* <ToastContainer position="bottom-left" toastClassName="email-toast-success" /> */}
    </>
  );
};

const SkillBox = styled(Box)({
  border: "1px solid #D9D9D9",
  height: "32px",
  borderRadius: "16px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "6px 12px",
  margin: "6px 6px 6px 0px",
  gap: "5px",
  fontSize: "14px",
  lineHeight: "20.02px",
});

function SkillItem({ label, isEdit, onAdd, skillsKey }) {
  return (
    <SkillBox>
      <div className="skill-item">{label}</div>
      {isEdit && (
        <IconButton
          color="color-lightred"
          onClick={() => onAdd(label, skillsKey)}
          className="flex-center delete-icon-skills"
        >
          <CancelIcon color="color-lightred" className="delete-icon-skills" />
        </IconButton>
      )}
    </SkillBox>
  );
}

function SkillItemForLightBox({ label, skillsKey, selectedSkills, onAdd }) {
  const isSkillSelected = selectedSkills?.includes(label);

  return (
    <SkillBox>
      <div>{label}</div>
      <IconButton
        color="#0044C6"
        onClick={() => onAdd(label, skillsKey)}
        className="flex-center"
        sx={{ p: 0 }}
        disableTouchRipple
      >
        {isSkillSelected ? (
          <CancelIcon
            className="delete-icon-skills"
            onClick={() => onAdd(label, skillsKey)}
          />
        ) : (
          <AddCircleRoundedIcon />
        )}
      </IconButton>
    </SkillBox>
  );
}

function SkillItemForNewAddItem({ selectedSkills, skillsKey, onAdd, label }) {
  const [inputValue, setInputValue] = useState("");

  return (
    <SkillBox>
      <TextField
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={label}
        variant="outlined"
        size="small"
        className="textfield-new-styles text-center"
        sx={{
          fontSize: "14px",
          lineHeight: "20.02px",
          "& .MuiOutlinedInput-input": {
            paddingLeft: 0,
          },
        }}
      />
      <IconButton
        color="#0044C6"
        onClick={() => {
          onAdd(inputValue, skillsKey);
          setInputValue("");
        }}
        className="flex-center"
        sx={{ p: 0 }}
      >
        <AddCircleRoundedIcon />
      </IconButton>
    </SkillBox>
  );
}

export function DeleteLightBox({
  LightBoxCloseFunction,
  Title,
  Label,
  DeleteFunction,
  clearFields,
}) {
  const handleCancel = () => {
    LightBoxCloseFunction(false);
    if (clearFields) {
      clearFields();
    }
  };
  return (
    <div className="lightbox-overlay">
      <div className="lightbox-content delete-lightbox">
        <>
          <div className="p-4">
            <div className="soc-modal-heading" style={{ position: "relative" }}>
              <div className="profile-modal-heading1">Delete {Title}</div>
              <span className="span-center-align file-attach-icon-container">
                <IconButton
                  color="rgb(0, 0, 0, 0.54)"
                  onClick={() => {
                    LightBoxCloseFunction(false);
                  }}
                >
                  <CloseRoundedIcon />
                </IconButton>
              </span>
            </div>
          </div>
          <Divider
            sx={{ backgroundColor: "#DDE0E6", height: "1px", opacity: 1 }}
          />
          <div className="p-4 pt-3">
            <span className="heading-fav-content text-left">{Label}</span>
            <div className="d-flex justify-content-end mt-4 gap-3">
              <Button
                variant="outlined"
                sx={{ color: "#0044C6" }}
                onClick={handleCancel}
              >
                CANCEL
              </Button>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#0044C6" }}
                onClick={DeleteFunction}
              >
                DELETE
              </Button>
            </div>
          </div>
        </>
      </div>
    </div>
  );
}

export const AlertDialog = ({
  open,
  onClose,
  dialogTitle = "ALERT",
  dialogMessage,
  cancelFn,
  continueFn,
  continueLabel = "Continue",
}) => {
  const handleCancel = () => {
    if (cancelFn) cancelFn();
    else onClose();
  };

  const handleContinue = () => {
    continueFn();
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
        className="lightbox-content delete-lightbox"
      >
        <>
          <div className="p-4">
            <div className="soc-modal-heading" style={{ position: "relative" }}>
              <div className="profile-modal-heading1">{dialogTitle}</div>
              <span className="span-center-align file-attach-icon-container">
                <IconButton color="rgb(0, 0, 0, 0.54)" onClick={onClose}>
                  <CloseRoundedIcon />
                </IconButton>
              </span>
            </div>
          </div>
          <Divider
            sx={{ backgroundColor: "#DDE0E6", height: "1px", opacity: 1 }}
          />
          <div className="p-4 pt-3">
            <span className="heading-fav-content text-left">
              {dialogMessage}
            </span>
            <div className="d-flex justify-content-end mt-4 gap-3">
              <Button
                variant="outlined"
                sx={{ color: "#0044C6" }}
                onClick={handleCancel}
              >
                CANCEL
              </Button>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#0044C6" }}
                onClick={handleContinue}
              >
                {continueLabel}
              </Button>
            </div>
          </div>
        </>
      </Box>
    </Modal>
  );
};

export default ProfessionalProfile;

export const transformProjectData = (data) => {
  return data?.map((item) => ({
    id: item.id,
    projectName: item.project_name,
    projectDescription: item.project_description,
    startMonth: item.start_month,
    startYear: item.start_year,
    endMonth: item.end_month,
    endYear: item.end_year,
    currentlyWorking: item.is_current_project,
    isPublic: Boolean(item.is_public ?? true),
    attachments:
      item.attachments?.map((attachment) => ({
        id: attachment.id,
        name: attachment.document_name,
        data: attachment.document_url,
        type: attachment.document_type,
        size: JSON.parse(attachment.document_meta)?.document_size || "Unknown",
        date: new Date(attachment.created_at).toLocaleDateString(), // Convert created_at to a readable date format
      })) || [], // Default to an empty array if there are no attachments
  }));
};